(() => {
const gemstoneSelectorTemplate = `<div class="custom-dropdown-wrapper"><div data-custom-dropdown-element class="dropdown-parent">
        <div data-option-selected class="option selected">
          <button 
              role="combobox"
              aria-haspopup="listbox"
              aria-labelledby="selected-text label-"
              aria-expanded="false"
              class="focusable-dropdown-button-main focusable-dropdown-button">
                <div class="swatch">
                    <img alt="" class="gemstone-image hidden" src="">
                </div>
                <div id="selected-text" class="title">Add a Gemstone</div>
              </button>
          </div>
         
          <span class="focusable-dropdown-button-span" aria-hidden="true"></span>
        </div>
        <ul role="listbox" aria-labelledby="label-{{componentName}}" data-options-list class="dropdown-options-list">      
        `

const gemstoneOptionTemplate = `<li role="option" data-value="{{value}}" data-gemstone-url="{{gemstoneUrl}}" data-gemstone-name="{{value}}" data-option-to-select data-option-index="{{forloopIndex}}" class="option">
    <button class="focusable-dropdown-button focusable-dropdown-button-list-item">
      <div class="swatch">
        <img alt="{{value}} gemstone swatch" class="gemstone-image" src="{{gemstoneUrl}}" loading="lazy">
      </div>
      <div class="title" id="option-title-1">{{value}}</div>
    </button>  
    </li>`

const gemstoneSelectorTemplateCloser = `</ul></div>`

const gemstoneComponentSelectorTemplate = `<div data-custom-dropdown-element class="dropdown-parent">
        <div data-option-selected class="option">
          <button 
              role="combobox"
              aria-haspopup="listbox"
              aria-labelledby="selected-text label-"
              aria-expanded="false"
              class="focusable-dropdown-button-main-component focusable-dropdown-button">
                <div class="swatch">
                    <img alt="" class="gemstone-image hidden" src="">
                </div>
                <div id="selected-text" class="title">Select One</div>
              </button>
          </div>
         
          <span class="focusable-dropdown-button-span" aria-hidden="true"></span>
        </div>
        <ul role="listbox" aria-labelledby="label-{{componentName}}" data-options-list class="dropdown-options-list">      
        `

const gemstoneComponentOptionTemplate = `<li role="option" data-word-pos="{{wordPos}}" data-radius="{{radius}}" data-start-angle="{{startAngle}}" data-value="{{value}}" data-gemstone-url="{{gemstoneUrl}}" data-position="{{sideName}}" data-canvas="{{canvas}}" data-gemstone-name="{{value}}" data-option-to-select data-option-index="{{forloopIndex}}" class="option">
    <button class="focusable-dropdown-button focusable-dropdown-button-component-list-item">
      <div class="swatch">
        <img alt="{{value}} gemstone swatch" class="gemstone-image" src="{{gemstoneUrl}}" loading="lazy">
      </div>
      <div class="title" id="option-title-1">{{value}}</div>
    </button>  
    </li>`

const gemstoneComponentSelectorTemplateCloser = `</ul>`  


    

document.addEventListener('DOMContentLoaded', () => {
    const personalizeDrawerManager = {
        debug: true,
        canvasSize: 400,
        productType: 'CORE',
        // used to store caret position in all editable divs
        selectionState: new WeakMap(),
        alignLabel: "alignment",
        symbolLabel: "add symbol",
        gemstoneLabel: "gemstone",
        inlineGemstoneLabel: "",
        characterCountStarterLabel: 'CHARACTER LIMIT',
        circlePendantTextLabel: "word {{number}}",
        circlePendantGemstoneLabel: "gemstone {{number}}",
        gemstoneInlineNameFormat: "stone",
        gemstoneUiData: {
            component: {type: 'dropdown', runType: 'auto'},
            inline: {type: 'dropdown', runType: 'auto'}
        },
        hasBackOnlyEngraving: false,
        // holds the personalization json for the product(s) located in personalize-drawer.liquid
        personalizationJSON: [],
        // holds the sort order of alignment buttons, case buttons, etc from theme settings stored in script tag in personalize-drawer.liquid
        sortOrderJSON: {},
        // holds the font size JSON located in personalization-font-script-tag.liquid
        fontSizing: {},
        // characters allowed to be typed or pasted into an editable div - special characters are in the metaobject now
        whiteListCharacters: [
            // letters
            "a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z",
            "A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z",

            // space
            " "
        ],
        whiteListNumbers: [
            "0","1","2","3","4","5","6","7","8","9",
        ],
        iconAndGemstoneSkuMap: {},
        skuCodes: {},
        bundleSkuData: {},
        // holds the character and space count of the icons/images
        characterCounts: {},
        // where the fabric canvas initializations are stored for access throughout the manager
        fabricMap: {},
        // where the fabric canvas required data is stored: props, imageurl,
        fabricCanvasData: {},
        // tracks in-flight font loads so Fabric measures text only after fonts settle
        fontLoadPromises: new Map(),
        uploadcareJpegOperation: "-/format/jpeg/",
        isSafariBrowser: function() {
            const ua = navigator.userAgent;
            return /Safari/i.test(ua) && !/Chrome|Chromium|CriOS|Edg|OPR/i.test(ua);
        },
        isIOS: function() {
            return (
                /iPad|iPhone|iPod/.test(navigator.userAgent) ||
                // iPadOS reports as Mac but has touch
                (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
            )
        },
        init: function () {
            if ( personalizeDrawerManager.debug ) {
                console.log('init personalize drawer')
            }
            personalizeDrawerManager.runSystem()
            personalizeDrawerManager.toggleErrorMessage( false )
        },
        reInit: function ( currentColor ) {
            if ( personalizeDrawerManager.debug ) {
                console.log('reinit personalize drawer with current color: ', currentColor)
            }
            personalizeDrawerManager.runSystem( currentColor )
            personalizeDrawerManager.toggleErrorMessage( false )
            personalizeDrawerManager.updateChainImage( currentColor );
        },
        runSystem: function (currentColor = null) {
            personalizeDrawerManager.addClickEventForFallbackATCButton();
            personalizeDrawerManager.getPersonalizationJson( currentColor );
        },
        // used to store caret position in all editable divs
        saveSelection: function ( editableDiv ) {
            const sel = window.getSelection();
            if ( !sel || sel.rangeCount === 0 ) return;

            const range = sel.getRangeAt(0);

            // Only save if selection is inside THIS specific div
            if ( !editableDiv.contains(range.startContainer) ) return;

            // Store a cloned range for this div only
            personalizeDrawerManager.selectionState.set( editableDiv, range.cloneRange() );
        },
        getSelectionForEditable: function ( editableDiv ) {
            const saved = this.selectionState.get(editableDiv);
            if ( !saved ) return null;

            // Ensure the saved range is still attached to the DOM under this div
            if ( !editableDiv.contains(saved.startContainer) ) {
                personalizeDrawerManager.selectionState.delete(editableDiv);
                return null;
            }

            return saved;
        },
        addClickEventForFallbackATCButton: function() {
            const fallbackATCButton = document.querySelector('.fallback-personalize-cta');
            if ( fallbackATCButton != null ) {
                fallbackATCButton.removeEventListener('click', personalizeDrawerManager.handleFallbackAddToCart);
                fallbackATCButton.addEventListener('click', personalizeDrawerManager.handleFallbackAddToCart);
            }
        },
        updateChainImage( currentColor ) {
            if ( currentColor == null ) return

            let currentColorLowercase = currentColor.toLowerCase();
            let color = 'yellow';
            if ( currentColorLowercase.includes('white') || currentColorLowercase.includes('silver') ) {
                color = 'white'
            } else if ( currentColorLowercase.includes('rose') ) {
                color = 'rose'
            }

            const personalizeDrawerElement = document.querySelector('personalize-drawer');
            if ( personalizeDrawerElement != null ) {

                const yellowImgUrl = personalizeDrawerElement.getAttribute('data-bundle-chain-yellow-url');
                const whiteImgUrl = personalizeDrawerElement.getAttribute('data-bundle-chain-white-url');
                const roseImgUrl = personalizeDrawerElement.getAttribute('data-bundle-chain-rose-url');

                const bundleChainImages = document.querySelectorAll('.bundle-chain-img');
                for ( let image of bundleChainImages ) {
                    if ( color == 'yellow' && yellowImgUrl != null && yellowImgUrl != "" ) {
                        image.setAttribute('src', yellowImgUrl)
                    } else if ( color == 'white' && whiteImgUrl != null && whiteImgUrl != "" ) {
                         image.setAttribute('src', whiteImgUrl)
                    } else if ( color == 'rose' && roseImgUrl != null && roseImgUrl != "" ) {
                         image.setAttribute('src', roseImgUrl)
                    }
                }
            }
        },
        handleFallbackAddToCart: function (e) {
            let items = [];
            const btn = e.currentTarget;
            
            let bundlePropertyString = '_bundle';
            let bundleNamePropertyString = '_bundle_name';
            let bundleLabelString = '_bundle_item_label';
            const addJSON = {
                'items': []
            };
           
            const bundleTimestamp = personalizeDrawerManager.createTimestamp();
            let productTitle = "";
            let totalTagsToAdd = 1;
            let productType = 'CORE';
            const drawerEl = document.querySelector('personalize-drawer');
            if ( drawerEl != null ) {
                productTitle = drawerEl.getAttribute('data-product-title');
                totalTagsToAdd = parseInt( drawerEl.getAttribute( 'data-product-amount' ) );
                productType = drawerEl.getAttribute('data-product-type');
            }

            let currentProductVariant = null;
            const actionWrapper = btn.closest('.fallback-personalization-action-wrapper');
            if ( actionWrapper != null ) {
                const attributeValue = actionWrapper.getAttribute('data-variant-id')
                if ( attributeValue != null ) {
                    currentProductVariant = attributeValue
                }
            }

            if ( currentProductVariant != null ) {
                let currentVariantImage = null;
                let currentVariantPrice = null;
                let currentVariantBaseSku = null;
                const currentProductData = drawerEl.querySelector('script.current-product');
                if ( currentProductData != null ) {
                    const currentProductJson = JSON.parse( currentProductData.innerHTML );
                    currentVariantImage = personalizeDrawerManager.findBundleImage( currentProductJson, currentProductVariant )
                    currentVariantPrice = personalizeDrawerManager.findVariantPrice( currentProductJson, currentProductVariant )
                    currentVariantBaseSku = personalizeDrawerManager.findVariantSku( currentProductJson , currentProductVariant );
                }

                if ( productType == 'CORE' ) {
                    for ( let i = 0; i <= totalTagsToAdd - 1; i++ ) {
                        const item = {
                            quantity: 1,
                            id: currentProductVariant,
                            properties: {}
                        };

                        let finalName = productTitle;
                        if ( totalTagsToAdd > 1 ) {
                            finalName = ` ${totalTagsToAdd} Names`;
                        }
                        
                        let uniqueLineLabel = `${productTitle} ${i+1}`;
                        item.properties[ bundlePropertyString ] = bundleTimestamp;
                        item.properties[ bundleNamePropertyString ] = finalName;
                        item.properties[ bundleLabelString ] = uniqueLineLabel;
                        item.properties['_type'] = productType;
                        item.properties['_parent_variant_id'] = 'gid://shopify/ProductVariant/' + currentProductVariant;

                        personalizeDrawerManager.createSkuProperty( item , currentVariantBaseSku );
                        
                        if ( currentVariantImage != null ) {
                            item.properties['_bundle_image'] = currentVariantImage
                        }

                        // leaving this here in clase they want to price line item to show
                        // if ( currentVariantPrice != null ) {
                        //     const formattedVariantPrice = new Intl.NumberFormat( 'en-US', {
                        //         style: 'currency',
                        //         currency: window.Shopify.currency.active
                        //     }).format( currentVariantPrice / 100 );
                        //     item.properties[ "Price" ] = formattedVariantPrice;
                        // }

                        items.push( item );
                    }
                } else {
                    const bundleProductData = drawerEl.querySelector('script.bundle-products');
                    const currentProductData = drawerEl.querySelector('script.current-product');
                    const selectedBundleVariants = [];

                    if ( bundleProductData && currentProductData ) {
                        let finalName = productTitle;

                        const bundleProducts = JSON.parse( bundleProductData.innerHTML );
                        const currentProduct = JSON.parse( currentProductData.innerHTML );
                        let selectedVariant = null;
                        for ( let v = 0; v < currentProduct.variants.length; v++ ) {
                            const _variant = currentProduct.variants[v];
                            if ( String(_variant.id) == String(currentProductVariant) ) {
                                selectedVariant = _variant; 
                                break;
                            }
                        }

                        const selectedOptionsForCurrentVariant = selectedVariant?.options;
                        for ( let i = 0; i < bundleProducts.length; i++ ) {
                            const currentProduct = bundleProducts[i]?.product;
                            const productVariants = currentProduct?.variants ?? [];

                            for ( let v = 0; v < productVariants.length; v++ ) {
                                const optionsSelected = productVariants[v].selectedOptions;
                                const listOfSelected = [];
                                for ( let o = 0; o < optionsSelected.length; o++ ) {
                                    const optionValue = optionsSelected[o].value;
                                    listOfSelected.push( optionValue );
                                }

                                if ( listOfSelected.length > 1 ) {
                                    if ( listOfSelected.toString()?.toLowerCase() == selectedOptionsForCurrentVariant.toString()?.toLowerCase() ) {
                                        productVariants[v]['product_id'] = currentProduct.legacyResourceId;
                                        selectedBundleVariants.push( productVariants[v] );
                                        break;
                                    }
                                } else {
                                    let foundMatch = false
                                    for ( let option of selectedOptionsForCurrentVariant ) {
                                        if ( option.toLowerCase() == listOfSelected.toString()?.toLowerCase() ) {
                                            foundMatch = true;
                                            break;
                                        }
                                    }
                                    if ( foundMatch ) {
                                        productVariants[v]['product_id'] = currentProduct.legacyResourceId;
                                        selectedBundleVariants.push( productVariants[v] );
                                    }
                                }
                            }
                        }

                        for ( let i = 0; i < selectedBundleVariants.length; i++ ) {
                            const bundleVariant = selectedBundleVariants[i];
                            const bundleProductId = parseInt( bundleVariant?.product_id ?? -1 );
                            const bundleVariantId = parseInt( bundleVariant?.legacyResourceId ?? -1 );
                            const bundleIdToFind = bundleVariantId + "-" + i;
                            const _item = {
                                quantity: 1,
                                id: bundleVariantId,
                                properties: {}
                            };

                            _item.properties[ bundlePropertyString ] = bundleTimestamp;
                            _item.properties[ bundleNamePropertyString ] = finalName;
                            _item.properties['_type'] = productType;
                            _item.properties['_parent_variant_id'] = 'gid://shopify/ProductVariant/' + currentProductVariant;

                            const skuData = personalizeDrawerManager.bundleSkuData;
                            const sku = skuData[ bundleProductId ][ bundleVariantId ];
                            if ( sku != null ) {
                                personalizeDrawerManager.createSkuProperty( _item , sku );
                            }

                            if ( currentVariantImage != null ) {
                                _item.properties['_bundle_image'] = currentVariantImage
                            }

                            if ( selectedVariant != null ) {
                                _item.properties[ '_expected_base_bundle_price' ] = selectedVariant.price;
                            }

                            // const formattedVariantPrice = new Intl.NumberFormat( 'en-US', {
                            //         style: 'currency',
                            //         currency: window.Shopify.currency.active
                            //     }).format( chainVariant.price / 100 );
                            //     item.properties[ "Price" ] = formattedChainPrice;
                            //     item.properties[ "_price" ] = chainVariant.price;

                            items.push( _item );
                        }
                    }
                }

                const chainVariantId = btn.getAttribute('data-chain-variant-id');
                if ( chainVariantId != null ) {
                    const chainPickerEl = document.querySelector('chain-picker');
                    if ( chainPickerEl != null ) {
                        const selectedChainVariantId = chainPickerEl.selectedChainVariantId;
                        const selectedChainProductId = chainPickerEl.selectedChainProduct;
                        const chains = chainPickerEl.chains;
                        let chain = null;
                        for ( let c = 0; c < chains.length; c++ ) {
                            if ( chains[c].id == selectedChainProductId ) {
                                chain = chains[c];
                                break;
                            }   
                        }
    
                        if ( selectedChainVariantId != -1 ) {
                            const item = {
                                'id': chainVariantId,
                                'quantity': 1,
                                'properties': {}
                            };
    
                            let finalName = productTitle;
                            if ( totalTagsToAdd > 1 ) {
                                finalName += ` ${totalTagsToAdd} Names`;
                            }
    
                            item.properties[ bundlePropertyString ] = bundleTimestamp;
                            item.properties[ bundleNamePropertyString ] = finalName;
                            item.properties[ bundleLabelString ] = "chain";
                            item.properties['_type'] = "ADDON";
    
                            let chainVariant = null;
                            for ( let v = 0; v < chain.variants.length; v++ ) {
                                if ( chain.variants[v].id == chainVariantId ) {
                                    chainVariant = chain.variants[v];
                                    break;
                                }
                            }
    
                            if ( chainVariant != null ) {
                                const formattedChainPrice = new Intl.NumberFormat( 'en-US', {
                                    style: 'currency',
                                    currency: window.Shopify.currency.active
                                }).format( chainVariant.price / 100 );
                                item.properties[ "Price" ] = formattedChainPrice;
                                item.properties[ "_price" ] = chainVariant.price;
                            }
    
                            items.push( item );
                        }
                    }
                    
                }
            } 

            items = items.reverse();
            addJSON.items = items;

            if ( personalizeDrawerManager.debug ) {
                console.log('Add these items to the cart', addJSON)
            }

            // Popup Alert on PDP — show popup then add to cart after popup is closed
            if ( typeof( window?.showPopup ) != 'undefined' ) {
                window.showPopup();

                // Listen for pdp:accepted event dispatched in the popup-alerts snippet
                document.addEventListener('pdp:accepted', () => {
                    personalizeDrawerManager.addItemsToCart( addJSON );
                }, { once: true });
            } else {
                // No popup system — add directly to cart
                personalizeDrawerManager.addItemsToCart( addJSON );
            }
          
        },
        // add click event to atc button and run an initial validation check on form
        addFormValidationAndATCAbility: function () {
            const atcButton = document.querySelector('.personalize-atc');

            if ( atcButton != null ) {
                atcButton.removeEventListener('click', personalizeDrawerManager.handleAddToCart);
                atcButton.addEventListener('click', personalizeDrawerManager.handleAddToCart);

                personalizeDrawerManager.validateFormAndReturnFormData( atcButton )
            }
        },
        // checks that all required fields have a value before atc button is enabled
        validateFormAndReturnFormData: function ( atcButton = null ) {
            const requiredOptionWrapper = document.querySelector('.option-wrapper[data-option="front"][data-personalized-optional="false"]');
            const optionalOptionWrappers = document.querySelectorAll('.option-wrapper[data-option="back"], .option-wrapper[data-option="front"][data-personalized-optional="true"]');

            // need to get all of the variant ids of the products in the form
            let variantIds = []
            if ( atcButton != null ) {
                variantIds = atcButton.getAttribute('data-bundle-subproduct-variant-ids').split(",")
            }

            const lineItemData = {};
            let allRequiredFieldsHaveText = true;
            let allGemstoneHaveBeenSelected = true;
            let optionalFieldsHaveText = false;

            if (requiredOptionWrapper) {
                // need to seperate the line items into products
                allRequiredFieldsHaveText = personalizeDrawerManager.processInputFields(requiredOptionWrapper, lineItemData, variantIds, true, "front");
                allGemstoneHaveBeenSelected = personalizeDrawerManager.processGemstones(requiredOptionWrapper, lineItemData, variantIds);
                personalizeDrawerManager.processImageUploads(requiredOptionWrapper, lineItemData, variantIds)
                optionalFieldsHaveText = true;
            }

            for ( const wrapper of optionalOptionWrappers ) {
                const sideName = wrapper.getAttribute("data-option");
                const inputFields = wrapper.querySelectorAll('.input-field');
                const uploadInputs = wrapper.querySelectorAll('.image_upload');

                if ( !optionalFieldsHaveText ) {
                    const hasTextInputValue = Array.from(inputFields).some((field) => {
                        const textContent = field.textContent.replace(/\u00A0/g, " ").trim();
                        return textContent.length > 0 || field.querySelector('img') != null;
                    });

                    const hasSelectedUpload = Array.from(uploadInputs).some((input) => {
                        const uploadedImageUrl = input.dataset.uploadedImageUrl || "";
                        return uploadedImageUrl != "";
                    });
                    optionalFieldsHaveText = hasTextInputValue || hasSelectedUpload;
                }

                personalizeDrawerManager.processInputFields(wrapper, lineItemData, variantIds, false, sideName);
                personalizeDrawerManager.processImageUploads(wrapper, lineItemData, variantIds)
            }

            


            const button = atcButton ?? document.querySelector('.personalize-atc');
            if ( button != null ) {
                if ( allRequiredFieldsHaveText && allGemstoneHaveBeenSelected && optionalFieldsHaveText ) {
                    button.removeAttribute("disabled");
                } else {
                    button.setAttribute("disabled", true);
                }
            }

            return lineItemData;
        },
        // get all of the gemstone selectors and their values for each product in the form.  This function serves 2 purposes: return true/false if all gemstone selectors have been selected and build the line item property data for gemstone for ATC 
        processGemstones: function ( wrapper, lineItemData, variantIds = [], ) {
            let selectedGemstoneCount = 0;
            let gemstoneSelectorCount = 0;

            if ( variantIds.length > 0 ) { 
                for ( let vId of variantIds ) {
                    const productWrapper = wrapper.querySelector(`.product-wrapper[data-variant-id="${vId}"]`);

                    if ( productWrapper != null ) {
                        let gemstoneSelectors = productWrapper.querySelectorAll('.embeded-gemstone-container');

                        if ( gemstoneSelectors.length === 0 ) {
                            continue
                        }
                        
                        gemstoneSelectorCount += gemstoneSelectors.length;

                        if ( lineItemData[vId] == undefined ) {
                            lineItemData[vId] = {}
                        }

                        let counter = 2;
                        for (let selector of gemstoneSelectors) {
                            const value = selector.querySelector('#selected-text')?.innerText || "";
                            if ( value != null && value != "" && value != "Select One" ) {
                                let isCirclePendant = false;
                                let fieldNumber = "";
                                const parentDiv = selector.closest('.circle-pendant-form-wrapper');
                                if ( parentDiv != null ) {
                                    isCirclePendant = true;

                                    const container = selector.closest('.embeded-gemstone-container');
                                    if ( container != null ) {
                                        let label = container.querySelector('label');

                                        if ( label != null ) {
                                            let innerText = label.innerText.trim();
                                            if ( innerText.length >= 2 ) {
                                                fieldNumber = innerText[innerText.length - 2] // the field number is before a colon
                                            }
                                        }
                                    }
                                }
                                selectedGemstoneCount++;
                                let lineName = 'Stone';
                                if ( isCirclePendant ) {
                                    lineName += ` ${fieldNumber}`
                                }
                                let lineValue = value;
                                // we have a failsafe for gemstone componenets if more than 1 are allowed on the product.  The line item property will be appended with a counter to keep track of the gemstone to be added
                                if ( lineItemData[vId][lineName] != undefined ) {
                                    lineName = lineName + "-" + counter;
                                    counter++
                                }
                                lineItemData[vId][lineName] = lineValue;
                            }
                        }
                    }
                }
            } else {
                const gemstoneSelectors = wrapper.querySelectorAll('.embeded-gemstone-container');
                if ( gemstoneSelectors.length === 0 ) {
                    return true
                } 

                gemstoneSelectorCount = gemstoneSelectors.length

                let counter = 2;
                for (let selector of gemstoneSelectors) {
                    const value = selector.querySelector('#selected-text')?.innerText || "";
                    if ( value != null && value != "" && value != "Select One" ) {
                        let isCirclePendant = false;
                                let fieldNumber = "";
                                const parentDiv = selector.closest('.circle-pendant-form-wrapper');
                                if ( parentDiv != null ) {
                                    isCirclePendant = true;

                                    const container = selector.closest('.embeded-gemstone-container');
                                    if ( container != null ) {
                                        let label = container.querySelector('label');

                                        if ( label != null ) {
                                            let innerText = label.innerText.trim();
                                            if ( innerText.length >= 2 ) {
                                                fieldNumber = innerText[innerText.length - 2] // the field number is before a colon
                                            }
                                        }
                                    }
                                }
                        selectedGemstoneCount++;

                        let lineName = 'Stone';
                        if ( isCirclePendant ) {
                            lineName += ` ${fieldNumber}`
                        }
                        let lineValue = value;

                        if ( lineItemData.variant == undefined ) {
                            lineItemData.variant = {}
                        }

                        if ( lineItemData.variant[lineName] != undefined ) {
                            lineName = lineName + "-" + counter;
                            counter++
                        }
                        lineItemData.variant[lineName] = lineValue;
                    }
                }
            }
            

            return selectedGemstoneCount === gemstoneSelectorCount;
            
        },
        // get all of the input fields and their values for each product in the form.  This function serves 2 purposes: return true/false if all gemstone selectors have been selected and build the line item property data for gemstone for ATC 
        processInputFields: function ( wrapper, lineItemData, variantIds = [], isRequired = false, sideName = null ) {
            let fieldWithTextCount = 0;
            let inputFieldsCount = 0;

            if ( variantIds.length > 1 ) { 
                for ( let vId of variantIds ) {
                    const productWrappers = wrapper.querySelectorAll(`.product-wrapper[data-variant-id="${vId}"]`);
                    for ( let productWrapper of productWrappers ) {
                        const inputFields = productWrapper.querySelectorAll('.input-field')

                        inputFieldsCount += inputFields.length

                        let key = vId
                        let counter = 2;

                        if ( lineItemData[key] == undefined ) {
                            lineItemData[key] = {}
                        }

                        let used = 0;
                        for ( let field of inputFields ) {
                            if ( field.innerHTML.length > 0 ) {
                                fieldWithTextCount++;
                                let divCase = personalizeDrawerManager.fetchCurrentCase(field)
                                
                                let lineItemName = field.getAttribute('data-label');
                                let lineItemValue = personalizeDrawerManager.convertEditableHTML(field.innerHTML, divCase);

                                // we have a failsafe for text componenets with the same name.  The line item property will be appended with a counter to keep track of the text to be added
                                if ( lineItemData[key][lineItemName] != undefined ) {
                                    lineItemName += `_${counter}`;
                                    counter++
                                }

                                lineItemData[key][`${lineItemName}`] = lineItemValue;

                                let optionWrapper = field.closest('.text-field-and-option-wrapper');
                                
                                let hasOnlyOneTextCaseOption = false;

                                if ( optionWrapper != null ) {
                                    let caseContainer = optionWrapper.querySelector('.case-container');
                                    if ( caseContainer != null && caseContainer.children.length == 0 ) {
                                        hasOnlyOneTextCaseOption = true;
                                    }
                                }

                                // when we have a radius, we only want to attach the upper / lower as a prop 1 time
                                const radius = field.getAttribute( "data-radius" );
                                if ( radius == null ) {
                                    lineItemData[key][`${ hasOnlyOneTextCaseOption ? "_" : "" }${lineItemName} - Upper/Lower Limits`] = divCase;
                                } else {
                                    if ( used == 0 ) {
                                        lineItemData[key][`${ hasOnlyOneTextCaseOption ? "_" : "" }${lineItemName} - Upper/Lower Limits`] = divCase;
                                    }
                                }

                                let alignment = field.getAttribute('data-font-align');
                                let hasOnlyOneAlignmentOption = false;
                                
                                if ( optionWrapper != null ) {
                                    let alignmentContainer = optionWrapper.querySelector('.alignment-container');
                                    if ( alignmentContainer != null && alignmentContainer.children.length == 0 ) {
                                        hasOnlyOneAlignmentOption = true;
                                    }
                                }
                                
                                lineItemData[key][`${ hasOnlyOneAlignmentOption ? "_" : "" }${lineItemName} - Text Alignment`] = alignment;

                                used++;
                            }
                        }
                    }
                }
            } else {
                const inputFields = wrapper.querySelectorAll('.input-field');
                inputFieldsCount += inputFields.length

                let counter = 2;
                let used = 0;
                for ( let field of inputFields ) {
                    if ( field.innerHTML.length > 0 ) {
                        fieldWithTextCount++;
                        let divCase = personalizeDrawerManager.fetchCurrentCase(field)
                        let lineItemName = field.getAttribute('data-label');
                        let lineItemValue = personalizeDrawerManager.convertEditableHTML(field.innerHTML, divCase);

                        if ( lineItemData.variant == undefined ) {
                            lineItemData.variant = {}
                        }

                        // we have a failsafe for text componenets with the same name.  The line item property will be appended with a counter to keep track of the text to be added
                        if ( lineItemData.variant[lineItemName] != undefined ) {
                            lineItemName += `_${counter}`;
                            counter++
                        }

                        lineItemData.variant[`${lineItemName}`] = lineItemValue;

                        let optionWrapper = field.closest('.text-field-and-option-wrapper');
                        
                        let hasOnlyOneTextCaseOption = false;

                        if ( optionWrapper != null ) {
                            let caseContainer = optionWrapper.querySelector('.case-container');
                            if ( caseContainer != null && caseContainer.children.length == 0 ) {
                                hasOnlyOneTextCaseOption = true;
                            }
                        }

                        // when we have a radius, we only want to attach the upper / lower as a prop 1 time
                        const radius = field.getAttribute( "data-radius" );
                        if ( radius == null ) {
                            lineItemData.variant[`${ hasOnlyOneTextCaseOption ? "_" : "" }${lineItemName} - Upper/Lower Limits`] = divCase;
                        } else {
                            if ( used == 0 ) {
                                lineItemData.variant[`${ hasOnlyOneTextCaseOption ? "_" : "" }${lineItemName} - Upper/Lower Limits`] = divCase;
                            }
                        }

                        let alignment = field.getAttribute('data-font-align');
                        let hasOnlyOneAlignmentOption = false;
                        
                        if ( optionWrapper != null ) {
                            let alignmentContainer = optionWrapper.querySelector('.alignment-container');
                            if ( alignmentContainer != null && alignmentContainer.children.length == 0 ) {
                                hasOnlyOneAlignmentOption = true;
                            }
                        }
                        
                        lineItemData.variant[`${ hasOnlyOneAlignmentOption ? "_" : "" }${lineItemName} - Text Alignment`] = alignment;

                        used++;
                    }
                }

            }
            
            return fieldWithTextCount === inputFieldsCount
        },
        processImageUploads: function ( wrapper, lineItemData, variantIds = [] ) {
            const setImageProperty = function ( key, sideName, label, url ) {
                if ( lineItemData[key] == undefined ) {
                    lineItemData[key] = {};
                }

                const formattedSideName = sideName ? sideName.charAt(0).toUpperCase() + sideName.slice(1) : "Image";
                const propertyLabel = label ? label.trim() : "Image";

                // to show prop in cart, remove "_"
                const baseName = `_${formattedSideName} ${propertyLabel}`;
                let lineName = baseName;
                let counter = 2;

                while ( lineItemData[key][lineName] != undefined ) {
                    lineName = `${baseName} ${counter}`;
                    counter++;
                }

                lineItemData[key][lineName] = url;
            };

            const processProductWrapper = function ( productWrapper, key ) {
                if ( productWrapper == null ) { 
                    return;
                }

                const uploadInputs = productWrapper.querySelectorAll( '.image_upload[data-uploaded-image-url]' );

                for ( const input of uploadInputs ) {
                    const uploadedImageUrl = input.dataset.uploadedImageUrl || "";

                    if ( uploadedImageUrl != "" ) {
                        setImageProperty( key, input.getAttribute( "data-side-name" ), input.getAttribute( "data-property-label" ), uploadedImageUrl );
                    }
                }
            };

            if ( variantIds.length > 1 ) {
                for ( let vId of variantIds ) {
                    const productWrappers = wrapper.querySelectorAll(`.product-wrapper[data-variant-id="${vId}"]`);
                    for ( const productWrapper of productWrappers ) {
                        processProductWrapper( productWrapper, vId );
                    }
                }
            } else {
                const productWrappers = wrapper.querySelectorAll('.product-wrapper');
                for ( const productWrapper of productWrappers ) {
                    processProductWrapper( productWrapper, 'variant' );
                }
            }
        },
        ensureUploadcareComponents: async function () {
            if ( !document.querySelector('.image_upload[data-uploadcare-context]') ) {
                return true;
            }

            if ( typeof customElements == 'undefined' ) {
                return false;
            }

            try {
                if ( window.uploadcareFileUploaderReady != null ) {
                    await window.uploadcareFileUploaderReady;
                }
                await customElements.whenDefined('uc-upload-ctx-provider');
                return true;
            } catch ( error ) {
                return false;
            }
        },
        normalizeUploadcareCdnUrl: function ( cdnUrl ) {
            if ( cdnUrl == null || cdnUrl == "" ) return "";

            const cleanUrl = cdnUrl.split('?')[0];
            if ( cleanUrl.includes(personalizeDrawerManager.uploadcareJpegOperation) ) {
                return cleanUrl;
            }

            const separator = cleanUrl.endsWith('/') ? '' : '/';
            const normalizedUrl = `${cleanUrl}${separator}${personalizeDrawerManager.uploadcareJpegOperation}`;
            return normalizedUrl;
        },
        isAllowedUploadcareImageFile: function ( file ) {
            const fileName = file?.name?.toLowerCase() || "";
            const mimeType = file?.type?.toLowerCase() || "";
            const allowedExtensions = [".jpg", ".jpeg", ".heic", ".heif", ".png"];
            const allowedMimeTypes = ["image/jpeg", "image/heic", "image/heif", "image/png"];

            return allowedExtensions.some((extension) => fileName.endsWith(extension)) || allowedMimeTypes.includes(mimeType);
        },
        uploadSingleImageInput: function ( input ) {
            return new Promise((resolve, reject) => {
                const files = Array.from(input.files || []);
                input.removeAttribute('data-uploadcare-cdn-urls');

                if ( files.length === 0 ) {
                    resolve([]);
                    return;
                }

                const hasUnsupportedFile = files.some((file) => !personalizeDrawerManager.isAllowedUploadcareImageFile(file));
                if ( hasUnsupportedFile ) {
                    reject(new Error('Only JPEG and HEIC images are allowed.'));
                    return;
                }

                const ctxName = input.getAttribute('data-uploadcare-context');
                const provider = document.querySelector(`uc-upload-ctx-provider[ctx-name="${ctxName}"]`);
                if ( provider == null || typeof provider.getAPI != 'function' ) {
                    reject(new Error(`Uploadcare provider missing for ${ctxName}`));
                    return;
                }

                const api = provider.getAPI();
                
                api.removeAllFiles();

                for ( const file of files ) {
                    api.addFileFromObject(file, { fileName: file.name });
                }

                let settled = false;
                let unsubscribeSuccess = null;
                let unsubscribeFailed = null;
                let unsubscribeChange = null;
                let pollInterval = null;
                let timeoutId = null;

                const cleanup = function () {
                    provider.removeEventListener('common-upload-success', handleSuccess);
                    provider.removeEventListener('common-upload-failed', handleFailed);
                    provider.removeEventListener('change', handleChange);

                    if ( typeof unsubscribeSuccess == 'function' ) unsubscribeSuccess();
                    if ( typeof unsubscribeFailed == 'function' ) unsubscribeFailed();
                    if ( typeof unsubscribeChange == 'function' ) unsubscribeChange();
                    if ( pollInterval != null ) window.clearInterval(pollInterval);
                    if ( timeoutId != null ) window.clearTimeout(timeoutId);
                };

                const complete = function ( callback ) {
                    if ( settled ) return;
                    settled = true;
                    cleanup();
                    callback();
                };

                const getUploadedUrls = function () {
                    const state = api.getOutputCollectionState();
                    
                    return Array.from(state.successEntries || [])
                        .map((entry) => personalizeDrawerManager.normalizeUploadcareCdnUrl(entry.cdnUrl))
                        .filter((url) => url != null && url != "");
                };

                const summarizeState = function () {
                    const state = api.getOutputCollectionState();
                    return {
                        status: state.status,
                        totalCount: state.totalCount,
                        successCount: state.successCount,
                        failedCount: state.failedCount,
                        uploadingCount: state.uploadingCount,
                        idleCount: state.idleEntries?.length || 0,
                        errors: state.errors,
                        entries: Array.from(state.allEntries || []).map((entry) => ({
                            name: entry.name,
                            status: entry.status,
                            isUploading: entry.isUploading,
                            isSuccess: entry.isSuccess,
                            isFailed: entry.isFailed,
                            uuid: entry.uuid,
                            cdnUrl: entry.cdnUrl,
                            errors: entry.errors
                        }))
                    };
                };

                const resolveFromCurrentStateIfFinished = function (source) {
                    if ( settled ) return;
                    const state = api.getOutputCollectionState();

                    if ( state.failedCount > 0 || state.status == 'failed' ) {
                        complete(() => reject(new Error('Image upload failed')));
                        return;
                    }

                    if ( state.totalCount > 0 && state.successCount === state.totalCount ) {
                        
                        complete(() => {
                            const urls = getUploadedUrls();
                            
                            resolve(urls);
                        });
                    }
                };

                const handleSuccess = function () {
                    complete(() => {
                        const urls = getUploadedUrls();
                        resolve(urls);
                    });
                };

                const handleFailed = function () {
                    const state = api.getOutputCollectionState();
                    
                    complete(() => reject(new Error('Image upload failed')));
                };

                const handleChange = function () {
                    resolveFromCurrentStateIfFinished('change event');
                };

                provider.addEventListener('common-upload-success', handleSuccess);
                provider.addEventListener('common-upload-failed', handleFailed);
                provider.addEventListener('change', handleChange);

                if ( typeof api.on == 'function' ) {
                    unsubscribeSuccess = api.on('common-upload-success', handleSuccess);
                    unsubscribeFailed = api.on('common-upload-failed', handleFailed);
                    unsubscribeChange = api.on('change', handleChange);
                }

                api.uploadAll();

                pollInterval = window.setInterval(() => {
                    resolveFromCurrentStateIfFinished('polling');
                }, 1000);

                timeoutId = window.setTimeout(() => {
                    if ( settled ) return;
                    complete(() => reject(new Error('Image upload timed out')));
                }, 45000);
            });
        },
        processImageUploadsForAddToCart: async function () {
            let allUploadsComplete = true;

            const uploadInputs = document.querySelectorAll(".image_upload");
            for ( const input of uploadInputs ) {
                const uploadedImageUrl = input.dataset.uploadedImageUrl || "";

                const contextName = input.getAttribute("ctx-name") || "";

                if ( contextName == "" ) {
                    continue;
                }

                const provider = document.querySelector( `uc-upload-ctx-provider[ctx-name="${contextName}"]`);

                if ( provider == null || typeof provider.getAPI != "function" ) {
                    allUploadsComplete = false;
                    break;
                }

                const api = provider.getAPI();
                const state = api.getOutputCollectionState();

                if ( state.totalCount > 0 ) {
                    const uploadIsComplete = state.successCount === state.totalCount && state.failedCount === 0 && uploadedImageUrl != "";

                    if ( !uploadIsComplete ) {
                        allUploadsComplete = false;
                        break;
                    }
                }
            }

            return allUploadsComplete;
        },
        // update text from div to replace images with codes
        convertEditableHTML: function ( innerHtml, textCase ) {

            // Create a temporary DOM element to parse the HTML string
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = innerHtml;

            let result = "";

            tempDiv.childNodes.forEach(node => {
                // Plain text nodes (fallback for browsers that don't wrap in spans)
                if (node.nodeType === Node.TEXT_NODE) {
                    let text = node.textContent.replace(/\u00A0/g, " ");
                    if (textCase === 'lowercase') {
                        text = text.toLowerCase();
                    } else if (textCase === 'uppercase') {
                        text = text.toUpperCase();
                    }
                    result += text;
                }
                // Spans 
                else if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'SPAN' ) {
                    let letter = node.textContent.replace(/\u00A0/g, " ");
                    if ( textCase == 'lowercase' ) {
                        letter = letter.toLowerCase();
                    } else if ( textCase == 'uppercase' ) {
                        letter = letter.toUpperCase()
                    }
                    // Replace non-breaking spaces with regular spaces
                    result += letter

                // Gemstone / special-character images
                } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "IMG") {
                    const alt = node.getAttribute("alt") || "";

                    if ( alt.toLowerCase() == 'foot' || alt.toLowerCase() == "custom heart" ) {
                        if ( personalizeDrawerManager.iconAndGemstoneSkuMap[alt] ) {
                            result = `[${personalizeDrawerManager.iconAndGemstoneSkuMap[alt]}]`;
                        }
                    }
                    if ( personalizeDrawerManager.gemstoneInlineNameFormat == 'full' ) {
                        result += `[${alt}]`;
                    } else if ( personalizeDrawerManager.gemstoneInlineNameFormat == 'stone' ) {
                        const altParts = alt.toLowerCase().split('-');
                        if ( altParts.length > 1 ) {
                            result += `[${altParts[1].trim()}]`
                        } else {
                            result += `[${alt}]`
                        }
                    } else if ( personalizeDrawerManager.gemstoneInlineNameFormat == 'sku' ) {
                        if ( personalizeDrawerManager.iconAndGemstoneSkuMap[alt] ) {
                            result += personalizeDrawerManager.iconAndGemstoneSkuMap[alt].toUpperCase();
                        } else {
                            // fallback to full name if sku is missing
                            result += `[${alt}]`;
                        }
                    }
                    
                }
            });

            return result;
        },
        // this handles variant changes, we need to update the ids on the button and the product-wrapper divs
        updateVariantsOnATCButtonAndProductWrapper: function ( selectedBundleVariants, btn ) {
            let newVariantId = []
            let oldVariantId = []
            for ( let i = 0; i < selectedBundleVariants.length; i++ ) {
                const bundleVariant = selectedBundleVariants[i];
                const bundleVariantId = parseInt( bundleVariant?.legacyResourceId ?? -1 );
                newVariantId.push( `${bundleVariantId}-${i}` )
            }

            if ( btn != null && newVariantId.length > 0) {
                let attribute = btn.getAttribute('data-bundle-subproduct-variant-ids')
                oldVariantId = attribute ? attribute.split(',') : []
                btn.setAttribute('data-bundle-subproduct-variant-ids', newVariantId.toString())
            }

            if ( oldVariantId.length > 0 ) {
                for ( let i = 0; i < oldVariantId.length; i++ ) {
                    const id = oldVariantId[i]
                    const productWrappers = document.querySelectorAll(`.product-wrapper[data-variant-id="${id}"]`);

                    for ( const wrapper of productWrappers ) {
                        wrapper.setAttribute('data-variant-id', newVariantId[i])
                    }
                }
            }
        },
        findVariantPrice: function ( currentProductJson, variantId ) {
            let currentPrice = null;
            for ( let v = 0; v < currentProductJson.variants.length; v++ ) {
                const _variant = currentProductJson.variants[v];
                if ( _variant.id == variantId ) {
                    currentPrice = _variant.price
                    break;
                }
            }

            return currentPrice
        },
        findVariantSku: function ( currentProductJson, variantId ) {
            let sku = null;
            for ( let v = 0; v < currentProductJson.variants.length; v++ ) {
                const _variant = currentProductJson.variants[v];
                if ( _variant.id == variantId ) {
                    sku = _variant.sku
                    break;
                }
            }

            return sku;
        },
        findBundleImage: function ( currentProductJson, variantId ) {
            let currentVariantImage = null;
            let foundImage = false;
            for ( let v = 0; v < currentProductJson.variants.length; v++ ) {
                const _variant = currentProductJson.variants[v];
                if ( _variant.id == variantId ) {
                    if ( _variant.featured_image != null ) {
                        currentVariantImage = _variant.featured_image.src;
                        foundImage = true;
                    }
                    break;
                }
            }

            if ( !foundImage ) {
                currentVariantImage = currentProductJson.featured_image;
            }

            return currentVariantImage
        },
        calculateDiscountRate: function ( selectedBundleVariants, price ) {
            let discountRate = null;

            if ( price == null ) return null

            let subproductPriceTotal = 0;
            for ( let i = 0; i < selectedBundleVariants.length; i++ ) {
                const bundleVariant = selectedBundleVariants[i];
                if ( bundleVariant.price ) {
                    subproductPriceTotal += bundleVariant.price
                }
            }
            return discountRate
        },
        base64ToBlob: function ( base64 ) {
            const byteChars = atob(base64.split(';')[1].replace('base64,', ''));
            let byteNumbers = new Array(byteChars.length);
            for (let byteCounter = 0; byteCounter < byteChars.length; byteCounter++) {
                byteNumbers[byteCounter] = byteChars.charCodeAt(byteCounter);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {type: base64.split(';')[0].split(':')[1]});

            return blob;
        },
        toggleSpinner: function ( showSpinner ) {
            const personalizeATCButton = document.querySelector('.personalize-atc');
            if ( personalizeATCButton != null ) {
                const textSpan = personalizeATCButton.querySelector('.atc-text');
                const spinnerSpan = personalizeATCButton.querySelector('.atc-spinner-wrapper'); 

                if ( textSpan != null && spinnerSpan != null ) {
                    if ( showSpinner ) {
                        if ( spinnerSpan.classList.contains('hidden') ) {
                            spinnerSpan.classList.remove('hidden');
                        }
                        if ( !textSpan.classList.contains('hidden') ) {
                            textSpan.classList.add('hidden')
                        }
                    } else {
                        if ( textSpan.classList.contains('hidden') ) {
                            textSpan.classList.remove('hidden');
                        }
                        if ( !spinnerSpan.classList.contains('hidden') ) {
                            spinnerSpan.classList.add('hidden')
                        }
                    }
                }
            }
        },
        toggleErrorMessage: function ( showMessage ) {
            const errorMessage = document.querySelector('.error-message');
                if ( errorMessage != null ) {
                    if ( showMessage && errorMessage.classList.contains('hidden')) {
                        errorMessage.classList.remove('hidden')
                    } else if ( !showMessage && !errorMessage.classList.contains('hidden') ) {
                        errorMessage.classList.add('hidden')
                    }
                }
        },
        handleAddToCart: async function ( e ) {      
            personalizeDrawerManager.toggleSpinner(true)
            const btn = e.currentTarget;
            // varaintId is the id of the product on the PDP.  
            let variantId = btn.getAttribute('data-variant-id');
            let bundleSubproductsVariantId = btn.getAttribute('data-bundle-subproduct-variant-ids');
            const urlParams = new URLSearchParams(window.location.search);
            if ( urlParams.has('variant') ) {
                variantId = urlParams.get('variant');
            }

            const drawerEl = document.querySelector('personalize-drawer');
            if ( drawerEl === null ) {
                console.warn( '[Custom Personalization Drawer] Cannot find the drawer! Cannot Add to cart' )
                personalizeDrawerManager.toggleErrorMessage(true)
                const realBtn = document.querySelector('.personalize-atc');
                if ( realBtn != null ) {
                    realBtn.setAttribute('disabled', true)
                }
                personalizeDrawerManager.toggleSpinner(false)
                return;
            }

            let currentVariantImage = null;
            const currentProductData = drawerEl.querySelector('script.current-product');
            if ( currentProductData != null ) {
                const currentProductJson = JSON.parse( currentProductData.innerHTML );
                currentVariantImage = personalizeDrawerManager.findBundleImage( currentProductJson, variantId )
            }

            const productTitle = drawerEl.getAttribute('data-product-title');
            const productType = drawerEl.getAttribute('data-product-type');
            const totalTagsToAdd = parseInt( drawerEl.getAttribute( 'data-product-amount' ) );

            const allFrontInputs = drawerEl.querySelectorAll('.input-field[data-position="front"]');
            const allBackInputs = drawerEl.querySelectorAll('.input-field[data-position="back"]');
            const allGemstoneSelects = drawerEl.querySelectorAll('.embeded-gemstone-container');

            const imageUploadsComplete = await personalizeDrawerManager.processImageUploadsForAddToCart();
            if ( !imageUploadsComplete ) {
                personalizeDrawerManager.toggleSpinner(false);
                return;
            }

            let bundlePropertyString = '_bundle';
            let bundleNamePropertyString = '_bundle_name';
            let bundleLabelString = '_bundle_item_label';
            const addJSON = {
                'items': []
            };

            const bundleTimestamp = personalizeDrawerManager.createTimestamp();
            let items = [];
            if ( productType == 'CORE' ) {
                if ( variantId == null ) {
                    console.error('[ADD TO CART] The variant ID is null! Cannot Add to cart')
                    personalizeDrawerManager.toggleErrorMessage(true)
                    const realBtn = document.querySelector('.personalize-atc');
                    if ( realBtn != null ) {
                        realBtn.setAttribute('disabled', true)
                    }
                    personalizeDrawerManager.toggleSpinner(false)
                    return
                }
                let currentVariantPrice = null;
                let currentVariantBaseSku = null;
                if ( currentProductData != null ) {
                    const currentProductJson = JSON.parse( currentProductData.innerHTML );
                    currentVariantPrice = personalizeDrawerManager.findVariantPrice( currentProductJson, variantId );
                    currentVariantBaseSku = personalizeDrawerManager.findVariantSku( currentProductJson, variantId );
                }

                for ( let i = 0; i <= totalTagsToAdd - 1; i++ ) {
                    const item = {
                        quantity: 1,
                        id: variantId,
                        properties: {}
                    };

                    let finalName = productTitle;
                    if ( totalTagsToAdd > 1 ) {
                        finalName = ` ${totalTagsToAdd} Names`;
                    }
                    
                    let uniqueLineLabel = `${productTitle} ${i+1}`;
                    item.properties[ bundlePropertyString ] = bundleTimestamp;
                    item.properties[ bundleNamePropertyString ] = finalName;
                    item.properties[ bundleLabelString ] = uniqueLineLabel;
                    item.properties['_type'] = productType;
                    item.properties['_parent_variant_id'] = 'gid://shopify/ProductVariant/' + variantId;

                    personalizeDrawerManager.createSkuProperty( item , currentVariantBaseSku );

                    if ( currentVariantImage != null ) {
                        item.properties['_bundle_image'] = currentVariantImage;
                    }

                    // this will need to be refactored for handling each unique tag
                    const propertiesFromPersonalization = personalizeDrawerManager.validateFormAndReturnFormData( );
                    item.properties = { ...item.properties, ...propertiesFromPersonalization.variant };

                    // leaving this here incase they do want the price of each tag to show as line item property
                    // if ( currentVariantPrice != null ) {
                    //     const formattedVariantPrice = new Intl.NumberFormat( 'en-US', {
                    //         style: 'currency',
                    //         currency: window.Shopify.currency.active
                    //     }).format( currentVariantPrice / 100 );
                    //     item.properties[ "Price" ] = formattedVariantPrice;
                    // }

                    let hasBackEngraving = false;
                    for ( let i = 0; i < allBackInputs.length; i++ ) {
                        if ( allBackInputs[i].childNodes.length <= 0 ) {
                            continue;
                        }

                        hasBackEngraving = true;
                        break;
                    }

                    if ( typeof(personalizeDrawerManager.fabricMap['front-1']) != "undefined" ) {
                        try {
                            const image = personalizeDrawerManager.fabricMap['front-1'].canvas.toDataURL("image/png"); 
                            const blob = personalizeDrawerManager.base64ToBlob(image)
    
                            item.properties = { ...item.properties, "custom_preview_front": blob} 
                        } catch ( error ) {
                            console.log('Error converting fabric.js image', error)
                        }
                    }

                    if ( hasBackEngraving && typeof(personalizeDrawerManager.fabricMap['back-1']) != "undefined" ) {
                        try {
                            const backImage = personalizeDrawerManager.fabricMap['back-1'].canvas.toDataURL("image/png"); 
                            const backBlob = personalizeDrawerManager.base64ToBlob(backImage)
        
                            item.properties = { ...item.properties, "custom_preview_back": backBlob} 
                        } catch ( error ) {
                            console.log('Error converting fabric.js image', error)
                        }
                    }

                    items.push( item );
                }
            } else {
                // not a core product... bundle ATC
                // determine what options are selected on the current product
                // find the matching item on the bundle product
                const bundleProductData = drawerEl.querySelector('script.bundle-products');
                const selectedBundleVariants = [];

                if ( bundleProductData && currentProductData ) {
                    let finalName = productTitle;

                    const bundleProducts = JSON.parse( bundleProductData.innerHTML );
                    const currentProduct = JSON.parse( currentProductData.innerHTML );
                    let selectedVariant = null;
                    for ( let v = 0; v < currentProduct.variants.length; v++ ) {
                        const _variant = currentProduct.variants[v];
                        if ( _variant.id == variantId ) {
                            selectedVariant = _variant;
                            break;
                        }
                    }

                    const selectedOptionsForCurrentVariant = selectedVariant?.options;
                    for ( let i = 0; i < bundleProducts.length; i++ ) {
                        const currentProduct = bundleProducts[i]?.product;
                        const productVariants = currentProduct?.variants ?? [];

                        for ( let v = 0; v < productVariants.length; v++ ) {
                            const optionsSelected = productVariants[v].selectedOptions;
                            const listOfSelected = [];
                            for ( let o = 0; o < optionsSelected.length; o++ ) {
                                const optionValue = optionsSelected[o].value;
                                listOfSelected.push( optionValue );
                            }

                            if ( listOfSelected.length > 1 ) {
                                if ( listOfSelected.toString()?.toLowerCase() == selectedOptionsForCurrentVariant.toString()?.toLowerCase() ) {
                                    productVariants[v].product_id = currentProduct.legacyResourceId;
                                    selectedBundleVariants.push( productVariants[v] );
                                    break;
                                }
                            } else {
                                let foundMatch = false
                                for ( let option of selectedOptionsForCurrentVariant ) {
                                    if ( option.toLowerCase() == listOfSelected.toString()?.toLowerCase() ) {
                                        foundMatch = true;
                                        break;
                                    }
                                }
                                if ( foundMatch ) {
                                    productVariants[v].product_id = currentProduct.legacyResourceId;
                                    selectedBundleVariants.push( productVariants[v] );
                                }
                            }
                        }
                    }

                    personalizeDrawerManager.updateVariantsOnATCButtonAndProductWrapper(selectedBundleVariants, btn)

                    if ( personalizeDrawerManager.debug ) {
                        console.log( 'SELECTED BUNDLE PRODUCTS: ' , selectedBundleVariants );
                    }
                    let discountRate = personalizeDrawerManager.calculateDiscountRate( selectedBundleVariants, selectedVariant.price )

                    for ( let i = 0; i < selectedBundleVariants.length; i++ ) {
                        const bundleVariant = selectedBundleVariants[i];
                        const bundleProductId = parseInt( bundleVariant?.product_id ?? -1 );
                        const bundleVariantId = parseInt( bundleVariant?.legacyResourceId ?? -1 );
                        const bundleIdToFind = bundleVariantId + "-" + i;
                        const _item = {
                            quantity: 1,
                            id: bundleVariantId,
                            properties: {}
                        };

                        _item.properties[ bundlePropertyString ] = bundleTimestamp;
                        _item.properties[ bundleNamePropertyString ] = finalName;
                        _item.properties['_type'] = productType;
                        _item.properties['_parent_variant_id'] = 'gid://shopify/ProductVariant/' + variantId;

                        const skuData = personalizeDrawerManager.bundleSkuData;
                        const sku = skuData[ bundleProductId ][ bundleVariantId ];
                        if ( sku != null ) {
                            personalizeDrawerManager.createSkuProperty( _item , sku );
                        }

                        if ( currentVariantImage != null ) {
                            _item.properties['_bundle_image'] = currentVariantImage
                        }

                        if ( selectedVariant != null ) {
                            _item.properties[ '_expected_base_bundle_price' ] = selectedVariant.price;
                        }

                        const propertiesFromPersonalization = personalizeDrawerManager.validateFormAndReturnFormData( btn );
                        _item.properties = { ..._item.properties, ...propertiesFromPersonalization[bundleIdToFind] };

                        if ( personalizeDrawerManager.debug ) {
                            console.log("Item's line item properties", _item.properties)
                        }

                        if ( typeof(personalizeDrawerManager.fabricMap[`front-${i + 1}`]) != "undefined" ) {
                            try {
                                const image = personalizeDrawerManager.fabricMap[`front-${i + 1}`].canvas.toDataURL("image/png"); 
                                const blob = personalizeDrawerManager.base64ToBlob(image)
        
                                _item.properties = { ..._item.properties, "custom_preview_front": blob}
                            } catch ( error ) {
                                console.log('Error converting fabric.js image', error)
                            }
                        }

                        let itemHasBackEngraving = false;
                        let matchingDivs = document.querySelectorAll(`.input-field[data-canvas="back-${i + 1}"]`);
                        for ( let m = 0; m < matchingDivs.length; m++ ) {
                            if ( matchingDivs[m].childNodes.length <= 0 ) {
                                continue;
                            }

                            itemHasBackEngraving = true;
                            break;
                        }

                        if ( itemHasBackEngraving && typeof(personalizeDrawerManager.fabricMap[`back-${i + 1}`]) != "undefined") {
                            try {
                                const backImage = personalizeDrawerManager.fabricMap[`back-${i + 1}`].canvas.toDataURL("image/png"); 
                                const backBlob = personalizeDrawerManager.base64ToBlob(backImage)
        
                                _item.properties = { ..._item.properties, "custom_preview_back": backBlob}
                            } catch ( error ) {
                                console.log('Error converting fabric.js image', error)
                            }
                        }

                        items.push( _item );
                    }
                }


            }

            // chains
            const chainPickerEl = document.querySelector('chain-picker');
            if ( chainPickerEl != null ) {
                const selectedChainVariantId = chainPickerEl.selectedChainVariantId;
                const selectedChainProductId = chainPickerEl.selectedChainProduct;
                const chains = chainPickerEl.chains;
                let chain = null;
                for ( let c = 0; c < chains.length; c++ ) {
                    if ( chains[c].id == selectedChainProductId ) {
                        chain = chains[c];
                        break;
                    }   
                }

                if ( selectedChainVariantId != -1 ) {
                    const item = {
                        'id': selectedChainVariantId,
                        'quantity': 1,
                        'properties': {}
                    };

                    let finalName = productTitle;
                    if ( totalTagsToAdd > 1 ) {
                        finalName += ` ${totalTagsToAdd} Names`;
                    }

                    item.properties[ bundlePropertyString ] = bundleTimestamp;
                    item.properties[ bundleNamePropertyString ] = finalName;
                    item.properties[ bundleLabelString ] = "chain";
                    item.properties['_type'] = "ADDON";

                    let chainVariant = null;
                    for ( let v = 0; v < chain.variants.length; v++ ) {
                        if ( chain.variants[v].id == selectedChainVariantId ) {
                            chainVariant = chain.variants[v];
                            break;
                        }
                    }

                    if ( chainVariant != null ) {
                        const formattedChainPrice = new Intl.NumberFormat( 'en-US', {
                            style: 'currency',
                            currency: window.Shopify.currency.active
                        }).format( chainVariant.price / 100 );
                        item.properties[ "Price" ] = formattedChainPrice;
                        item.properties[ "_price" ] = chainVariant.price;
                    }

                    items.push( item );
                }
            }

            // back engravings
            // each back engraving with text should be charged for.
            const backEngravingProductData = drawerEl.querySelector('script.back-engraving-product');
            if ( backEngravingProductData != null ) {
                const backEngravingProduct = JSON.parse( backEngravingProductData.innerHTML );
                if ( backEngravingProduct != null ) {
                    const backEngravingVariant = backEngravingProduct.variants[0];
    
                    for ( let i = 0; i < allBackInputs.length; i++ ) {
                        if ( allBackInputs[i].childNodes.length <= 0 ) {
                            continue;
                        }
                        
                        let backEngravingVariantId = backEngravingVariant.id;
                        const item = {
                            quantity: 1,
                            id: backEngravingVariantId,
                            properties: {}
                        };
    
                        let finalName = productTitle;
                        if ( totalTagsToAdd > 1 ) {
                            finalName = ` ${totalTagsToAdd} Names`;
                        }
                            
                        item.properties[ bundlePropertyString ] = bundleTimestamp;
                        item.properties[ bundleNamePropertyString ] = finalName;
                        item.properties[ bundleLabelString ] = `Back Engraving ${i+1}`;
                        item.properties['_type'] = "ADDON";
    
                        if ( backEngravingVariant != null ) {
                            const formattedBackEngravingPrice = new Intl.NumberFormat( 'en-US', {
                                style: 'currency',
                                currency: window.Shopify.currency.active
                            }).format( backEngravingVariant.price / 100 );
                            item.properties[ "Price" ] = formattedBackEngravingPrice;
                            item.properties[ "_price" ] = backEngravingVariant.price;
                        }
    
                        items.push( item );
                    }
                }
            }

            // gemstones
            // any gemstone added + any gemstone inersted in the middle of text = add on.
            const gemstonesProductData = drawerEl.querySelector('script.gemstone-product');
            if ( gemstonesProductData != null ) {
                const gemstoneProduct = JSON.parse( gemstonesProductData.innerHTML );
                // search all text fields for gemstones and add try to add it by its name ( match variants to name )
                for ( let i = 0; i < allFrontInputs.length; i++ ) {
                    const gemstones = allFrontInputs[i].querySelectorAll('[data-symbol-type="gemstone"]');
                    for ( let g = 0; g < gemstones.length; g++ ) {
                        const gemstoneName = gemstones[g].alt;
                        let foundGemstoneVariant = null;
                        for ( let j = 0; j < gemstoneProduct?.variants.length; j++ ) {
                            const lowercaseTitle = gemstoneProduct?.variants[j].title.toLowerCase();
                            if ( gemstoneName == lowercaseTitle ) {
                                foundGemstoneVariant = gemstoneProduct.variants[j];
                                break;
                            }
                        }                            

                        if ( foundGemstoneVariant ) {
                            const item = {
                                quantity: 1,
                                id: parseInt( foundGemstoneVariant.id ),
                                properties: {}
                            };

                            let finalName = productTitle;
                            if ( totalTagsToAdd > 1 ) {
                                finalName = ` ${totalTagsToAdd} Names`;
                            }
                                
                            item.properties[ bundlePropertyString ] = bundleTimestamp;
                            item.properties[ bundleNamePropertyString ] = finalName;
                            item.properties[ bundleLabelString ] = `Gemstone ${i+1}`;
                            item.properties['_type'] = "ADDON";

                            const formattedBackEngravingPrice = new Intl.NumberFormat( 'en-US', {
                                style: 'currency',
                                currency: window.Shopify.currency.active
                            }).format( foundGemstoneVariant.price / 100 );
                            item.properties[ "Price" ] = formattedBackEngravingPrice;
                            item.properties[ "_price" ] = foundGemstoneVariant.price;
                            
                            items.push( item );
                        }
                    }
                }

                // search for gemstone-selector and read the selected value from each
                if ( personalizeDrawerManager.debug ) {
                    console.log('ALL GEMSTONES', allGemstoneSelects.length)
                }
                for ( let i = 0; i < allGemstoneSelects.length; i++ ) {
                    const selectedGemstoneValue = allGemstoneSelects[i].querySelector('#selected-text').innerText;
                    let foundGemstoneVariant = null;
                    for ( let j = 0; j < gemstoneProduct?.variants.length; j++ ) {
                        const lowercaseTitle = gemstoneProduct?.variants[j].title.toLowerCase();
                        if ( selectedGemstoneValue.toLowerCase() == lowercaseTitle ) {
                            foundGemstoneVariant = gemstoneProduct.variants[j];
                            break;
                        }
                    }

                    if ( foundGemstoneVariant ) {
                        const item = {
                            quantity: 1,
                            id: parseInt( foundGemstoneVariant.id ),
                            properties: {}
                        };

                        let finalName = productTitle;
                        if ( totalTagsToAdd > 1 ) {
                            finalName = ` ${totalTagsToAdd} Names`;
                        }
                            
                        item.properties[ bundlePropertyString ] = bundleTimestamp;
                        item.properties[ bundleNamePropertyString ] = finalName;
                        item.properties[ bundleLabelString ] = `Gemstone ${i+1}`;
                        item.properties['_type'] = "ADDON";

                        const formattedBackEngravingPrice = new Intl.NumberFormat( 'en-US', {
                            style: 'currency',
                            currency: window.Shopify.currency.active
                        }).format( foundGemstoneVariant.price / 100 );
                        item.properties[ "Price" ] = formattedBackEngravingPrice;
                        item.properties[ "_price" ] = foundGemstoneVariant.price;
                        
                        items.push( item );
                    }
                }
            }

            items = items.reverse();
            addJSON.items = items;

            if ( personalizeDrawerManager.debug ) {
                console.log('Add these items to the cart', addJSON)
            }
            
            // Popup Alert on PDP — show popup then add to cart after popup is closed
            if ( typeof( window?.showPopup ) != 'undefined' ) {
                window.showPopup();

                // Listen for pdp:accepted event dispatched in the popup-alerts snippet
                document.addEventListener('pdp:accepted', () => {
                    personalizeDrawerManager.addItemsToCart( addJSON );
                }, { once: true });
            } else {
                // No popup system — add directly to cart
                personalizeDrawerManager.addItemsToCart( addJSON );
            }
        },
        // generates a timestamp for bundles
        createTimestamp: function( ) {
            const now = new Date();
            const timestamp = now.getTime();
            return timestamp;
        },
        addItemsToCart: function ( itemsToAdd ) {
            const formData = new FormData();
            itemsToAdd.items.forEach(function(item, index) {
                var itemName = `items[${index}]`;
                formData.append(itemName + '[id]', item.id);
                formData.append(itemName + '[quantity]', item.quantity);
                const props = item.properties || {};
                Object.keys(props).forEach(function( key ) {
                    let val = props[key];
                    if (key === 'custom_preview') {
                        // Ensure we send a *named* file; wrap Blob as File if needed
                        // var file = new File([val], 'Preview.jpg', { type: val.type || 'image/jpeg' });
                        formData.append(itemName + `[properties][${key}]`, val, 'Preview.png' );
                    } else if ( key === 'custom_preview_back' ) {
                        // Ensure we send a *named* file; wrap Blob as File if needed
                        // var file = new File([val], 'Preview.jpg', { type: val.type || 'image/jpeg' });
                        formData.append(itemName + `[properties][${key}]`, val, 'Back Preview.png' );
                    } else if ( key === 'custom_preview_front' ) {
                        // Ensure we send a *named* file; wrap Blob as File if needed
                        // var file = new File([val], 'Preview.jpg', { type: val.type || 'image/jpeg' });
                        formData.append(itemName + `[properties][${key}]`, val, 'Front Preview.png' );
                    } else if (val != null) {
                        formData.append(itemName + `[properties][${key}]`, String(val));
                    }
                });
            })

            const uploadcareFormEntries = [];
            for ( const [key, value] of formData.entries() ) {
                if ( key.toLowerCase().includes('image') || String(value).includes('ucarecdn') || String(value).includes('/-/format/jpeg') ) {
                    uploadcareFormEntries.push({ key, value });
                }
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json'
                },
                body: formData
            })
            .then(response => {
                if (response.ok) {
                    // close drawer
                    const drawer = document.querySelector( 'personalize-drawer' );
                    if ( drawer != null ) {
                        drawer.close();
                    }

                    // refresh cart
                    document.dispatchEvent( new CustomEvent( 'cart:refresh', {
                        bubbles: true
                    }));

                    // open cart
                    document.dispatchEvent( new CustomEvent( 'cart:open', {
                        bubbles: true
                    }));

                    personalizeDrawerManager.toggleSpinner(false)
                } else {
                    console.error('Error adding personalized product to cart', response.body);
                    personalizeDrawerManager.toggleSpinner(false);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                personalizeDrawerManager.toggleSpinner(false);
            }); 
        },
        // converts color names to lowercase to ensure data for color is found
        findColorData: function ( sideData, currentColor ) {
            let colorToFind = currentColor;
            let sizeToFind = null;

            /**
             * Bundles may have tags with & without a size.  The PDP (current color) will have a size, if one tag has a size option.
             * We need to split the color name & size to check use during check.
             */
            if ( personalizeDrawerManager.productType != 'CORE' ) {
                if ( currentColor.includes('/') ) {
                    let indexOfSlash = currentColor.indexOf('/');
                    colorToFind = currentColor.substring(0, indexOfSlash).trim()
                    sizeToFind = currentColor.substring(indexOfSlash + 1).trim()
                }
            }

            const lowerColorToFind = colorToFind.toLowerCase();
            
            for ( const [ key, value ] of Object.entries( sideData ) ) {
                let lowerKey = key.toLowerCase();
                let color = lowerKey
                let size = null;
                
                /**
                 * Bundles may have tags with & without a size.  The lower key is from the sideData object.  
                 * If the product has a size, it will include a "/".  
                 */
                if ( lowerKey.includes('/') ) {
                    let idxOfSlash = lowerKey.indexOf('/')
                    color = lowerKey.substring(0, idxOfSlash).trim()
                    size = lowerKey.substring(idxOfSlash + 1).trim()
                }

                /**
                 * Bundles may have tags with & without a size.  If size is not null, the side data is for a product with a size.
                 * If not, just match the color name.  
                 */
                if ( size != null ) {
                    if ( color == lowerColorToFind && size == sizeToFind ) {
                        return value
                    }
                } else {
                    if ( color == lowerColorToFind ) {
                        return value
                    }
                }
            }

            // fallback for if no match is found
            return sideData[ currentColor ];
        },
        // build the forms from the json data. The forms need to be cleared and rebuilt everytime a color variant is changed
        buildForms: function ( currentColor = null ) {
            const personalizationForm = document.querySelector('personalization-form');
            if ( personalizationForm != null ) {
                const innerWrapper = personalizationForm.querySelector('.inner-wrapper');
                const modalButton = document.querySelector('.personalize-cta')

                if ( innerWrapper != null && modalButton != null ) {
                    const frontWrapper = innerWrapper.querySelector('.option-wrapper[data-option="front"]');
                    const backWrapper = innerWrapper.querySelector('.option-wrapper[data-option="back"]');('data-current-selected-color');
                    if (currentColor == null ) {
                        currentColor = innerWrapper.getAttribute('data-current-color');
                    } 

                    if ( personalizationForm.debug ) {
                        console.log('CURRENT COLOR:', currentColor)
                    }

                    if ( currentColor != null && frontWrapper != null && backWrapper != null ) {
                        for ( let i = 0; i < personalizeDrawerManager.personalizationJSON.length; i++ ) {
                            const fieldsWrapper = frontWrapper.querySelector(`#fields-wrapper-${i + 1}`);
                            if ( fieldsWrapper != null ) {
                                fieldsWrapper.innerHTML = ''
                            }

                            const frontCanvasContainer = frontWrapper.querySelector(`#canvas-container-${i + 1}`)
                            const backCanvasContainer = backWrapper.querySelector(`#canvas-container-${i + 1}`)

                            let item = personalizeDrawerManager.personalizationJSON[i]
                            
                            // find the data for the front
                            let frontData = item.front;
                            let currentColorDataFront = personalizeDrawerManager.findColorData(frontData, currentColor);

                            if ( personalizeDrawerManager.debug ) {
                                console.log(currentColor, 'FRONT', currentColorDataFront) 
                            }
                            

                            if ( currentColorDataFront ) {
                                personalizeDrawerManager.renderSideData( 'front', currentColorDataFront, frontCanvasContainer, fieldsWrapper, i+1)
    
                                personalizeDrawerManager.handleEditableDivs( 'front', i+1 )
                                personalizeDrawerManager.handleCirclePendantItems( 'front', i+1 )
                            } 
    
                            let hasBackComponents = true;
                            // find the data for the back
                            let backData = item.back;
                            let currentColorDataBack = personalizeDrawerManager.findColorData(backData, currentColor);

                            if ( personalizeDrawerManager.debug ) {
                                console.log(currentColor, 'BACK', currentColorDataBack)
                            }

                            if ( currentColorDataBack ) {
                                const fieldsWrapper2 = backWrapper.querySelector(`#fields-wrapper-${i + 1}`);
                                
                                if ( fieldsWrapper2 != null ) {
                                    fieldsWrapper2.innerHTML = ''
                                }
                                
                                if ( currentColorDataBack.length == 0 ) {
                                    hasBackComponents = false
                                }
    
                                personalizeDrawerManager.renderSideData( 'back', currentColorDataBack, backCanvasContainer, fieldsWrapper2, i+1 )
    
                                personalizeDrawerManager.handleEditableDivs( 'back', i+1 )
                                personalizeDrawerManager.handleCirclePendantItems( 'back', i+1 )
                            }
                            
                          
                            const frontValues = currentColorDataFront?.length ?? 0;
                            const backValues = currentColorDataBack?.length ?? 0;

                            if ( frontValues <= 0 && backValues <= 0 ) {
                                personalizeDrawerManager.determineATCButtonToShow( false )
                            } else {
                                personalizeDrawerManager.showCorrectActionBtn(false, true, false)
                            }
                            
                          

                            personalizeDrawerManager.updateStateOfTabsAndOptionWrappers( hasBackComponents )

                        }
                        
                    }
                }
            }
        },
        // changes if front and back tab are active and if back tab should show
        updateStateOfTabsAndOptionWrappers: function ( hasBackComponents ) {
            const frontTab = document.querySelector('.personalize-tab[data-tab="front"]');
            const backTab = document.querySelector('.personalize-tab[data-tab="back"]');
            const frontWrapper = document.querySelector('.option-wrapper[data-option="front"]');
            const backWrapper = document.querySelector('.option-wrapper[data-option="back"]');
            
            if ( frontTab != null && backTab != null && frontWrapper != null && backWrapper != null ) {
                // set front tab to active
                if ( !frontTab.classList.contains('active') ) {
                    frontTab.classList.add('active')
                }
                // set back tab to not active
                if ( backTab.classList.contains('active') ) {
                    backTab.classList.remove('active')
                }
                // set front wraper to show
                if ( frontWrapper.classList.contains('hidden') ) {
                    frontWrapper.classList.remove('hidden')
                }
                // set back wraper to hidden
                if ( !backWrapper.classList.contains('hidden') ) {
                    backWrapper.classList.add('hidden')
                }

                if ( hasBackComponents ) {
                    // unhide front tab
                    if ( frontTab.classList.contains('hidden') ) {
                        frontTab.classList.remove('hidden')
                    }
                    // unhide back tab
                    if ( backTab.classList.contains('hidden') ) {
                        backTab.classList.remove('hidden')
                    }
                } else {
                    // hide back tab
                    if ( !backTab.classList.contains('hidden') ) {
                        backTab.classList.add('hidden')
                    }
                }
            }

        },
        // formula for line spacing
        characterSpacingFormula: function (currentLetterSpacingValue, currentFontSize) {
            return ( currentLetterSpacingValue / currentFontSize ) * 1000
        },
        // reorders incoming value from JSON to the order set in the theme so buttons go on page in order
        reorderValuesToArray: function( valueStr, orderStr ) {
            if ( personalizeDrawerManager.debug ) {
                console.log('Reordering this string', 'orininal:', valueStr, ' | goal order:', orderStr)
            }
            const values = valueStr.split(',').map(v => v.trim());
            const orderRaw = orderStr.split('||').map(v =>  v.trim());
            const order = [];
            for ( let item of orderRaw ) {
                let splitValue = item.split('[');
                order.push(splitValue[0])

                if ( splitValue.length == 2 ) {
                    personalizeDrawerManager.iconAndGemstoneSkuMap[splitValue[0]] = '[' + splitValue[1]
                }
            }

            // Create a map of value positions from the order string
            const orderMap = new Map(order.map((val, index) => [val, index]));

            // Sort values based on their index in the order map
            const response = values
                .filter(val => orderMap.has(val))
                .sort((a, b) => orderMap.get(a) - orderMap.get(b));

            return response
        },
        // uses data for each side from JSON to build the divs and buttons on the page
        renderSideData: function ( sideName, sideData, canvasContainer, fieldsWrapper, itemNum ) {
            for ( let i = 0; i < sideData.length; i++ ) {
                const component = sideData[i]
                if ( component.type == "image" ) {
                    if ( canvasContainer != null ) {
                        canvasContainer.innerHTML = '';
                    }

                    let imageUrl = component?.field_options?.upload_image?.options?.image?.value || null;
                    
                    if ( imageUrl != null ) {
                        // add the data needed to create the fabric canvas instance
                        if ( personalizeDrawerManager.fabricCanvasData[sideName + "-" + itemNum] == undefined ) {
                            personalizeDrawerManager.fabricCanvasData[sideName + "-" + itemNum] = {}
                        }
                        personalizeDrawerManager.fabricCanvasData[sideName + "-" + itemNum].image_url = component.field_options.upload_image.options.image.value;
                        personalizeDrawerManager.fabricCanvasData[sideName + "-" + itemNum].div_id = `fabricCanvas-${sideName}-${itemNum}`;
                        personalizeDrawerManager.fabricCanvasData[sideName + "-" + itemNum].image_fabric_props = component.field_options.upload_image.options.image.fabric_props;

                        // add div to the page
                        if ( canvasContainer != null ) {
                            const canvas = document.createElement("canvas");
                            canvas.classList.add('fabric-canvas');
                            canvas.setAttribute('id', `fabricCanvas-${sideName}-${itemNum}`)
                            canvas.setAttribute('data-canvas-for', sideName);
                            canvas.setAttribute('data-product-num', itemNum);
                            canvasContainer.appendChild(canvas);

                            if (canvasContainer.dataset.caption) {
                                const optionWrapper = canvasContainer.closest('.option-wrapper');
                                const fieldsWrapper = optionWrapper?.querySelector('.fields-wrapper');
                                const canvasOption = optionWrapper?.querySelector('.canvas-caption');

                                if (fieldsWrapper && !canvasOption) {
                                    console.log('Adding caption for canvas', canvasContainer.dataset.caption);
                                    const caption = document.createElement('span');
                                    caption.classList.add('canvas-caption');
                                    caption.textContent = canvasContainer.dataset.caption;
                                    fieldsWrapper.insertAdjacentElement('beforebegin', caption);
                                }
                            }

                            canvasContainer.classList.remove('hidden')
                        }

                    }
                } else if ( component.type == "text" ) {
                    const sortOrderData = personalizeDrawerManager.sortOrderJSON
                    const fieldOptions = component.field_options;

                    // get the editable div label & fabric prop position
                    const fieldNameSettings = fieldOptions.field_name_settings.options;
                    const labelForEditableDiv = fieldNameSettings.title.value;
                    const inputType = fieldNameSettings.body.input_type;
                    const placeholderText = fieldNameSettings.body.value;
                    const fabricPropsForTextInDiv = fieldNameSettings.body.fabric_props;

                    const allFontSettings = fieldOptions.font_settings.options;

                    const actualFontSetting = allFontSettings.font;
                    const fontOptions = actualFontSetting.options;
                    const fontToShow = actualFontSetting.value;
                    for ( let font of fontOptions ) {
                        if ( font.value == fontToShow ) {
                            personalizeDrawerManager.loadFont( font.linked_font_data )
                        }
                    }

                    const colorSettings = allFontSettings.color;
                    const colorOptions = colorSettings.options;
                    const colorToShow = colorSettings.value;

                    const fontSizeSetting = allFontSettings.font_size.value;
                    const fontSizeLowercaseOverrideSettings = allFontSettings?.lowercase_text_override?.value || null;
                    const fontSizeMixedOverrideSettings = allFontSettings?.mixed_case_text_font_size_override?.value || null;
                    const fontSizeUpperCaseOverrideSettings = allFontSettings?.uppercase_text_font_size_override?.value || null;
                    const fontWeightSetting = allFontSettings.font_weight.value;
                    const fontLineHeight = allFontSettings.line_height.value;
                    const fontLetterSpacingValue = allFontSettings.letter_spacing.value === "" ? 0.0 : allFontSettings.letter_spacing.value;
                    const fontLetterSpacing = fontLetterSpacingValue

                    const fontAlignOptions = allFontSettings.alignment.options;
                    const fontAlignSettings = allFontSettings.alignment.value;
                    const fontAlignOrder = sortOrderData.font_alignment;
                    let fontAlignSettingsArr = []
                    if ( fontAlignSettings.includes(',') ) {
                        fontAlignSettingsArr = personalizeDrawerManager.reorderValuesToArray( fontAlignSettings.toLowerCase(), fontAlignOrder.toLowerCase() )
                    } else {
                        fontAlignSettingsArr.push(fontAlignSettings)
                    }

                    const fontCaseSettings = allFontSettings.font_case;
                    const fontCaseOptions = fontCaseSettings.options;
                    const fontCaseToShow = fontCaseSettings.value;
                    const fontCaseOrder = sortOrderData.font_case;
                    let fontCaseToShowArr = []
                    if ( fontCaseToShow != null && fontCaseToShow != undefined && fontCaseToShow != "" ) {
                        fontCaseToShowArr = personalizeDrawerManager.reorderValuesToArray( fontCaseToShow.toLowerCase(), fontCaseOrder.toLowerCase() )
                    }
                    
                    const lowerCaseLimit = allFontSettings?.lowercase_text_limit?.value || 0;
                    const upperCaseLimt = allFontSettings?.uppercase_text_limit?.value || 0;
                    const mixedCaseLimit = allFontSettings?.mixed_case_text_limit?.value || 0;
                    const gemstoneSettings = fieldOptions.gemstone_settings.options.gemstones;
                    const labelForGemstones = fieldOptions.gemstone_settings.label;
                    const gemstoneOptions = gemstoneSettings.options;
                    const gemstonesToShow = gemstoneSettings.value;
                    const gemstoneOrder = sortOrderData.gemstones;
                    const gemstoneLimit = allFontSettings?.gemstone_limit?.value || 1;
                    let gemstonesToShowArr = []
                    if ( gemstonesToShow != null && gemstonesToShow != undefined && gemstonesToShow != '') {
                        gemstonesToShowArr = personalizeDrawerManager.reorderValuesToArray(gemstonesToShow.toLowerCase(), gemstoneOrder.toLowerCase())
                    }


                    const iconSettings = fieldOptions.icon_settings.options.icons;
                    const iconOptions = iconSettings.options;
                    const iconsToShow = iconSettings.value;
                    const iconsOrder = sortOrderData.icons
                    let iconsToShowArr = []
                    if ( iconsToShow != null && iconsToShow != undefined && iconsToShow != "" ) {
                        iconsToShowArr = personalizeDrawerManager.reorderValuesToArray( iconsToShow.toLowerCase(), iconsOrder.toLowerCase() )
                    }

                    // create the div to hold each field and it's options
                    const wrapperDiv = document.createElement("div");
                    wrapperDiv.classList.add("text-field-and-option-wrapper");

                    // create the label & case button wrapper
                    const textOptions = document.createElement("div");
                    textOptions.classList.add("text-options");

                    // create the label for the div
                    const labelAndCaseContainer = document.createElement('div');
                    labelAndCaseContainer.classList.add('label-and-case-wrapper');

                    if ( labelForEditableDiv != null ) {
                        const label = document.createElement("label");
                        label.classList.add('bold');
                        label.classList.add('uppercase')
                        label.innerText = labelForEditableDiv + ":";
                        labelAndCaseContainer.appendChild(label);
                    }


                    // create the case button
                    const caseContainer = document.createElement('div');
                    caseContainer.classList.add('case-container');

                    if ( fontCaseToShowArr.length > 1 ) {
                        let btnIndex = 0;
                        let foundFirstCase = false;
                        for ( let caseOption of fontCaseToShowArr ) {
                            for ( let j = 0; j < fontCaseOptions.length; j++ ) {
                                const option = fontCaseOptions[j];
                                
                                if ( option.value.toLowerCase() == caseOption ) {
                                    const caseBtn = document.createElement('button');
                                    caseBtn.classList.add('text-case-align');

                                    if ( !foundFirstCase ) {
                                        caseBtn.classList.add('enabled-box');
                                        foundFirstCase = true;
                                    }
                                    caseBtn.setAttribute('id', `field-${i}-${btnIndex++}`);
                                    caseBtn.setAttribute('data-case', caseOption.toLowerCase().replace(' case', ""));
    
                                    const iconWrapper = document.createElement('span');
                                    iconWrapper.innerHTML = option.icon; 
                                    caseBtn.appendChild(iconWrapper);
    
                                    caseContainer.appendChild(caseBtn)
                                }
                            }
                        }
                    }
                    labelAndCaseContainer.appendChild(caseContainer)

                    textOptions.appendChild(labelAndCaseContainer)

                     // create alignment
                    const alignmentContainer = document.createElement('div');
                    alignmentContainer.classList.add('alignment-container');

                    if ( fontAlignSettingsArr.length > 1 ) {
                        const alignLabel = document.createElement("label");
                        alignLabel.classList.add('uppercase')
                        alignLabel.innerText = personalizeDrawerManager.alignLabel + ":";

                        alignmentContainer.appendChild(alignLabel)

                        let foundFirstAlignment = false;
                        for ( let alignment of fontAlignSettingsArr ) {
                            for ( let j = 0; j < fontAlignOptions.length; j++ ) {
                                const option = fontAlignOptions[j];
                       
                                if ( option.value.toLowerCase() == alignment ) {
                                    const alignBtn = document.createElement('button');
                                    alignBtn.classList.add('alignment-button');
                                    alignBtn.setAttribute('data-align-name', alignment);

                                    if ( !foundFirstAlignment ) {
                                        alignBtn.classList.add('enabled-box')
                                        foundFirstAlignment = true
                                    }
                                    
                                    const alignWrapper = document.createElement('span');
                                    alignWrapper.innerHTML = option.icon;
                                    
                                    alignBtn.appendChild(alignWrapper);

                                    alignmentContainer.appendChild(alignBtn)
                                }
                            }
                        }

                    }
                    textOptions.appendChild(alignmentContainer)

                    wrapperDiv.appendChild(textOptions)
                    
                    if ( fieldsWrapper != null ) {
                        fieldsWrapper.appendChild(wrapperDiv)
                    }

                    const divAndCounterWrapper = document.createElement('div');
                    divAndCounterWrapper.classList.add('div-and-counter-wrapper');

                    // create the editable div
                    const editableDiv = document.createElement('div');
                    editableDiv.classList.add('input-field')
                    if ( fontCaseToShowArr.length > 0 ) {
                        editableDiv.classList.add(fontCaseToShowArr[0].toLowerCase().replace(' case', ""))
                    }
                    editableDiv.setAttribute('id', `field-${sideName}-${itemNum}-${i}`);
                    editableDiv.setAttribute('data-position', sideName);
                    editableDiv.setAttribute('data-lowercase-max', lowerCaseLimit);
                    editableDiv.setAttribute('data-uppercase-max', upperCaseLimt);
                    editableDiv.setAttribute('data-mixed-max', mixedCaseLimit);
                    editableDiv.setAttribute('contenteditable', `true`);
                    editableDiv.setAttribute('autocomplete', 'off');
                    editableDiv.setAttribute('autocorrect', 'off');
                    editableDiv.setAttribute('autocapitalize', 'off');
                    editableDiv.setAttribute('spellcheck', 'false');
                    editableDiv.setAttribute('data-color', colorToShow);
                    editableDiv.setAttribute('data-font-family', fontToShow);
                    editableDiv.setAttribute('data-fabric-props', JSON.stringify(fabricPropsForTextInDiv));
                    editableDiv.setAttribute('data-font-size', fontSizeSetting);
                    editableDiv.setAttribute('data-font-size-override-lowercase', fontSizeLowercaseOverrideSettings);
                    editableDiv.setAttribute('data-font-size-override-mixedcase', fontSizeMixedOverrideSettings);
                    editableDiv.setAttribute('data-font-size-override-uppercase', fontSizeUpperCaseOverrideSettings);
                    editableDiv.setAttribute('data-font-weight', fontWeightSetting);
                    editableDiv.setAttribute('data-font-align', fontAlignSettingsArr[0]);
                    editableDiv.setAttribute('data-font-line-height', fontLineHeight);
                    editableDiv.setAttribute('data-font-letter-spacing', fontLetterSpacing);
                    editableDiv.setAttribute('data-label', labelForEditableDiv)
                    editableDiv.setAttribute('data-placeholder', placeholderText)
                    editableDiv.setAttribute('data-canvas', `${sideName}-${itemNum}`)
                    editableDiv.setAttribute('data-single-alignment', fontAlignSettingsArr.length > 1 ? true : false)
                    editableDiv.setAttribute('data-single-case', fontCaseToShowArr.length > 1 ? true : false)

                    divAndCounterWrapper.appendChild(editableDiv)

                    // create counter
                    const counterWrapper = document.createElement('div');
                    counterWrapper.classList.add('input-counter');
                    let maxCount = 0;
                    if ( fontCaseToShowArr.length > 0 ) {
                        if ( fontCaseToShowArr[0] == 'uppercase' ) {
                            maxCount = upperCaseLimt;
                        } else if ( fontCaseToShowArr[0] == 'lowercase') {
                            maxCount = lowerCaseLimit;
                        } else {
                            maxCount = mixedCaseLimit;
                        }
                    }

                    counterWrapper.innerHTML = `<span class="empty-div-text">${maxCount} ${personalizeDrawerManager.characterCountStarterLabel}</span><span class="has-content-text hidden"><span class="input-count">0</span>/<span class="input-max-count">${maxCount}</span></span>`;

                    divAndCounterWrapper.appendChild(counterWrapper);

                    wrapperDiv.appendChild(divAndCounterWrapper)

                    // create symbols
                    const symbolContainer = document.createElement('div');
                    symbolContainer.classList.add('symbol-container');
                    if ( iconsToShowArr.length > 0 ) {
                        const symbolLabel = document.createElement("label");
                        symbolLabel.classList.add('uppercase')
                        symbolLabel.innerText = personalizeDrawerManager.symbolLabel + ":";
    
                        symbolContainer.appendChild(symbolLabel)
                    }
                    for ( let icon of iconsToShowArr ) {

                        for ( let j = 0; j < iconOptions.length; j++ ) {
                            const option = iconOptions[j];
                            
                            if ( option.value.toLowerCase() == icon ) {
                                const iconBtn = document.createElement('button');
                                iconBtn.classList.add('symbol-button');
                                let character = option.linked_symbol_data.symbol_string;
                                let type = 'text'
                                if ( option.linked_symbol_data.symbol_image_url != null ) {
                                    character = option.linked_symbol_data.symbol_image_url;
                                    type = 'image'
                                }
                                iconBtn.setAttribute('data-symbol-character', character);
                                iconBtn.setAttribute('data-symbol-name', option.linked_symbol_data.symbol_name);
                                iconBtn.setAttribute('data-symbol-type', type);
                                iconBtn.setAttribute('data-character-space', option.linked_symbol_data.character_spacing);
                                
                                const iconWrapper = document.createElement('span');
                                if ( type == 'text' ) {
                                    iconBtn.setAttribute('data-value', character)
                                    let innerTxt = this.normalizeHearts(character);
                                    
                                    iconWrapper.innerText = innerTxt; 
                                } else {
                                    const iconImage = document.createElement('img');
                                    iconBtn.setAttribute('alt', option.linked_symbol_data.symbol_name)
                                    iconImage.setAttribute('alt', option.linked_symbol_data.symbol_name)
                                    iconImage.setAttribute('src', character)
                                    iconImage.style.width = '15px';
                                    iconImage.style.height = '15px';
                                    iconWrapper.appendChild(iconImage)
                                }
                                iconBtn.appendChild(iconWrapper);

                                symbolContainer.appendChild(iconBtn)
                            }
                        }
                    }

                    wrapperDiv.appendChild(symbolContainer)

                    // create gemstones
                    const gemstoneContainer = document.createElement('div');
                    gemstoneContainer.classList.add('gemstone-container');
                    gemstoneContainer.setAttribute('data-limit', gemstoneLimit)

                    if ( personalizeDrawerManager.gemstoneUiData.inline.type == 'swatches' ) {
                        for ( let gem of gemstonesToShowArr ) {
                            for ( let j = 0; j < gemstoneOptions.length; j++ ) {
                                const option = gemstoneOptions[j];
                                
                                if ( option.value.toLowerCase() == gem ) {
                                    const gemBtn = document.createElement('button');
                                    gemBtn.classList.add('gemstone-button');
                                    let url = option.linked_gemstone_data.gemstone_image_url;
                                    
                                    gemBtn.setAttribute('data-gemstone-url', url);
                                    gemBtn.setAttribute('data-gemstone-name', option.linked_gemstone_data.gemstone_name);
                                    gemBtn.setAttribute('data-character-space', 1);
                                    gemBtn.classList.add('gemstone');
                                    
                                    const gemWrapper = document.createElement('span');
                                    const gemImage = document.createElement('img');
                                    gemImage.setAttribute('alt', option.linked_gemstone_data.gemstone_name)
                                    gemImage.setAttribute('src', url)
                                    gemImage.style.width = '15px';
                                    gemImage.style.height = '15px';
                                    gemWrapper.appendChild(gemImage)
                                    
                                    gemBtn.appendChild(gemWrapper);
    
                                    gemstoneContainer.appendChild(gemBtn)
                                }
                            }
                        }
                    } else {
                        let runAutomatcially = true;
                        if ( personalizeDrawerManager.gemstoneUiData.inline.runType == 'manual' ) {
                            runAutomatcially = false;
                            gemstoneContainer.classList.add('manual-add');
                        }

                        if ( gemstonesToShowArr.length > 0 ) {
                            let tempContent = gemstoneSelectorTemplate;
                            tempContent = tempContent.replace('{{componentName}}', 'inline-gemstone')
    
                            for ( let gem of gemstonesToShowArr ) {
                                for ( let j = 0; j < gemstoneOptions.length; j++ ) {
                                    const option = gemstoneOptions[j];
                            
                                    if ( option.value.toLowerCase() == gem ) {
                                        let url = option.linked_gemstone_data.gemstone_image_url;
                                        let tempOptionContent = gemstoneOptionTemplate;
                                        tempOptionContent = tempOptionContent.replaceAll('{{value}}', gem);
                                        tempOptionContent = tempOptionContent.replaceAll('{{forloopIndex}}', j);
                                        tempOptionContent = tempOptionContent.replaceAll('{{gemstoneUrl}}', url);
                                        
                                        tempContent += tempOptionContent
                                    }
                                }
                            }

                            tempContent += gemstoneSelectorTemplateCloser
    
                            gemstoneContainer.innerHTML = tempContent

                            // let addButton = document.createElement('button');
                            // addButton.setAttribute('id', 'inline-gem-add-btn');
                            // addButton.classList.add('button', 'inline-gemstone-add-btn');
                            // addButton.innerText = 'Add'

                            // if ( runAutomatcially ) {
                            //     addButton.classList.add('hidden');
                            //     addButton.setAttribute('aria-label', 'hidden')
                            // }

                            // gemstoneContainer.appendChild(addButton)

                        }

                    }

                    wrapperDiv.appendChild(gemstoneContainer)

                } else if ( component.type == "gemstones" ) {
                    const labelForGemstoneContainer = personalizeDrawerManager.gemstoneLabel + ":";
                    const fieldOptions = component.field_options;
                    const gemstoneProps = fieldOptions.upload_image.options.image.fabric_props;
                    const gemstoneOrder = personalizeDrawerManager.sortOrderJSON.gemstones;
                    const gemstonesToAdd = fieldOptions.gemstone_settings.options.gemstones.value;
                    const gemstoneOptions = fieldOptions.gemstone_settings.options.gemstones.options;
                    let gemstonesToShowArr = []
                    if ( gemstonesToAdd != null && gemstonesToAdd != undefined && gemstonesToAdd != '') {
                        gemstonesToShowArr = personalizeDrawerManager.reorderValuesToArray(gemstonesToAdd.toLowerCase(), gemstoneOrder.toLowerCase())
                    }

                    // create gemstones
                    const gemstoneContainer = document.createElement('div');
                    gemstoneContainer.classList.add(`embeded-gemstone-container`);
                    gemstoneContainer.setAttribute('data-fabric-props', JSON.stringify(gemstoneProps))

                    const label = document.createElement('label');
                    label.classList.add('bold');
                    label.innerText = labelForGemstoneContainer
                    gemstoneContainer.appendChild(label)

                    const customSelectWrapper = document.createElement('div');
                    customSelectWrapper.classList.add('custom-dropdown-wrapper');

                    if ( personalizeDrawerManager.gemstoneUiData.component.type == 'swatches' ) {
                        for ( let gem of gemstonesToShowArr ) {
                            for ( let j = 0; j < gemstoneOptions.length; j++ ) {
                                const option = gemstoneOptions[j];
                                
                                if ( option.value.toLowerCase() == gem ) {
                                    const gemBtn = document.createElement('button');
                                    gemBtn.classList.add('gemstone-component-button');
                                    let url = option.linked_gemstone_data.gemstone_image_url;
                                    
                                    gemBtn.setAttribute('data-gemstone-url', url);
                                    gemBtn.setAttribute('data-gemstone-name', option.linked_gemstone_data.gemstone_name);
                                    gemBtn.setAttribute('data-character-space', 1);
                                    gemBtn.classList.add('gemstone');
                                    
                                    const gemWrapper = document.createElement('span');
                                    const gemImage = document.createElement('img');
                                    gemImage.setAttribute('alt', option.linked_gemstone_data.gemstone_name)
                                    gemImage.setAttribute('src', url)
                                    gemImage.style.width = '15px';
                                    gemImage.style.height = '15px';
                                    gemWrapper.appendChild(gemImage)
                                    
                                    gemBtn.appendChild(gemWrapper);
    
                                    gemstoneContainer.appendChild(gemBtn)
                                }
                            }
                        }
                    } else {
                        let runAutomatcially = true;
                        if ( personalizeDrawerManager.gemstoneUiData.component.runType == 'manual' ) {
                            runAutomatcially = false;
                            gemstoneContainer.classList.add('manual-add');
                        }

                        if ( gemstonesToShowArr.length > 0 ) {
                            let tempContent = gemstoneComponentSelectorTemplate;
                            tempContent = tempContent.replace('{{componentName}}', 'gemstone-component')
    
                            for ( let gem of gemstonesToShowArr ) {
                                for ( let j = 0; j < gemstoneOptions.length; j++ ) {
                                    const option = gemstoneOptions[j];
                            
                                    if ( option.value.toLowerCase() == gem ) {
                                        let url = option.linked_gemstone_data.gemstone_image_url;
                                        let tempOptionContent = gemstoneComponentOptionTemplate;
                                        tempOptionContent = tempOptionContent.replaceAll('{{value}}', gem);
                                        tempOptionContent = tempOptionContent.replaceAll('{{forloopIndex}}', j);
                                        tempOptionContent = tempOptionContent.replaceAll('{{gemstoneUrl}}', url);
                                        tempOptionContent = tempOptionContent.replaceAll('{{sideName}}', sideName);
                                         tempOptionContent = tempOptionContent.replaceAll('{{canvas}}', `${sideName}-${itemNum}`)
                                        
                                        tempContent += tempOptionContent
                                    }
                                }
                            }

                            tempContent += gemstoneComponentSelectorTemplateCloser
    
                            customSelectWrapper.innerHTML = tempContent;
                            gemstoneContainer.appendChild(customSelectWrapper)

                            // let addButton = document.createElement('button');
                            // addButton.setAttribute('id', 'gem-component-add-btn');
                            // addButton.classList.add('button', 'gem-component-add-btn');
                            // addButton.innerText = 'Add'

                            // if ( runAutomatcially ) {
                            //     addButton.classList.add('hidden');
                            //     addButton.setAttribute('aria-label', 'hidden')
                            // }

                            // gemstoneContainer.appendChild(addButton)

                        }

                    }

                    // const select = document.createElement('select');
                    // select.setAttribute('id', `embeded-gemstone-dropdown-${i}`)
                    // select.classList.add('gemstone-selector')

                    fieldsWrapper.appendChild(gemstoneContainer)
                } else if ( component.type == 'circletext' ) {
                    const sortOrderData = personalizeDrawerManager.sortOrderJSON
                    const fieldOptions = component.field_options;
                    const fontSettings = fieldOptions.font_settings;
                    const allFontSettings = fontSettings.options;
                    const gemstoneSettings = fieldOptions.gemstone_settings.options.gemstones;
                    const amountOfFields = parseInt(allFontSettings.word_count.value)

                    // get fabric prop position
                    const fabricPropsForCircle = allFontSettings.word_count.fabric_props;

                    const actualFontSetting = allFontSettings.font;
                    const fontOptions = actualFontSetting.options;
                    const fontToShow = actualFontSetting.value;
                    for ( let font of fontOptions ) {
                        if ( font.value == fontToShow ) {
                            personalizeDrawerManager.loadFont( font.linked_font_data )
                        }
                    }

                    const colorSettings = allFontSettings.color;
                    const colorOptions = colorSettings.options;
                    const colorToShow = colorSettings.value;

                    const fontSizeSetting = allFontSettings.font_size.value;
                    const fontSizeLowercaseOverrideSettings = allFontSettings?.lowercase_text_override?.value || null;
                    const fontSizeMixedOverrideSettings = allFontSettings?.mixed_case_text_font_size_override?.value || null;
                    const fontSizeUpperCaseOverrideSettings = allFontSettings?.uppercase_text_font_size_override?.value || null;
                    const fontWeightSetting = allFontSettings.font_weight.value;
                    const fontLetterSpacingValue = allFontSettings.letter_spacing.value === "" ? 0.0 : allFontSettings.letter_spacing.value;
                    const fontLetterSpacing = personalizeDrawerManager.characterSpacingFormula( fontLetterSpacingValue, fontSizeSetting)

                    const radius = allFontSettings["radius"]["value"];
                    const startingAngle = allFontSettings["start_angle"]["value"];
                    
                    const fontCaseSettings = allFontSettings.font_case;
                    const fontCaseOptions = fontCaseSettings.options;
                    const fontCaseToShow = fontCaseSettings.value;
                    const fontCaseOrder = sortOrderData.font_case;
                    let fontCaseToShowArr = []
                    if ( fontCaseToShow != null && fontCaseToShow != undefined && fontCaseToShow != "" ) {
                        fontCaseToShowArr = personalizeDrawerManager.reorderValuesToArray( fontCaseToShow.toLowerCase(), fontCaseOrder.toLowerCase() )
                    }
                    
                    const lowerCaseLimit = allFontSettings?.lowercase_text_limit?.value || 0;
                    const upperCaseLimt = allFontSettings?.uppercase_text_limit?.value || 0;
                    const mixedCaseLimit = allFontSettings?.mixed_case_text_limit?.value || 0;

                    const gemstoneOptions = gemstoneSettings.options;
                    const gemstonesToShow = gemstoneSettings.value;
                    const gemstoneOrder = sortOrderData.gemstones;
                    let gemstonesToShowArr = []
                    if ( gemstonesToShow != null && gemstonesToShow != undefined && gemstonesToShow != '') {
                        gemstonesToShowArr = personalizeDrawerManager.reorderValuesToArray(gemstonesToShow.toLowerCase(), gemstoneOrder.toLowerCase())
                    }

                     // create the div to hold each field and it's options
                    const wrapperDiv = document.createElement("div");
                    wrapperDiv.classList.add("circle-pendant-form-wrapper");
                    wrapperDiv.setAttribute('data-amount-of-fields', amountOfFields)

                    // create the label & case button wrapper
                    const textOptions = document.createElement("div");
                    textOptions.classList.add("text-options");

                    // create the label for the div
                    if ( fontCaseToShowArr.length > 1 ) {
                        const labelAndCaseContainer = document.createElement('div');
                        labelAndCaseContainer.classList.add('label-and-case-wrapper', 'circle-pendant');

                        // create the case button
                        const caseContainer = document.createElement('div');
                        caseContainer.classList.add('case-container');

                        let btnIndex = 0;
                        let foundFirstCase = false;
                        for ( let caseOption of fontCaseToShowArr ) {
                            for ( let j = 0; j < fontCaseOptions.length; j++ ) {
                                const option = fontCaseOptions[j];
                                
                                if ( option.value.toLowerCase() == caseOption ) {
                                    const caseBtn = document.createElement('button');
                                    caseBtn.classList.add('circle-pendant-text-case-align');

                                    if ( !foundFirstCase ) {
                                        caseBtn.classList.add('enabled-box');
                                        foundFirstCase = true;
                                    }
                                    caseBtn.setAttribute('id', `field-${i}-${btnIndex++}`);
                                    caseBtn.setAttribute('data-case', caseOption.toLowerCase().replace(' case', ""));
    
                                    const iconWrapper = document.createElement('span');
                                    iconWrapper.innerHTML = option.icon; 
                                    caseBtn.appendChild(iconWrapper);
    
                                    caseContainer.appendChild(caseBtn)
                                }
                            }
                        }
                        labelAndCaseContainer.appendChild(caseContainer)
                        
                        textOptions.appendChild(labelAndCaseContainer)
                        wrapperDiv.appendChild(textOptions)
                    }
                    
                    if ( fieldsWrapper != null ) {
                        fieldsWrapper.appendChild(wrapperDiv)
                    }

                    for ( let j = 0; j < amountOfFields; j++ ) {
                        const fieldValue = allFontSettings[`word_${j + 1}`]?.value || null;

                        const labelForEditableDiv = personalizeDrawerManager.circlePendantTextLabel.replace('{{number}}', j + 1 )

                        if ( fieldValue != null && fieldValue != "{{GEMSTONE}}" ) {
                            const textWrapper = document.createElement("div");
                            textWrapper.classList.add("text-field-and-option-wrapper");

                            const label = document.createElement("label");
                            label.classList.add('bold');
                            label.classList.add('uppercase')
                            label.innerText = labelForEditableDiv + ":";

                            textWrapper.appendChild(label)

                            const divAndCounterWrapper = document.createElement('div');
                            divAndCounterWrapper.classList.add('div-and-counter-wrapper');

                            // create the editable div
                            const editableDiv = document.createElement('div');
                            editableDiv.classList.add('input-field')
                            if ( fontCaseToShowArr.length > 0 ) {
                                editableDiv.classList.add(fontCaseToShowArr[0].toLowerCase().replace(' case', ""))
                            }
                            editableDiv.setAttribute('id', `field-${sideName}-${itemNum}-${j}`);
                            editableDiv.setAttribute('data-position', sideName);
                            editableDiv.setAttribute('data-lowercase-max', lowerCaseLimit);
                            editableDiv.setAttribute('data-uppercase-max', upperCaseLimt);
                            editableDiv.setAttribute('data-mixed-max', mixedCaseLimit);
                            editableDiv.setAttribute('contenteditable', `true`);
                            editableDiv.setAttribute('autocomplete', 'off');
                            editableDiv.setAttribute('autocorrect', 'off');
                            editableDiv.setAttribute('autocapitalize', 'off');
                            editableDiv.setAttribute('spellcheck', 'false');
                            editableDiv.setAttribute('data-color', colorToShow);
                            editableDiv.setAttribute('data-font-family', fontToShow);
                            editableDiv.setAttribute('data-fabric-props', JSON.stringify(fabricPropsForCircle));
                            editableDiv.setAttribute('data-font-size', fontSizeSetting);
                            editableDiv.setAttribute('data-font-size-override-lowercase', fontSizeLowercaseOverrideSettings);
                            editableDiv.setAttribute('data-font-size-override-mixedcase', fontSizeMixedOverrideSettings);
                            editableDiv.setAttribute('data-font-size-override-uppercase', fontSizeUpperCaseOverrideSettings);
                            editableDiv.setAttribute('data-font-weight', fontWeightSetting);
                            editableDiv.setAttribute('data-font-letter-spacing', fontLetterSpacing);
                            editableDiv.setAttribute('data-canvas', `${sideName}-${itemNum}`)
                            editableDiv.setAttribute( 'data-word-pos' , j );
                            editableDiv.setAttribute('data-radius' , radius);
                            editableDiv.setAttribute('data-start-angle' , startingAngle);
                            editableDiv.setAttribute('data-label', labelForEditableDiv)

                            divAndCounterWrapper.appendChild(editableDiv)

                            // create counter
                            const counterWrapper = document.createElement('div');
                            counterWrapper.classList.add('input-counter');
                            let maxCount = 0;
                            if ( fontCaseToShowArr.length > 0 ) {
                                if ( fontCaseToShowArr[0] == 'uppercase' ) {
                                    maxCount = upperCaseLimt;
                                } else if ( fontCaseToShowArr[0] == 'lowercase') {
                                    maxCount = lowerCaseLimit;
                                } else {
                                    maxCount = mixedCaseLimit;
                                }
                            }

                            counterWrapper.innerHTML = `<span class="empty-div-text">${maxCount} ${personalizeDrawerManager.characterCountStarterLabel}</span><span class="has-content-text hidden"><span class="input-count">0</span>/<span class="input-max-count">${maxCount}</span></span>`;

                            divAndCounterWrapper.appendChild(counterWrapper);

                            textWrapper.appendChild(divAndCounterWrapper)

                            wrapperDiv.appendChild(textWrapper)

                        } else {
                            // create gemstones
                            const gemstoneContainer = document.createElement('div');
                            gemstoneContainer.classList.add(`embeded-gemstone-container`, `circle-pendant`);

                            const labelForGemstoneContainer = personalizeDrawerManager.circlePendantGemstoneLabel.replace('{{number}}', j + 1 )

                            const label = document.createElement('label');
                            label.classList.add('bold');
                            label.classList.add('uppercase')
                            label.innerText = labelForGemstoneContainer + ":"
                            gemstoneContainer.appendChild(label)

                            const customSelectWrapper = document.createElement('div');
                            customSelectWrapper.classList.add('custom-dropdown-wrapper');

                            if ( personalizeDrawerManager.gemstoneUiData.component.type == 'swatches' ) {
                                for ( let gem of gemstonesToShowArr ) {
                                    for ( let g = 0; g < gemstoneOptions.length; g++ ) {
                                        const option = gemstoneOptions[g];
                                        
                                        if ( option.value.toLowerCase() == gem ) {
                                            const gemBtn = document.createElement('button');
                                            gemBtn.classList.add('gemstone-component-button');
                                            let url = option.linked_gemstone_data.gemstone_image_url;
                                            
                                            gemBtn.setAttribute('data-gemstone-url', url);
                                            gemBtn.setAttribute('data-gemstone-name', option.linked_gemstone_data.gemstone_name);
                                            gemBtn.setAttribute('data-character-space', 1);
                                            gemBtn.setAttribute('data-word-pos' , j );
                                            gemBtn.setAttribute('data-radius' , radius);
                                            gemBtn.setAttribute('data-start-angle' , startingAngle);
                                            gemBtn.classList.add('gemstone');
                                            
                                            const gemWrapper = document.createElement('span');
                                            const gemImage = document.createElement('img');
                                            gemImage.setAttribute('alt', option.linked_gemstone_data.gemstone_name)
                                            gemImage.setAttribute('src', url)
                                            gemImage.style.width = '15px';
                                            gemImage.style.height = '15px';
                                            gemWrapper.appendChild(gemImage)
                                            
                                            gemBtn.appendChild(gemWrapper);
            
                                            gemstoneContainer.appendChild(gemBtn)
                                        }
                                    }
                                }
                            } else {
                                let runAutomatcially = true;
                                if ( personalizeDrawerManager.gemstoneUiData.component.runType == 'manual' ) {
                                    runAutomatcially = false;
                                    gemstoneContainer.classList.add('manual-add');
                                }

                                if ( gemstonesToShowArr.length > 0 ) {
                                    let tempContent = gemstoneComponentSelectorTemplate;
                                    tempContent = tempContent.replace('{{componentName}}', 'gemstone-component')
            
                                    for ( let gem of gemstonesToShowArr ) {
                                        for ( let g = 0; g < gemstoneOptions.length; g++ ) {
                                            const option = gemstoneOptions[g];
                                    
                                            if ( option.value.toLowerCase() == gem ) {
                                                let url = option.linked_gemstone_data.gemstone_image_url;
                                                let tempOptionContent = gemstoneComponentOptionTemplate;
                                                tempOptionContent = tempOptionContent.replaceAll('{{value}}', gem);
                                                tempOptionContent = tempOptionContent.replaceAll('{{forloopIndex}}', g);
                                                tempOptionContent = tempOptionContent.replaceAll('{{gemstoneUrl}}', url);
                                                tempOptionContent = tempOptionContent.replaceAll('{{sideName}}', sideName);
                                                tempOptionContent = tempOptionContent.replaceAll('{{canvas}}', `${sideName}-${itemNum}`);
                                                tempOptionContent = tempOptionContent.replaceAll('{{wordPos}}', j );
                                                tempOptionContent = tempOptionContent.replaceAll('{{radius}}', radius );
                                                tempOptionContent = tempOptionContent.replaceAll('{{startAngle}}', startingAngle );
                                                
                                                tempContent += tempOptionContent
                                            }
                                        }
                                    }

                                    tempContent += gemstoneComponentSelectorTemplateCloser
            
                                    customSelectWrapper.innerHTML = tempContent;
                                    gemstoneContainer.appendChild(customSelectWrapper)

                                    // let addButton = document.createElement('button');
                                    // addButton.setAttribute('id', 'gem-component-add-btn');
                                    // addButton.classList.add('button', 'gem-component-add-btn');
                                    // addButton.innerText = 'Add'

                                    // if ( runAutomatcially ) {
                                    //     addButton.classList.add('hidden');
                                    //     addButton.setAttribute('aria-label', 'hidden')
                                    // }

                                    // gemstoneContainer.appendChild(addButton)

                                }

                            }

                            // const select = document.createElement('select');
                            // select.setAttribute('id', `embeded-gemstone-dropdown-${i}`)
                            // select.classList.add('gemstone-selector')

                            wrapperDiv.appendChild(gemstoneContainer)
                        }
                    }
                
                } else if ( component.type == 'uploader' ) {
                    const uploaderSettings = component?.field_options?.uploader_settings || {};
                    const uploaderLabel = uploaderSettings?.options?.uploader_title.value || null;
                    const drawerEl = document.querySelector('personalize-drawer');
                    const uploadcarePublicKey = drawerEl?.getAttribute('data-uploadcare-public-key') || "";
                    const uploadcareCdnCname = drawerEl?.getAttribute('data-uploadcare-cdn-cname') || "";
                    const uploaderContextName = `personalize-uploader-${sideName}-${itemNum}-${i}`;
                    const uploaderInputId = `image-upload-${sideName}-${itemNum}-${i}`;

                    // create the div to hold each field and it's options
                    const wrapperDiv = document.createElement("div");
                    wrapperDiv.classList.add("text-field-and-option-wrapper", "image-uploader-wrapper");

                    // create the label & case button wrapper
                    const imageUploaderDiv = document.createElement("div");
                    imageUploaderDiv.classList.add("image-uploader");

                    // create the label for the div
                    const labelAndFieldContainer = document.createElement('div');
                    labelAndFieldContainer.classList.add('label-and-field-wrapper');

                    if ( uploaderLabel != null ) {
                        const label = document.createElement("label");
                        label.classList.add('bold');
                        label.classList.add('uppercase');
                        label.setAttribute("for", uploaderInputId);
                        label.innerText = uploaderLabel + ":";
                        labelAndFieldContainer.appendChild(label);
                    }

                    imageUploaderDiv.appendChild(labelAndFieldContainer)

                    // const input = document.createElement('input');
                    // input.name = "image_upload";
                    // input.classList.add("image_upload");
                    // input.id = uploaderInputId;
                    // input.setAttribute("type", "file");
                    // input.setAttribute("accept", ".jpg,.jpeg,.heic,.heif,.png,image/jpeg,image/heic,image/heif,image/png");
                    // input.setAttribute("multiple", "multiple");
                    // input.setAttribute("data-uploadcare-context", uploaderContextName);
                    // input.setAttribute("data-side-name", sideName);
                    // input.setAttribute("data-property-label", uploaderLabel || "Image");
                    // input.addEventListener('change', (event) => {
                    //     const selectedFiles = Array.from(event.currentTarget.files || []);
                    //     personalizeDrawerManager.validateFormAndReturnFormData();
                    // });

                    // imageUploaderDiv.appendChild(input)

                    if ( uploadcarePublicKey != "" ) {
                        const uploadcareConfig = document.createElement( "uc-config" );

                        uploadcareConfig.setAttribute( "ctx-name", uploaderContextName );
                        uploadcareConfig.setAttribute( "pubkey", uploadcarePublicKey );

                        uploadcareConfig.setAttribute( "source-list", "local" );
                        uploadcareConfig.setAttribute( "img-only", "true" );
                        uploadcareConfig.setAttribute( "multiple", "false" );
                        uploadcareConfig.setAttribute( "accept", ".jpg,.jpeg,.heic,.heif,.png,image/jpeg,image/heic,image/heif,image/png" );
                        uploadcareConfig.setAttribute( "store", "auto" );

                        // Editor / auto open editor / tabs in editor / crop preset aspect.
                        uploadcareConfig.setAttribute( "use-cloud-image-editor", "true" );
                        uploadcareConfig.setAttribute( "cloud-image-editor-auto-open", "true" );
                        uploadcareConfig.setAttribute( "cloud-image-editor-tabs", "crop,tuning" );
                        uploadcareConfig.setAttribute( "crop-preset", "1:1,4:5,3:2,16:9" );

                        if ( uploadcareCdnCname != "" ) {
                            uploadcareConfig.setAttribute( "cdn-cname", uploadcareCdnCname );
                        }

                        const uploadcareProvider = document.createElement( "uc-upload-ctx-provider" );

                        uploadcareProvider.setAttribute( "ctx-name", uploaderContextName );

                        const uploadcareUploader = document.createElement( "uc-file-uploader-regular" );

                        uploadcareUploader.setAttribute( "ctx-name", uploaderContextName );

                        uploadcareUploader.classList.add( "image_upload" );
                        uploadcareUploader.id = uploaderInputId;
                        uploadcareUploader.setAttribute( "data-side-name", sideName );
                        uploadcareUploader.setAttribute( "data-property-label", uploaderLabel || "Image" );
                        uploadcareUploader.dataset.uploadedImageUrl = "";

                        const uploadcareWrapper = document.createElement( "div" );
                        uploadcareWrapper.classList.add( "image-upload-wrapper" );

                        const uploadcarePreview = document.createElement( "div" );
                        uploadcarePreview.classList.add( "image-upload-preview" );
                        uploadcarePreview.hidden = true;

                        const uploadcarePreviewImage = document.createElement( "img" );
                        uploadcarePreviewImage.classList.add( "image-upload-preview__image" );
                        uploadcarePreviewImage.alt = "Uploaded image preview";

                        uploadcarePreview.appendChild( uploadcarePreviewImage );

                        uploadcareProvider.addEventListener( "file-url-changed", ( event ) => {
                            const uploadedFile = event.detail;
                            const croppedImageUrl = uploadedFile?.cdnUrl || "";

                            uploadcareUploader.dataset.uploadedImageUrl = croppedImageUrl;

                            if ( croppedImageUrl != "" ) {
                                uploadcarePreviewImage.src =`${croppedImageUrl}-/resize/300x300/-/quality/smart/-/format/auto/`;
                                uploadcarePreview.hidden = false;
                            } else {
                                uploadcarePreviewImage.removeAttribute( "src" );
                                uploadcarePreview.hidden = true;
                            }

                            personalizeDrawerManager.validateFormAndReturnFormData();
                        });

                        uploadcareProvider.addEventListener( "file-removed", () => {
                            uploadcareUploader.dataset.uploadedImageUrl = "";
                            uploadcarePreviewImage.removeAttribute( "src" );
                            uploadcarePreview.hidden = true;
                            personalizeDrawerManager.validateFormAndReturnFormData();
                        });

                        uploadcareWrapper.appendChild( uploadcareUploader );
                        uploadcareWrapper.appendChild( uploadcarePreview );

                        imageUploaderDiv.appendChild( uploadcareConfig );
                        imageUploaderDiv.appendChild( uploadcareProvider );
                        imageUploaderDiv.appendChild( uploadcareWrapper );
                    }

                    wrapperDiv.appendChild(imageUploaderDiv)

                     if ( fieldsWrapper != null ) {
                        fieldsWrapper.appendChild(wrapperDiv)
                    }

                }
            }
        },
        // click event for hide banner on version banner
        handleHideBanner: function ( banner, e ) {
            banner.classList.add('hidden')
        },
        // click event for exit version on version banner
        handleExitPreview: function ( banner, e ) {
            const url = new URL(window.location.href); 
            const params = url.searchParams; 
            params.delete('version'); 
            window.history.replaceState({}, document.title, url.toString());

            // hide banner and rerun the system
            personalizeDrawerManager.handleHideBanner( banner, e);
            personalizeDrawerManager.runSystem()
            document.dispatchEvent( new Event( "variant:change" ) );
        },
        // get the metafield data from the script tag added via liquid in personalization-drawer.liquid
        getPersonalizationJson: function ( currentColor ) {
            let drawer = document.querySelector('.personalize-drawer');

            if ( drawer != null ) {
                let debug = drawer.getAttribute('data-debug') == "true" ? true : false;
                personalizeDrawerManager.debug = debug || false;
            }

            function useMetafieldData() {
                if ( drawer != null ) {
                    let productId = drawer.getAttribute('data-product-id');
    
                    if ( productId != null ) {
                        let scriptTag = document.querySelector(`#product-${productId}-personalization-data-list`)
    
                        if ( scriptTag != null ) {
                            if ( JSON.parse( scriptTag.innerText )[0] != null ) {
                                personalizeDrawerManager.personalizationJSON = JSON.parse( scriptTag.innerText )
                                if ( personalizeDrawerManager.debug ) {
                                    console.log(personalizeDrawerManager.personalizationJSON)
                                }
                                personalizeDrawerManager.getValuesFromDataAttributes()
                                personalizeDrawerManager.getSortOrders()
                                personalizeDrawerManager.getSizingData()
                                personalizeDrawerManager.getSkuCodeData()
                                personalizeDrawerManager.getBundleSkuData();
                                personalizeDrawerManager.buildForms( currentColor )
                                personalizeDrawerManager.loadTabs()
                                personalizeDrawerManager.loadFabricCanvas()
                                personalizeDrawerManager.refreshAllFabricCanvases()
                                personalizeDrawerManager.storeCharacterCounts()
                                personalizeDrawerManager.handleGemstoneComponent()
                                personalizeDrawerManager.addFormValidationAndATCAbility()
                            } else {
                                personalizeDrawerManager.determineATCButtonToShow( false )
                            }
                        }
                    }
                }
            }

            // check for version number and fetch that version's data
            const urlParams = new URLSearchParams( window.location.search );
            if (urlParams.has('version')) {
                personalizeDrawerManager.getSizingData()
                personalizeDrawerManager.getSkuCodeData()
                personalizeDrawerManager.getBundleSkuData();

                const version = urlParams.get('version');

                const banner = document.querySelector('#personalization-version-banner');
                if ( banner != null ) {
                    const span = banner.querySelector('#version-number')
                    if ( span != null ) {
                        span.innerText = version
                    }
                    const hideButton = banner.querySelector('#hide-version-banner');
                    const exitButton = banner.querySelector('#exit-version-view');

                    if ( hideButton != null ) {
                        hideButton.removeEventListener('click', personalizeDrawerManager.handleHideBanner.bind( null, banner ))
                        hideButton.addEventListener('click', personalizeDrawerManager.handleHideBanner.bind( null, banner ))
                    }

                    if ( exitButton != null ) {
                        exitButton.removeEventListener('click', personalizeDrawerManager.handleExitPreview.bind( null, banner ))
                        exitButton.addEventListener('click', personalizeDrawerManager.handleExitPreview.bind( null, banner ))
                    }
                    banner.classList.remove('hidden')
                }

                try {
                    if ( drawer != null ) {
                        let handle = drawer.getAttribute('data-product-handle');
                        let url = `https://tinytags-staging.txtcon.io/server/public/products/${handle}/personalization/${version}`

                        fetch(url, {method: 'POST'}).then( response => {
                            if (!response.ok) {
                                console.warn('Network response not ok', response.status)
                                useMetafieldData()
                            } 
                            return response.json()
                        }).then(data => {
                            // to do, send a list of version IDs
                            // must be a list of layer configs 
                            personalizeDrawerManager.personalizationJSON = [ data.layers ];
                            personalizeDrawerManager.getSortOrders()
                            personalizeDrawerManager.buildForms( currentColor )
                            personalizeDrawerManager.loadTabs()
                            personalizeDrawerManager.loadFabricCanvas()
                            personalizeDrawerManager.refreshAllFabricCanvases()
                            personalizeDrawerManager.storeCharacterCounts()
                            personalizeDrawerManager.handleGemstoneComponent()
                            personalizeDrawerManager.addFormValidationAndATCAbility()
                        })
                    }
                } catch (error) {
                    useMetafieldData()
                    console.warn('Error fetching json', error)
                }

                
            } else {
                useMetafieldData()
            }

            // console.log(personalizeDrawerManager.skuCodes)

        },
        showCorrectActionBtn: function ( showOrinialATCButton = false, showPersonalizeBtn = false, showFallbackATCButton = false ) {
            const personalizationButton = document.querySelector( '.open-personalization-action-wrapper' );
            // handle showing/hiding Klaviyo Back in Stock
            const productForm = personalizationButton?.closest('form');
            if ( productForm?.querySelector('.klaviyo-bis-trigger') ) {
                const stockUnavailable = productForm.getAttribute('data-personalization-stock-unavailable');
                const personalizationTrigger = personalizationButton.querySelector('.personalize-cta');
                // Before the swatch handler initializes, use the Liquid-rendered button state.
                const isUnavailable = stockUnavailable === 'true' || (stockUnavailable === null && personalizationTrigger?.disabled === true);

                if ( isUnavailable ) {
                    showOrinialATCButton = false;
                    showPersonalizeBtn = false;
                    showFallbackATCButton = false;
                }
            }

            if ( personalizationButton != null ) {
                if ( showPersonalizeBtn && personalizationButton.classList.contains('hidden') ) {
                    personalizationButton.classList.remove('hidden')
                } else if ( !showPersonalizeBtn && !personalizationButton.classList.contains('hidden') ) {
                    personalizationButton.classList.add('hidden')
                }
            }

            const originalATCButton = (productForm || document).querySelector( '.buy-buttons' );
            if ( originalATCButton != null ) {
                if ( showOrinialATCButton && originalATCButton.classList.contains('hidden') ) {
                    originalATCButton.classList.remove('hidden')
                } else if ( !showOrinialATCButton && !originalATCButton.classList.contains('hidden') ) {
                    originalATCButton.classList.add('hidden')
                }
            }

            const fallbackATCButton = (productForm || document).querySelector( '.fallback-personalization-action-wrapper' );
            if ( fallbackATCButton != null ) {
                if ( showFallbackATCButton && fallbackATCButton.classList.contains('hidden') ) {
                    fallbackATCButton.classList.remove('hidden')
                } else if ( !showFallbackATCButton && !fallbackATCButton.classList.contains('hidden') ) {
                    fallbackATCButton.classList.add('hidden')
                }
            }            
        },
        checkForVariantIdOnFallbackBtn: function () {
            const fallbackATCButton = document.querySelector('.fallback-personalize-cta');
            if ( fallbackATCButton != null ) {
                const hasVariantIdAttribute = fallbackATCButton.hasAttribute('data-chain-variant-id');
                
                if ( !hasVariantIdAttribute ) {
                    const chainPickerEl = document.querySelector('chain-picker');
                    const selectedChainVariantId = chainPickerEl.selectedChainVariantId;
                    fallbackATCButton.setAttribute( 'data-chain-variant-id', selectedChainVariantId)

                }
            }
        },
        determineATCButtonToShow: function ( showPersonalizationBtn = false ) {
            const chainPickerEl = document.querySelector('chain-picker');
            if ( chainPickerEl != null ) {
                personalizeDrawerManager.showCorrectActionBtn( false, showPersonalizationBtn, true )
                
                personalizeDrawerManager.checkForVariantIdOnFallbackBtn()
            } else {
                // show reg atc button
                personalizeDrawerManager.showCorrectActionBtn( true, showPersonalizationBtn, false )
            }
        },
        // get the sort order data from the script tag added via liquid in personalization-drawer.liquid
        getSortOrders: function () {
            let drawer = document.querySelector('.personalize-drawer')
            if ( drawer != null ) {
                let scriptTag = document.querySelector(`#item-sort-orders`)

                if ( scriptTag != null ) {
                    personalizeDrawerManager.sortOrderJSON = JSON.parse(scriptTag.innerText)
                }
            }
        },
        getValuesFromDataAttributes: function () {
            let drawer = document.querySelector('.personalize-drawer');
            if ( drawer != null ) {
                let size = drawer.getAttribute('data-canvas-size');
                if ( size != null ) {
                    personalizeDrawerManager.canvasSize = size;
                }
                let alignLabel = drawer.getAttribute('data-align-label');
                if ( alignLabel != null ) {
                    personalizeDrawerManager.alignLabel = alignLabel
                }
                let symbolLabel = drawer.getAttribute('data-symbol-label');
                if ( symbolLabel != null ) {
                    personalizeDrawerManager.symbolLabel = symbolLabel
                }
                let gemstoneLabel = drawer.getAttribute('data-gemstone-label');
                if ( gemstoneLabel != null ) {
                    personalizeDrawerManager.gemstoneLabel = gemstoneLabel
                }

                let characterCountStarterLabel = drawer.getAttribute('data-count-empty-label');
                if ( characterCountStarterLabel != null ) {
                    personalizeDrawerManager.characterCountStarterLabel = characterCountStarterLabel
                }

                let circlePendantTextLabel = drawer.getAttribute('data-circle-pendant-text-label');
                if ( circlePendantTextLabel != null ) {
                    personalizeDrawerManager.circlePendantTextLabel = circlePendantTextLabel
                }

                let circlePendantGemstoneLabel = drawer.getAttribute('data-circle-pendant-gemstone-label');
                if ( circlePendantGemstoneLabel != null ) {
                    personalizeDrawerManager.circlePendantGemstoneLabel = circlePendantGemstoneLabel
                }
                
                let inlineGemstoneType = drawer.getAttribute('data-inline-gemstone-type');
                if ( inlineGemstoneType != null ) {
                    personalizeDrawerManager.gemstoneUiData.inline.type = inlineGemstoneType
                }

                let hasBackOnlyEngraving = drawer.getAttribute('data-has-back-only-engraving');
                if ( hasBackOnlyEngraving != null ) {
                    personalizeDrawerManager.hasBackOnlyEngraving = hasBackOnlyEngraving;
                }

                let gemstoneInlineNameFormat = drawer.getAttribute('data-inline-gemstone-name-format');
                if ( gemstoneInlineNameFormat != null ) {
                    personalizeDrawerManager.gemstoneInlineNameFormat = gemstoneInlineNameFormat;
                }
            }

            let drawerEl = document.querySelector('personalize-drawer');
            if ( drawerEl != null ) {
                personalizeDrawerManager.productType = drawerEl.getAttribute('data-product-type');
            }
        },
        // get the special sizing data from the script tag added via liquid in personalization-drawer.liquid
        getSizingData: function () {
            let drawer = document.querySelector('.personalize-drawer');
            if ( drawer != null ) {
                let scriptTag = document.querySelector('#item-font-sizing');
                if ( scriptTag != null ) {
                    personalizeDrawerManager.fontSizing = JSON.parse(scriptTag.innerText)
                }
            }
        },
        getBundleSkuData: function() {
            let drawer = document.querySelector('.personalize-drawer')
            if ( drawer != null ) {
                let scriptTag = drawer.querySelector('#bundle-sku-data');
                if ( scriptTag != null ) {
                    personalizeDrawerManager.bundleSkuData = JSON.parse(scriptTag.innerText);
                }
            }
        },
        getSkuCodeData: function () {
            let drawer = document.querySelector('.personalize-drawer')
            if ( drawer != null ) {
                let scriptTag = drawer.querySelector('#item-sku-code');
                if ( scriptTag != null ) {
                    personalizeDrawerManager.skuCodes = JSON.parse(scriptTag.innerText)
                }
            }
        },
        // load font on page
        loadFont: async function ( fontData ) {
            const fontName = fontData.font_name;
            const fontWeight = fontData.font_weight;
            const fontStyle = fontData.font_style;
            const fontFiles = fontData.files;

            for ( let file of fontFiles ) {
                const fontUrl = file.shopify_cdn_url;
                const fontKey = `${fontName}::${fontWeight}::${fontStyle}::${fontUrl}`;

                if ( personalizeDrawerManager.fontLoadPromises.has( fontKey ) ) {
                    continue;
                }

                const fontPromise = (async () => {
                    const fontFaceUrl = `url(${fontUrl})`;
                    const fontProps = {
                        style: fontStyle,
                        weight: fontWeight
                    };
                    const currentFontFace = new FontFace( fontName, fontFaceUrl , fontProps );
                    await currentFontFace.load();
                    document.fonts.add( currentFontFace );
                })();

                personalizeDrawerManager.fontLoadPromises.set( fontKey, fontPromise );
            }

            await personalizeDrawerManager.ensureFontsReady();
        },
        ensureFontsReady: async function () {
            const pendingFontLoads = Array.from(personalizeDrawerManager.fontLoadPromises.values());

            if ( pendingFontLoads.length > 0 ) {
                await Promise.allSettled( pendingFontLoads );
            }

            if ( document.fonts?.ready ) {
                await document.fonts.ready;
            }

            await new Promise((resolve) => requestAnimationFrame(resolve));
            await new Promise((resolve) => requestAnimationFrame(resolve));
        },
        refreshAllFabricCanvases: async function () {
            await personalizeDrawerManager.ensureFontsReady();

            const canvasKeys = new Set();
            const editableDivs = document.querySelectorAll('.input-field[data-canvas]');
            for ( const editableDiv of editableDivs ) {
                const canvasKey = editableDiv.getAttribute('data-canvas');
                if ( canvasKey ) {
                    canvasKeys.add( canvasKey );
                }
            }

            for ( const canvasKey of canvasKeys ) {
                const matchingEditableDivs = document.querySelectorAll(`[contenteditable][data-canvas="${canvasKey}"]`);
                if ( matchingEditableDivs.length > 0 ) {
                    await personalizeDrawerManager.updateFabricCanvas(matchingEditableDivs, canvasKey);
                }
            }
        },
        // get the front and back tab on the modal and add click events 
        loadTabs: function () {
            const tabs = document.querySelectorAll('.personalize-tab');

            for ( let tab of tabs ) {
                tab.removeEventListener( 'click' , personalizeDrawerManager.handleTabToggle );
                tab.addEventListener( 'click' , personalizeDrawerManager.handleTabToggle );
            }
        },
        // create the fabric canvases
        loadFabricCanvas: function () {
            // front canvas
            const frontFabricCanvases = document.querySelectorAll(`.option-wrapper[data-option="front"] .canvasContainer `);
            for ( let canvasContainer of frontFabricCanvases) {
                const id = canvasContainer.getAttribute('id').split('-');
                const canvasNum = id[id.length - 1];

                if ( personalizeDrawerManager.fabricCanvasData[`front-${canvasNum}`]?.div_id ) {
                    const frontCanvas = new fabric.Canvas(personalizeDrawerManager.fabricCanvasData[`front-${canvasNum}`].div_id)
                    frontCanvas.setWidth(600);
                    frontCanvas.setHeight(600);
                    frontCanvas.hoverCursor = 'default'
    
                    personalizeDrawerManager.fabricMap[`front-${canvasNum}`] = {
                        canvas: frontCanvas,
                        textbox: new fabric.Textbox('', {
                            left: 10, top: 10, fontSize: 20, width: 580, selectable: false
                        }),
                        image_url: personalizeDrawerManager.fabricCanvasData[`front-${canvasNum}`].image_url,
                        image_fabric_props: personalizeDrawerManager.fabricCanvasData[`front-${canvasNum}`].image_fabric_props
                    }
                }
            }

            // back canvas
            const backFabricCanvases = document.querySelectorAll(`.option-wrapper[data-option="back"] .canvasContainer`);
            for ( const canvasContainer of backFabricCanvases) {
                const id = canvasContainer.getAttribute('id').split('-');
                const canvasNum = id[id.length - 1];

                if (personalizeDrawerManager.fabricCanvasData[`back-${canvasNum}`]?.div_id ) {
                    const backCanvas = new fabric.Canvas(personalizeDrawerManager.fabricCanvasData[`back-${canvasNum}`].div_id)
                    backCanvas.setWidth(600);
                    backCanvas.setHeight(600);
                    backCanvas.hoverCursor = 'default'
                    personalizeDrawerManager.fabricMap[`back-${canvasNum}`] = {
                        canvas: backCanvas,
                        textbox: new fabric.Textbox('', {
                            left: 10, top: 10, fontSize: 20, width: 580, selectable: false
                        }),
                        image_url: personalizeDrawerManager.fabricCanvasData[`back-${canvasNum}`].image_url,
                        image_fabric_props: personalizeDrawerManager.fabricCanvasData[`back-${canvasNum}`].image_fabric_props
                    }
                }
            }
            
            // add textboxes to canvases
            for (const [key, value] of Object.entries(personalizeDrawerManager.fabricMap)) {
                personalizeDrawerManager.fabricMap[key].canvas.add(personalizeDrawerManager.fabricMap[key].textbox)

                // set background image
                const backgroundUrl = personalizeDrawerManager.fabricMap[key].image_url;
                const scaleX = personalizeDrawerManager.fabricMap[key].image_fabric_props.scaleX;
                const scaleY = personalizeDrawerManager.fabricMap[key].image_fabric_props.scaleY;
                const top = personalizeDrawerManager.fabricMap[key].image_fabric_props.top;
                const left = personalizeDrawerManager.fabricMap[key].image_fabric_props.left;
                
                fabric.Image.fromURL(backgroundUrl, function(img) {
                    img.set({
                        scaleX: scaleX,
                        scaleY: scaleY,
                        left: left,
                        top: top
                    })
                    personalizeDrawerManager.fabricMap[key].canvas.setBackgroundImage( img, () => {
                        personalizeDrawerManager.fabricMap[key].canvas.renderAll();
                    });
                }, { crossOrigin: 'Anonymous' })
            }
        },
        scaleFabricProps: function ( incomingProps ) {
            const newSize = personalizeDrawerManager.canvasSize;
            const originalSize = 600;
            const newScale = newSize / originalSize;

            const props = { ...incomingProps };

            // normalize origin to top-left for predictable math
            props.originX = props.originX || 'left';
            props.originY = props.originY || 'top';

            // scale spatial props if present
            if ( props.left != null ) {
                props.left = props.left * newScale;
            } 
            if ( props.top != null ) {
                props.top = props.top * newScale;
            }
            if ( props.width != null )  {
                props.width = props.width * newScale;
            }
            if ( props.height != null ) {
                props.height = props.height * newScale;
            } 

            if ( props.scaleX != null && props.scaleY != null ) {
                props.scaleX = props.scaleX * newScale;
                props.scaleY = props.scaleY * newScale;
            } else {
                // don’t inherit object scale; keep at 1, use true sizes instead
                props.scaleX = 1;
                props.scaleY = 1;
            }


            // strokes etc.
            if ( props.strokeWidth != null ) { 
                props.strokeWidth = props.strokeWidth * newScale;
            }

            return props;
        },
        calcuateOffsetForCurrentFontSize: function (incomingFontSize, regressionData ) {
            const { slope, yIntercept } = regressionData;

            let returnValue = 0;
            if ( slope == 0 && yIntercept == 0 ) {
                returnValue = null
            } else {
                returnValue = slope * incomingFontSize + yIntercept;
            }
            return returnValue
        },
        alignContentToBox: function ( fabricObjects, debugRect, boxWidth, boxHeight, alignment ) {
            const contentObjects = fabricObjects.filter(o => o !== debugRect);
            if (!contentObjects.length) return;

            // Measure ONCE (pre-shift)
            const bounds = personalizeDrawerManager.measureContentBounds(fabricObjects, debugRect);
            const contentLeft = bounds.left;
            const contentTop = bounds.top;
            const contentRight = bounds.left + bounds.width;
            const contentBottom = bounds.top + bounds.height;

            // --- DY: baseline lock (bottom of box)
            const baselineY = boxHeight; // debugRect is at top=0, so bottom is boxHeight
            const dy = baselineY - contentBottom;

            // --- DX: horizontal align inside box (left/center/right)
            let targetLeft = 0;
            if ((alignment || '').toLowerCase() === 'center') {
                targetLeft = (boxWidth - bounds.width) / 2;
            } else if ((alignment || '').toLowerCase() === 'right') {
                targetLeft = boxWidth - bounds.width;
            } else {
                targetLeft = 0; 
            }

            const dx = targetLeft - contentLeft;

            // Apply both shifts together
            for (const obj of contentObjects) {
                obj.left += dx;
                obj.top += dy;
            }
        },
        measureContentBounds: function ( fabricObjects, debugRect ) {
                const contentObjects = fabricObjects.filter(o => o !== debugRect);

                const tempGroup = new fabric.Group(contentObjects, {
                    left: 0,
                    top: 0,
                    originX: 'left',
                    originY: 'top',
                    selectable: false,
                    evented: false
                });

                tempGroup._calcBounds();
                tempGroup._updateObjectsCoords();

                return tempGroup.getBoundingRect(true, true);
        },
        measureGroupBounds: function ( fabricObjects ) {
            const tempGroup = new fabric.Group(fabricObjects, {
                left: 0,
                top: 0,
                originX: 'left',
                originY: 'top',
                selectable: false,
                evented: false
            });

            tempGroup._calcBounds();
            tempGroup._updateObjectsCoords();

            return tempGroup.getBoundingRect(true, true);
        },
        anchorBottomLeftAngle0: function ( fabricProps, baselineHeight, trueHeight ) {
            const deltaH = trueHeight - baselineHeight;

            // If content got taller, move group up so bottom stays pinned.
            // If content got shorter, move group down.
            fabricProps.top = (fabricProps.top || 0) - deltaH;

            return fabricProps;
        },
        normalizeCanvasWhitespace: function (s) {
            if (s == null) return "";
            // Convert regular spaces to NBSP so trailing spaces keep width in Fabric/canvas
            return String(s).replace(/ /g, "\u00A0");
        },
        snapInlineImagesToBaseline: function (objs, boxHeight, inset = 20, mode = 'hang', opts = {}) {
            const baselineY = boxHeight - inset;

            // baseline hits this fraction down from the TOP of the image
            // 0.25 means baseline is 25% down from top → most of image below baseline
            const hangFraction = opts.hangFraction ?? 0.25;

            // small tweak (pixels), independent of font size
            const tweak = opts.tweak ?? 0;
            const fontKey = opts.fontKey ?? null;

            for (const obj of objs) {
                if (obj?.type !== 'image' && obj?.data?.role !== 'inline-image' ) continue;
                if (obj?.data?.role !== 'inline-image') continue;

                const h = obj.getScaledHeight();
                const beforeTop = obj.top;

                if (mode === 'center') {
                obj.top = baselineY - h / 2 + tweak;
                } else if (mode === 'bottom') {
                obj.top = baselineY - h + tweak;
                } else if (mode === 'hang') {
                // baseline crosses image near the top
                obj.top = baselineY - (h * hangFraction) + tweak;
                }

                obj.setCoords();
            }
        },
        snapVisualBottom: function (objects, boxHeight, inset = 25 ) {
            const safariBottomAdjustment = personalizeDrawerManager.isSafariBrowser() ? 8 : 0;
            const desiredBottom = boxHeight - inset + safariBottomAdjustment;

            for (const obj of objects) {
                if (!obj) continue;

                // Only apply to path text 
                const isText = ['text', 'textbox', 'i-text'].includes(obj.type);
                if (!isText) continue;

                obj.setCoords();
                const r = obj.getBoundingRect(false, true);  // group-local
                const currentBottom = r.top + r.height;

                obj.top += (desiredBottom - currentBottom);
                obj.setCoords();
  }
        },
        getNumberOrFallback: function (value, fallback = 0) {
            if (value == null || value === '') {
                return Number(fallback) || 0;
            }

            const parsedValue = Number(value);
            return Number.isNaN(parsedValue) ? Number(fallback) || 0 : parsedValue;
        },
        nudgePostSnapGlyphs: function (objs, boxHeight, bottomInset = 25) {
            const targetBottom = boxHeight - bottomInset;
            const safariBottomAdjustment = personalizeDrawerManager.isSafariBrowser() ? 8 : 0;
            const adjustableGlyphs = ['•', '°', '+'];

            for (const obj of objs) {
                if (!obj) continue;
                if (!['text', 'textbox', 'i-text'].includes(obj.type)) continue;
                if (!adjustableGlyphs.includes(obj?.data?.offsetKey)) continue;

                const fontKey = obj?.data?.sourceFontFamily || (typeof obj.fontFamily === 'string' ? obj.fontFamily.split(',')[0].trim() : obj.fontFamily);
                const offsetKey = obj.data.offsetKey;
                const offsetSettings = personalizeDrawerManager.fontSizing?.[fontKey]?.[offsetKey] || null;
                if (offsetSettings == null) continue;

                const extraPadding = personalizeDrawerManager.getNumberOrFallback(offsetSettings.offset_v2, offsetSettings.offset);

                obj.setCoords();
                const r = obj.getBoundingRect(false, true);
                const bottom = r.top + r.height;
                const desiredBottom = targetBottom - extraPadding + safariBottomAdjustment;

                obj.top += desiredBottom - bottom;
                obj.setCoords();
            }
        },
        nudgeHearts: function (objs, boxHeight, bottomInset = 25) {
            const targetBottom = boxHeight - bottomInset;
            const safariHeartAdjustment = personalizeDrawerManager.isSafariBrowser() ? 6 : 0;
            const iOSHeartAdjustment = personalizeDrawerManager.isIOS() ? -3 : 0;
            
            for (const obj of objs) {
                if (!obj) continue;
                if (!['text', 'textbox', 'i-text'].includes(obj.type)) continue;
                if (obj?.data?.glyph !== 'heart') continue;
                // use metaobject to get offset
                let heart = "♥"
                const fontKey = obj?.data?.sourceFontFamily || (typeof obj.fontFamily === 'string' ? obj.fontFamily.split(',')[0].trim() : obj.fontFamily);
                const extraPadding = personalizeDrawerManager.fontSizing?.[fontKey]?.[heart]?.offset_v2 || 0;
                
                obj.setCoords();
                const r = obj.getBoundingRect(false, true);
                const bottom = r.top + r.height;
                const desiredBottom = targetBottom - extraPadding + safariHeartAdjustment + iOSHeartAdjustment;

                // If heart bottom is too low, move it UP 
                const deltaY = desiredBottom - bottom;  // positive = move down, negative = move up
                obj.top += deltaY;

                obj.setCoords();
            }
        },
        // update the text on the canvas
        updateFabricCanvas: async function( editableDivs, editorId ) {
            await personalizeDrawerManager.ensureFontsReady();

            // grap the correct instance from fabricMap
            let editor = personalizeDrawerManager.fabricMap[ editorId ];

            if ( !editor ) {
                return;
            }

            // remove all non-background and non-gemstone objects
            editor.canvas.getObjects().forEach(obj => {
                if (obj?.data?.role !== 'gemstone') {
                    editor.canvas.remove(obj);
                }
            });

            function addText( letters, props, height = null, width = null, isAHeart = false ) {

                const localDebug = personalizeDrawerManager.debug;
                class DebugText extends fabric.Text {
                    _render(ctx) {
                        super._render(ctx);
                        ctx.save();
                        ctx.strokeStyle = localDebug ? 'purple' : 'transparent';
                        ctx.lineWidth = 1;
                        ctx.strokeRect(
                            -this.width / 2,
                            -this.height / 2,
                            this.width ,
                            this.height
                        );
                        ctx.restore();
                    }
                }

                if (!letters) return null;

                let l = letters;
                if ( props.fontCase === 'uppercase' ) {
                    l = l.toUpperCase();
                } else if ( props.fontCase === 'lowercase' ) {
                    l = l.toLowerCase();
                }

                let textObj = new DebugText( l, props ); 
                textObj.initDimensions();

                if ( height && width ) {
                    const boxWidth = textObj.width;
                    let inset = 15;

                    const pathData = `
                            M 0 0
                            L ${boxWidth} 0
                            `;

                    let stroke = 'transparent';
                    let showStroke = false;
                    if ( personalizeDrawerManager.debug ) {
                        stroke = '#8a0c0cff';
                        showStroke = true;
                    }   

                    const path = new fabric.Path(String(pathData).trim(), {
                        stroke: null,
                        fill: '',
                        visible: showStroke,
                        originX: 'left',
                        originY: 'top',
                        left: 0,
                        top: 0
                    });
                    
                    // Attach path to text
                    textObj = new DebugText(l, {
                        ...props,
                        path,
                        pathAlign: isAHeart ? 'ascender' : 'center',
                        pathStartOffset: 0,
                        pathOffset: new fabric.Point(0, inset),
                    });

                    // mark the text object so whe can update the heart emoji's position later
                    textObj.data = { ...(textObj.data || {}), glyph: isAHeart ? 'heart' : 'text', sourceFontFamily: props.fontFamily };

                    return textObj;
                }
                textObj = new DebugText( l, props ); 
                return textObj;
            }
            
            // need the text details from all divs so they can be updated together
            // skip circle text fields
            for ( let i = 0; i < editableDivs.length; i++ ) {
                let editableDivTemp = editableDivs[i];
                
                // skip any fields with a radius
                const radius = editableDivTemp.getAttribute( 'data-radius' );

                if ( radius != null ) {
                    continue;
                }
                
                let divId = editableDivTemp.getAttribute('id')
                const editableDiv = document.querySelector(`#${divId}`)
                let tempValue = editableDiv.getAttribute('data-placeholder');
                let fabricPropsRaw = JSON.parse(editableDiv.getAttribute('data-fabric-props'));
                let fabricProps = fabricPropsRaw;
                let color = editableDiv.getAttribute('data-color');
                let fontFamily = editableDiv.getAttribute('data-font-family');
                let fontSize = editableDiv.getAttribute('data-font-size');
                let baseFontSize = fontSize;
                let fontSizeOverride = null;
                let fontSizeLowercaseOverride = editableDiv.getAttribute('data-font-size-override-lowercase')
                let fontSizeMixedcaseOverride = editableDiv.getAttribute('data-font-size-override-mixedcase')
                let fontSizeUppercaseOverride = editableDiv.getAttribute('data-font-size-override-uppercase')
                let fontWeight = editableDiv.getAttribute('data-font-weight');
                let letterSpacing = editableDiv.getAttribute('data-font-letter-spacing');
                let spacingPx = parseFloat(letterSpacing);
                let calculatedCharSpacing = (spacingPx / parseInt(baseFontSize) * 1000)
                let alignment = editableDiv.getAttribute('data-font-align');
                const currentCase = personalizeDrawerManager.fetchCurrentCase( editableDiv );
                const newScale = 1;

                // determine if we should use an override
                switch ( currentCase ) {
                    case "lowercase":
                        fontSizeOverride = fontSizeLowercaseOverride
                        break
                    case "mixed":
                        fontSizeOverride = fontSizeMixedcaseOverride
                        break  
                    case "uppercase":
                        fontSizeOverride = fontSizeUppercaseOverride
                        break      
                }

                if ( fontSizeOverride && fontSizeOverride != null && fontSizeOverride != "null" && fontSizeOverride != "" ) {
                    fontSize = fontSizeOverride;
                }
            
                // use the highest length to determine the size of the box over the tag
                const lowerMaxLength = personalizeDrawerManager.fetchCurrentMaxLength( editableDiv , 'lowercase' );
                const upperMaxLength = personalizeDrawerManager.fetchCurrentMaxLength( editableDiv , 'uppercase' );
                const mixedMaxLength = personalizeDrawerManager.fetchCurrentMaxLength( editableDiv , 'mixed' );
                const absoluteMaxLength = Math.max( lowerMaxLength, upperMaxLength , mixedMaxLength );

                const layoutProps = {
                    fill: color,
                    fontWeight: fontWeight,
                    fontSize: baseFontSize * newScale,   // base font size drives layout box height
                    fontFamily: fontFamily,
                    letterSpacing: spacingPx,
                    charSpacing: calculatedCharSpacing,
                    fontCase: currentCase,
                    selectable: false,
                    lockMovementX: true,
                    lockMovementY: true,
                    lockRotation: true,
                    lockScalingFlip: true,
                    lockScalingX: true,
                    lockScalingY: true,
                    lockSkewingX: true,
                    lockSkewingY: true
                };

                const renderProps = {
                    ...layoutProps,
                    fontSize: fontSize * newScale        // override font size drives font render
                };

                const fabricObjects = [];

                // start by drawing a box with the max width of the characters
                const tempProps = {...layoutProps};
                
                let longestCase = 'lowercase';
                if (upperMaxLength == absoluteMaxLength) {
                    longestCase = 'uppercase';
                } else if (mixedMaxLength == absoluteMaxLength) {
                    longestCase = 'mixed';
                }
                
                tempProps.fontCase = longestCase;
                const tempFabricText = addText( tempValue , tempProps );
                tempFabricText.initDimensions();
                

                const groupWidth = tempFabricText.width * tempFabricText.scaleX;
                const groupHeight = tempFabricText.height * tempFabricText.scaleY;

                const debugRect = new fabric.Rect({
                    top: 0,
                    left: 0,
                    width: groupWidth,
                    height: groupHeight,
                    fill: 'rgba(0, 0, 255, 0.05)',
                    stroke: 'blue',
                    strokeWidth: personalizeDrawerManager.debug ? 1 : 0,
                    originX: 'left',
                    originY: 'top',
                    selectable: false,
                    evented: false,
                    lockMovementX: true,
                    lockMovementY: true,
                    lockRotation: true,
                    lockScalingFlip: true,
                    lockScalingX: true,
                    lockScalingY: true,
                    lockSkewingX: true,
                    lockSkewingY: true,
                    visible: personalizeDrawerManager.debug // USE THIS TO SHOW DEBUG BOX
                });

                // calculatedCharSpacing = ( 2 / 40 ) * 1000;
                // const fancyProps = {
                //     fontWeight: 400,
                //     fontSize: 40,   // base font size drives layout box height
                //     fontFamily: 'jasmine-2026',
                //     fontCase: 'lowercase',
                //     selectable: false,
                //     letterSpacing: 25,
                //     charSpacing: calculatedCharSpacing,
                //     top: 0,
                //     left: 0,
                //     angle: 0,
                //     scaleX: 1,
                //     scaleY: 1
                // }
                // const fancyText = addText( tempValue , fancyProps );

                // console.log('add text', fancyText)

                // const fancybox = new fabric.Rect({
                //     top: 0,
                //     left: 0,
                //     width: groupWidth,
                //     height: groupHeight,
                //     fill: 'rgba(0, 0, 255, 0.05)',
                //     stroke: 'blue',
                //     strokeWidth: personalizeDrawerManager.debug ? 1 : 0,
                //     originX: 'left',
                //     originY: 'top',
                //     selectable: false,
                //     evented: false,
                //     lockMovementX: true,
                //     lockMovementY: true,
                //     lockRotation: true,
                //     lockScalingFlip: true,
                //     lockScalingX: true,
                //     lockScalingY: true,
                //     lockSkewingX: true,
                //     lockSkewingY: true,
                //     visible: personalizeDrawerManager.debug // USE THIS TO SHOW DEBUG BOX
                // });

                fabricObjects.push( debugRect );                
                
                const nodeWalker = document.createTreeWalker( editableDiv , NodeFilter.SHOW_ALL, null , false );
                let currentNode = nodeWalker.nextNode();
                let nodesToSkip = 0;

                let cursorX = 0;
                let cursorY = 0;
                const angleDeg = 0;
                const angleRad = angleDeg * Math.PI / 180;
                let fontScaleMultiplier = 1;
                let fontScaleImageMultiplier = 0.4;
                let imageOffsetV2 = 0;
                const imageSpacing = 2; 

                const fontStructure = personalizeDrawerManager.fontSizing[fontFamily] || null;
                if ( fontStructure != null ) {
                    fontScaleImageMultiplier = fontStructure.images.resize;
                    imageOffsetV2 = Number(fontStructure?.images?.offset_v2);
                    if ( Number.isNaN(imageOffsetV2) ) {
                        imageOffsetV2 = 0;
                    }
                    let useMetaobjectDataForLetterSpacing = fontStructure.use_metaobject_letter_spacing_setting;

                    if ( useMetaobjectDataForLetterSpacing ) {
                        spacingPx = parseFloat(fontStructure.letter_spacing);
                    }
                }

                while ( currentNode ) {
                    // while there are nodes to skip OR the currentNode isn't existing anymore
                    while ( nodesToSkip > 0 ) {
                        currentNode = nodeWalker.nextNode();
                        if ( currentNode ) {
                            nodesToSkip--;
                        } else {
                            nodesToSkip = -999;
                        }
                    }

                    if ( currentNode ) {
                        if ( currentNode.nodeType == Node.ELEMENT_NODE ) {
                            if ( personalizeDrawerManager.debug ) {
                                console.log( '>> processing element...' , currentNode );
                            }

                            if ( currentNode.nodeName === 'SPAN' ) {
                                nodesToSkip = currentNode.childNodes.length;
                                let letters = currentNode.textContent;
                                let isAHeart = false;
                                // convert unicode back to heart emoji for fabric canvas
                                if ( letters == '\u2764\uFE0E' || letters == '\u2665\uFE0E' ) {
                                    letters = "♥"
                                    isAHeart = true;
                                }
                                // If it's a space, preserve it explicitly
                                const displayText = letters === " " ? "\u00A0" : letters; // non-breaking space
                                
                                const propsToAdd = structuredClone( renderProps );
                                const originalFontSize = parseFloat( renderProps.fontSize );
                                let scaledFontSize = originalFontSize;
                                
                                let offset = 15;
                                if ( letters == "°") {
                                    offset = 3;
                                } else if ( letters == '•') {
                                    offset = -2;
                                } else if ( letters == "♥" ) {
                                    offset = -5;
                                } else if ( letters == "+" ) {
                                    offset = 3;
                                    scaledFontSize = originalFontSize * (1 - 0.1)
                                }

                                if ( fontStructure != null ) {
                                    let lookupKey = letters;
                                    if ( lookupKey == "\u00A0" ) {
                                        lookupKey = 'text'
                                    }
                                    if ( personalizeDrawerManager.whiteListNumbers.indexOf(letters) > -1 ) {
                                        lookupKey = 'numbers';
                                    } else if ( personalizeDrawerManager.whiteListCharacters.indexOf(letters) > -1 ) {
                                        lookupKey = 'text';
                                    } else if ( personalizeDrawerManager.isValidSpecialCharacter(fontFamily, lookupKey) ) {
                                        if ( letters != "+" ) {
                                            lookupKey = 'text';
                                        } 
                                        if ( letters == "/" || letters == "-" ) {
                                            lookupKey = 'numbers';
                                        }
                                    }
                                   
                                    const regressionOffset = personalizeDrawerManager.calcuateOffsetForCurrentFontSize(fontSize, fontStructure[lookupKey].regressionData);
                                    offset = regressionOffset;
                                    
                                    if ( offset == null ) {
                                        offset = fontStructure[lookupKey].offset
                                    }
                                    
                                    if ( fontStructure[lookupKey].resize == 0 ) {
                                        fontScaleMultiplier = 1;
                                    }  else {
                                        fontScaleMultiplier = fontStructure[lookupKey].resize 
                                    } 
                                }
                                
                                scaledFontSize = originalFontSize * fontScaleMultiplier;

                                propsToAdd.fontSize = scaledFontSize;
                                propsToAdd.left = cursorX;
                                propsToAdd.top = cursorY - offset;
                                propsToAdd.selectable = true;
                                propsToAdd.lineHeight = 0.5

                                if ( letters == "♥" && personalizeDrawerManager.isIOS() ) {
                                    propsToAdd.fontFamily = `${fontFamily},Helvetica,"Times New Roman", Georgia, serif`;
                                    propsToAdd.fontSize = scaledFontSize + 7;
                                    propsToAdd.top = propsToAdd.top - 3;
                                } else if ( letters == "♥"  ) {
                                    // Not a IOS device, ignore above hotfix
                                }

                                const fabricText = addText( displayText, propsToAdd, groupHeight, groupWidth, isAHeart );
                                if ( fabricText ) {
                                    if ( ['•', '°', '+'].includes(letters) ) {
                                        fabricText.data = { ...(fabricText.data || {}), offsetKey: letters, sourceFontFamily: fontFamily };
                                    }
                                    fabricObjects.push( fabricText );
                                    const distance = fabricText.width * fabricText.scaleX;
                                    // spacingPx is the letter spacing
                                    cursorX += (distance + spacingPx) * Math.cos( angleRad );
                                    cursorY += (distance + spacingPx) * Math.sin( angleRad );
                                }
                            } else if ( currentNode.nodeName === 'IMG' ) {
                                nodesToSkip = currentNode.childNodes.length;
                                const src = currentNode.src;
                                const symbolType = currentNode.dataset.symbolType;
                                const symbolName = currentNode.getAttribute('alt');
                                let fabricImage;

                                if (symbolType === 'other' && symbolName && symbolName.toLowerCase() == 'foot') {
                                    fabricImage = await new Promise((resolve) => {
                                        fabric.loadSVGFromURL(src, (objects, options) => {
                                                const desiredColor = color; /// color of the font

                                                objects.forEach(obj => {
                                                    if (obj.fill) obj.set({ fill: desiredColor });
                                                    if (obj.stroke) obj.set({ stroke: desiredColor });
                                                });

                                                options.crossOrigin = 'Anonymous';


                                                let svg = fabric.util.groupSVGElements(objects, options);
                                                svg.data = { ...(svg.data || {}), role: 'inline-image' };
                                                svg.scale(0.8);
                                                svg.setCoords();
                                                resolve(svg);
                                            });
                                        });
                                } else {
                                    fabricImage = await new Promise((resolve) => {
                                        fabric.Image.fromURL(src, (img) => {
                                                resolve(img);
                                            }, { crossOrigin: 'Anonymous' });
                                    });
                                }

                                let offset = 0;
                                if ( fontStructure != null ) {
                                    offset =  personalizeDrawerManager.calcuateOffsetForCurrentFontSize(fontSize, fontStructure["images"].regressionData)

                                    if ( offset == null ) {
                                        offset = fontStructure["images"].offset
                                    }

                                    offset = 25
                                    
                                }

                                const originalWidth = fontSize;
                                const originalHeight = fontSize;
                                const fontScaleImageMultiplierForCurrentFontSize = fontScaleImageMultiplier
                                fabricImage.scaleToWidth( originalWidth * fontScaleImageMultiplierForCurrentFontSize );
                                fabricImage.scaleToHeight( originalHeight * fontScaleImageMultiplierForCurrentFontSize );
                                fabricImage.left = cursorX;
                                fabricImage.top = cursorY - offset;
                                fabricImage.selectable = false;
                                fabricImage.data = { role: 'inline-image'};
                                fabricObjects.push( fabricImage );
                                
                                const distance = fabricImage.width * fabricImage.scaleX;
                                cursorX += (distance + imageSpacing + 0) * Math.cos( angleRad );
                                cursorY += (distance + imageSpacing + 0) * Math.sin( angleRad );
                            }

                        } else if ( currentNode.nodeType == Node.TEXT_NODE ) {
                            if ( personalizeDrawerManager.debug ) {
                                console.log( '>> processing text element...' , currentNode );
                            }
                            const letters = currentNode.textContent;
                            const propsToAdd = structuredClone( renderProps );
                            propsToAdd.left = cursorX;
                            propsToAdd.top = 0;
                            propsToAdd.selectable = false;
                            const fabricText = addText( letters, propsToAdd );
                            if ( fabricText ) {
                                fabricObjects.push( fabricText );
                                const distance = fabricText.width * fabricText.scaleX;
                                cursorX += (distance + spacingPx) * Math.cos( angleRad );
                                cursorY += (distance + spacingPx) * Math.sin( angleRad );
                            }
                        }

                        currentNode = nodeWalker.nextNode();
                    }
                }

                personalizeDrawerManager.alignContentToBox(
                    fabricObjects,
                    debugRect,
                    groupWidth,
                    groupHeight,
                    alignment
                );

                // this moves the text to the bottom of the box (most important for divs with override font sizes)  
                personalizeDrawerManager.snapVisualBottom(fabricObjects, groupHeight, 25);
                personalizeDrawerManager.nudgePostSnapGlyphs(fabricObjects, groupHeight, 25);
                // this moves the images to the same path as the text (most important for divs with override font sizes)  
                // note: path does not work for images so we have to do this
                personalizeDrawerManager.snapInlineImagesToBaseline( fabricObjects, groupHeight, 25, 'hang', { hangFraction: 0.25, tweak: imageOffsetV2, fontKey: fontFamily } )
                // the heart emoji is too low so we need to move it up after everything else has been moved
                personalizeDrawerManager.nudgeHearts(fabricObjects, groupHeight, 25);
                const baselineHeight = groupHeight;

                // Measure true rendered bounds for the objects you actually built
                const bounds = personalizeDrawerManager.measureGroupBounds(fabricObjects);
                const trueHeight = bounds.height;

                // Shift the group so the bottom stays anchored (angle 0)
                fabricProps = personalizeDrawerManager.anchorBottomLeftAngle0(
                    fabricProps,
                    baselineHeight,
                    trueHeight
                );

                const group = new fabric.Group( fabricObjects , {
                    ...fabricProps,
                    originX: 'left',  
                    originY: 'top', 
                    lockMovementX: true,
                    lockMovementY: true,
                    lockRotation: true,
                    lockScalingFlip: true,
                    lockScalingX: true,
                    lockScalingY: true,
                    lockSkewingX: true,
                    lockSkewingY: true,
                    controls: null
                });

                editor.canvas.add( group );
            }

            const circleProps = {
                words: [],
                font: {
                    fontFamily: "",
                    fontColor: "",
                    fontWeight: "",
                    fontCase: "",
                    lineHeight: 1.16,
                    fontSize: 0,
                    charSpacing: 0,
                    textAlign: 'center'
                },
                side: editor.canvas.lowerCanvasEl.getAttribute('data-canvas-for'),
                currentFabricProps: null,
                canvas: {
                    canvasWidth: editor.canvas.getWidth(),
                    canvasHeight: editor.canvas.getHeight(),
                },
                circle: {
                    radius: 0,
                    startingAngleOffset: 0,
                    arcCount: 0,
                    anglePerArc: 0,
                    cx: editor.canvas.getWidth() / 2,
                    cy: editor.canvas.getHeight() / 2,
                    groupCenterX: 0,
                    groupCenterY: 0,
                },
                debug: {
                    debugColors: [ 'red' , 'green' , 'blue' , 'orange' , 'purple' , 'pink' ], 
                    debugColorIndex: 0
                }
            };

            const firstEditableDiv = editableDivs[0] || null;
            const formWrapper = firstEditableDiv?.closest('.circle-pendant-form-wrapper') || document.querySelector('.circle-pendant-form-wrapper');
            if ( formWrapper != null ) {
                let amountOfFields = formWrapper.getAttribute('data-amount-of-fields');

                if ( amountOfFields != null && circleProps.words.length == 0 ) {
                    circleProps.words.length = parseInt(amountOfFields)
                }
            }

            // extract all circle text fields and process them
            for ( let i = 0; i < editableDivs.length; i++ ) {
                const editableDivTemp = editableDivs[i];
                const editableDiv = editableDivTemp;
                const radius = editableDiv.getAttribute( 'data-radius' );
                const radiusAsFloat = parseFloat( radius );
                const startingAngle = editableDiv.getAttribute( 'data-start-angle' );
                const startingAngleAsFloat = parseFloat( startingAngle );
                const colorOfText = editableDiv.getAttribute( 'data-color' );
                const wordPos = editableDiv.getAttribute( 'data-word-pos' );
                const wordPosAsInt = parseInt( wordPos );
                const fontFamilyOfText = editableDiv.getAttribute( 'data-font-family' );
                const fontWeight = editableDiv.getAttribute( 'data-font-weight' );
                const fontSize = editableDiv.getAttribute( 'data-font-size' );
                let fontSizeOverride = null;
                let fontSizeLowercaseOverride = editableDiv.getAttribute('data-font-size-override-lowercase')
                let fontSizeMixedcaseOverride = editableDiv.getAttribute('data-font-size-override-mixedcase')
                let fontSizeUppercaseOverride = editableDiv.getAttribute('data-font-size-override-uppercase')
                const fontSizeAsFloat = parseFloat( fontSize );
                const fontLetterSpacing = editableDiv.getAttribute( 'data-font-letter-spacing' );
                const fontLineHeight = editableDiv.getAttribute( 'data-font-line-height' ) || "1.16";
                const fontLineHeightAsFloat = parseFloat( fontLineHeight );
                let fontLetterSpacingAsFloat = parseFloat( fontLetterSpacing );
                const fabricPositionPropsRaw = editableDiv.getAttribute( 'data-fabric-props' );
                const fabricPropsParsed = JSON.parse( fabricPositionPropsRaw );
                const calculatedCharSpacing = fontLetterSpacingAsFloat;
                const currentCase = personalizeDrawerManager.fetchCurrentCase( editableDiv );
                let overrideIsUsed = false;

                // skip anything without a radius
                if ( radius == null || radius == '{{radius}}' ) {
                    break;
                }

                // determine if we should use an override
                switch ( currentCase ) {
                    case "lowercase":
                        fontSizeOverride = fontSizeLowercaseOverride
                        break
                    case "mixed":
                        fontSizeOverride = fontSizeMixedcaseOverride
                        break  
                    case "uppercase":
                        fontSizeOverride = fontSizeUppercaseOverride
                        break      
                }

                if ( fontSizeOverride && fontSizeOverride != null && fontSizeOverride != "null" && fontSizeOverride != "" ) {
                    fontSize = fontSizeOverride;
                    overrideIsUsed = true;
                }

                // calculate the current word for later use
                const word = {
                    pos: wordPosAsInt,
                    letters: "",
                    fitToArc: editableDiv.hasAttribute('data-byo-preview-adapter-for')
                };

                const nodeWalker = document.createTreeWalker( editableDiv , NodeFilter.SHOW_ALL, null , false );
                let currentNode = nodeWalker.nextNode();
                let nodesToSkip = 0;
                while ( currentNode ) {
                    // while there are nodes to skip OR the currentNode isnt existing anymore
                    while ( nodesToSkip > 0 ) {
                        currentNode = nodeWalker.nextNode();
                        if ( currentNode ) {
                            nodesToSkip--;
                        } else {
                            nodesToSkip = -999;
                        }
                    }

                    if ( currentNode ) {
                        if ( currentNode.nodeType == Node.ELEMENT_NODE ) {
                            if ( currentNode.nodeName === 'SPAN' ) {
                                nodesToSkip = currentNode.childNodes.length;
                                const letters = currentNode.textContent;
                                // If it's a space, preserve it explicitly
                                const displayText = letters === " " ? "\u00A0" : letters; // non-breaking space
                                word.letters += displayText;
                            }
                        } else if ( currentNode.nodeType == Node.TEXT_NODE ) {
                            const letters = currentNode.textContent;
                            const displayText = letters === " " ? "\u00A0" : letters; // non-breaking space
                            word.letters += displayText;
                        }

                        currentNode = nodeWalker.nextNode();
                    }
                }

                if ( word.letters <= 0 ) { word.letters = "\u00A0" }

                circleProps.words[wordPosAsInt] = word ;
                circleProps.font.fontFamily = fontFamilyOfText;
                circleProps.font.fontSize = fontSizeAsFloat;
                circleProps.font.fontWeight = fontWeight;
                circleProps.font.fontColor = colorOfText;
                circleProps.font.charSpacing = calculatedCharSpacing;
                circleProps.font.lineHeight = fontLineHeightAsFloat;
                circleProps.font.fontCase = currentCase;
                circleProps.circle.radius = radiusAsFloat;
                circleProps.circle.startingAngleOffset = startingAngleAsFloat;
                circleProps.currentFabricProps = null;
                circleProps.currentFabricProps = fabricPropsParsed;
            }

            // now get the gemstones that behave like words
            const gemstoneContainers = formWrapper
                ? formWrapper.querySelectorAll('.embeded-gemstone-container.circle-pendant')
                : document.querySelectorAll( `[data-option="${circleProps.side}"] .embeded-gemstone-container.circle-pendant` );
            for ( let i = 0; i < gemstoneContainers.length; i++ ) {
                const container = gemstoneContainers[i];
                const gemstoneImageSelected = container.querySelector( '[data-option-selected] .swatch .gemstone-image' );
                const firstGemstoneOptionWithProps = container.querySelector( '[data-word-pos]' );

                if ( firstGemstoneOptionWithProps != null ) {
                    const positionInArray = parseInt( firstGemstoneOptionWithProps.getAttribute( 'data-word-pos' ) );
                    const newWord = {
                        pos: positionInArray,
                        letters: "{{GEMSTONE}}",
                        imageUrlToUse: gemstoneImageSelected.getAttribute( 'src' )
                    }

                    circleProps.words[positionInArray] = newWord ;
                }
            }

            if ( personalizeDrawerManager.debug ) {
                console.log('Circle Props Words', circleProps.words)
            }

            if ( circleProps.words.length > 0 ) {
                circleProps.circle.arcCount = circleProps.words.length,
                circleProps.circle.anglePerArc = circleProps.circle.arcCount === 1 ? 359.9 : 360 / circleProps.circle.arcCount;
                circleProps.circle.groupCenterX = circleProps.currentFabricProps.left;
                circleProps.circle.groupCenterY = circleProps.currentFabricProps.top;
                
                const groupItems = [];
                for ( let i = 0; i < circleProps.circle.arcCount; i++ ) {
                    const xAxisRotation = 0;
                    const sweepFlag = 1;
                    const largeArcFlag = circleProps.circle.anglePerArc > 180 ? 1 : 0;

                    const startAngleDeg = i * circleProps.circle.anglePerArc + circleProps.circle.startingAngleOffset;
                    const endAngleDeg = startAngleDeg + circleProps.circle.anglePerArc;

                    const startRad = ( Math.PI / 180 ) * startAngleDeg;
                    const endRad = ( Math.PI / 180 ) * endAngleDeg;

                    const x1 = circleProps.circle.cx + circleProps.circle.radius * Math.cos( startRad );
                    let y1 = circleProps.circle.cy + circleProps.circle.radius * Math.sin( startRad );

                    const x2 = circleProps.circle.cx + circleProps.circle.radius * Math.cos( endRad );
                    let y2 = circleProps.circle.cy + circleProps.circle.radius * Math.sin( endRad );
                    
                    if ( y1 == y2 ) {
                        y2 = y1 - 0.001;
                    }

                    const pathData = `
                        M ${x1} ${y1}
                        A ${circleProps.circle.radius} ${circleProps.circle.radius} ${xAxisRotation} ${largeArcFlag} ${sweepFlag} ${x2} ${y2}
                    `;

                    let stroke = 'transparent';
                    const localDebug = personalizeDrawerManager.debug;
                    if ( localDebug ) {
                        stroke = circleProps.debug.debugColors[ circleProps.debug.debugColorIndex % circleProps.debug.debugColors.length ]
                        circleProps.debug.debugColorIndex++;
                    }

                    const pathProps = {
                        stroke: stroke,
                        fill: '',
                        visible: true,
                        originX: 'center',
                        originY: 'center',
                    };

                    const path = new fabric.Path( pathData.trim() , pathProps );
                    const bounds = path.getBoundingRect();

                    const word = circleProps.words[ i ].letters;
                    if ( word != "{{GEMSTONE}}" ) {
                        const textProps = {
                            fontFamily: circleProps.font.fontFamily,
                            fill: circleProps.font.fontColor,
                            fontWeight: circleProps.font.fontWeight,
                            lineHeight: circleProps.font.lineHeight,
                            fontSize: circleProps.font.fontSize,
                            charSpacing: circleProps.font.charSpacing,
                            textAlign: 'center',
                            path: path,
                            left: bounds.left,
                            top: bounds.top,
                            originX: 'left',
                            originY: 'top',
                            pathAlign: 'center', // aligns to the center of the arc drawn
                        };

                        let letters = word;
                        if ( circleProps.font.fontCase === 'uppercase' ) {
                            letters = letters.toUpperCase();
                        } else if ( circleProps.font.fontCase === 'lowercase' ) {
                            letters = letters.toLowerCase();
                        }

                        const text = new fabric.Text( letters , textProps );
                        const availableArcLength = circleProps.circle.radius * (circleProps.circle.anglePerArc * Math.PI / 180) * 0.9;
                        const renderedTextWidth = text.calcTextWidth();

                        if ( circleProps.words[i].fitToArc && renderedTextWidth > availableArcLength && availableArcLength > 0 ) {
                            const fittedFontSize = circleProps.font.fontSize * (availableArcLength / renderedTextWidth);
                            text.set('fontSize', fittedFontSize);
                            text.initDimensions();
                        }

                        groupItems.push( text );
                    } 
                    else if ( word == "{{GEMSTONE}}" ) {
                        const gemstoneWidth = 30;
                        const gemstoneHeight = 30;
                        const midAngleDeg = startAngleDeg + circleProps.circle.anglePerArc / 2;
                        const midAngleRad = (Math.PI / 180) * midAngleDeg;
                        const midX = circleProps.circle.cx + circleProps.circle.radius * Math.cos( midAngleRad );
                        const midY = circleProps.circle.cy + circleProps.circle.radius * Math.sin( midAngleRad );
                        const gemstoneImagePlaceholder = "https://cdn.shopify.com/s/files/1/0738/3341/4879/files/gemstone-filler.png?v=1750359855";
                        const imageToUse = circleProps.words[ i ].imageUrlToUse ?? gemstoneImagePlaceholder;

                        const placeholder = new fabric.Circle({
                            radius: gemstoneWidth / 2,
                            fill: '#0000004d',
                            originX: 'center',
                            originY: 'center',
                            left: midX,
                            top: midY,
                            selectable: false,
                            evented: false,
                            _imageData: {
                                imageToUse: imageToUse,
                                gemstoneWidth: gemstoneWidth,
                                gemstoneHeight: gemstoneHeight
                            }
                        });

                        groupItems.push( placeholder );
                    }
                }

                if ( personalizeDrawerManager.debug ) {
                    console.log( '[updateFabricCanvas()] Calculated circle props: ' , circleProps );
                    console.log( '[updateFabricCanvas()] Canvas Group Items: ' , groupItems );
                }  

                const group = new fabric.Group( groupItems , {
                    left: circleProps.circle.groupCenterX,
                    top: circleProps.circle.groupCenterY,
                    lockMovementX: true,
                    lockMovementY: true,
                    lockRotation: true,
                    lockScalingFlip: true,
                    lockScalingX: true,
                    lockScalingY: true,
                    lockSkewingX: true,
                    lockSkewingY: true,
                    controls: null
                });

                // the flashing occurs because we remove all canvas elements every rerender. 
                // when we add back in we are waiting for the image load event to finish. 
                // Instead we are going to load a placeholder and replace that as soon as img loads
                
                editor.canvas.add( group );
                editor.canvas.renderAll();

                const gemstoneImagePromises = [];
                group.getObjects().forEach(( obj ) => {
                    const imageData = obj["_imageData"];
                    if ( imageData ) {
                        const gemstoneImagePromise = new Promise(( resolve ) => {
                          fabric.Image.fromURL( imageData.imageToUse , ( image ) => {
                            if ( !image ) {
                                resolve();
                                return;
                            }

                            personalizeDrawerManager.scaleImageToFitCanvas( image , imageData.gemstoneWidth , imageData.gemstoneHeight );

                            const relX = obj.left;
                            const relY = obj.top;

                            image.set({
                                originX: 'center',
                                originY: 'center',
                                left: relX,
                                top: relY,
                                selectable: false,
                                evented: false,
                            });

                            // IMPORTANT: use the LIVE index at replacement time
                            const liveIndex = group._objects.indexOf(obj);
                            if (liveIndex === -1) {
                                resolve();
                                return;
                            }

                            // splice the image IN so others shift right
                            group.insertAt( image, liveIndex );

                            // remove the original placeholder (it shifted to liveIndex + 1)
                            group.remove( obj );
                            editor.canvas.requestRenderAll();
                            resolve();
                          }, { crossOrigin: 'Anonymous' });
                        });
                        gemstoneImagePromises.push(gemstoneImagePromise);
                    }
                })

                await Promise.all(gemstoneImagePromises);
                editor.canvas.requestRenderAll();
            }
            
            editor.canvas.renderAll();
            
        },
        // toggle between the front and back forms
        handleTabToggle: function ( event ) {
            let tabClicked = event.target;
            const allTabs = document.querySelectorAll('.personalize-tab');
            const frontWrapper = document.querySelector('.option-wrapper[data-option="front"]');
            const backWrapper = document.querySelector('.option-wrapper[data-option="back"]');

            if ( !tabClicked.classList.contains('personalize-tab') ) {
                tabClicked = tabClicked.closest('.personalize-tab');
            }

            if ( !tabClicked.classList.contains('active') ) {
                tabClicked.classList.add('active');

                if ( frontWrapper != null && backWrapper != null ) {
                    if ( tabClicked.getAttribute('data-tab') == 'front' ) {
                        if ( frontWrapper.classList.contains('hidden') ) {
                            frontWrapper.classList.remove('hidden');
                        }
                        if ( !backWrapper.classList.contains('hidden') ) {
                            backWrapper.classList.add('hidden')
                        }
                    } else if ( tabClicked.getAttribute('data-tab') == 'back' ) {
                        if ( !frontWrapper.classList.contains('hidden') ) {
                            frontWrapper.classList.add('hidden');
                        }
                        if ( backWrapper.classList.contains('hidden') ) {
                            backWrapper.classList.remove('hidden')
                        }
                    }
                }
            }

            for ( let tab of allTabs ) {
                if ( tab != tabClicked && tab.classList.contains('active') ) {
                    tab.classList.remove('active')
                }
            }
        },
        // add the characters and counts to the characterCounts object. The character or img scr are the key and the count is the value
        storeCharacterCounts: function () {
            const characters = document.querySelectorAll(".symbol-button");

            for ( let char of characters ) {
                let name = char.getAttribute('data-symbol-character');
                let count = parseInt(char.getAttribute('data-character-space'));
                personalizeDrawerManager.characterCounts[name] = count;
            }

            const gemButton = document.querySelectorAll('.gemstone-button');

            for ( let gem of gemButton ) {
                let name = gem.getAttribute('data-gemstone-url');
                let count = 1;
                personalizeDrawerManager.characterCounts[name] = count;
            }
        },
        // get the selects and add change events
        handleGemstoneComponent: function () {
            const gemComponentDropdowns = document.querySelectorAll('.focusable-dropdown-button-main-component');
            const gemstoneSelectors = document.querySelectorAll(`.dropdown-options-list .option[data-position="front"]`);
            const backGemstoneSelectors = document.querySelectorAll(`.dropdown-options-list .option[data-position="back"]`)

            for ( const dropdownBnt of gemComponentDropdowns ) {
                dropdownBnt.removeEventListener('click', personalizeDrawerManager.handleGemDropdownToggle.bind( null, '.embeded-gemstone-container' ));
                dropdownBnt.addEventListener('click', personalizeDrawerManager.handleGemDropdownToggle.bind( null, '.embeded-gemstone-container' ));
            }

            for ( let selector of gemstoneSelectors ) {
                const canvasId = selector.getAttribute('data-canvas')
                // add change event listener that will add gemstone to fabricjs
                const container = selector.closest('.embeded-gemstone-container');
                if ( container != null ) {
                    let fabricProps = JSON.parse(container.getAttribute('data-fabric-props'));

                    selector.removeEventListener('click', personalizeDrawerManager.handleGemComponenetLiClick.bind( null, 'front', fabricProps, canvasId ))
                    selector.addEventListener('click', personalizeDrawerManager.handleGemComponenetLiClick.bind( null, 'front', fabricProps, canvasId ))
                }
            }

            for ( let selector of backGemstoneSelectors ) {
                const canvasId = selector.getAttribute('data-canvas')
                // add change event listener that will add gemstone to fabricjs
                const container = selector.closest('.embeded-gemstone-container');
                if ( container != null ) {
                    let fabricProps = JSON.parse(container.getAttribute('data-fabric-props'));

                    selector.removeEventListener('click', personalizeDrawerManager.handleGemComponenetLiClick.bind( null, 'back', fabricProps, canvasId ))
                    selector.addEventListener('click', personalizeDrawerManager.handleGemComponenetLiClick.bind( null, 'back', fabricProps, canvasId ))
                }
            }
        },
        handleChange: function ( imgUrl, canvasId, props ) {
            const editor = personalizeDrawerManager.fabricMap[canvasId];
            const canvas = editor.canvas;

            const noMutProps = JSON.parse(props);
            const scaledProps = noMutProps;

            if (editor.imageLayer) {
                // Replace the image content but keep properties like position, scale
                fabric.util.loadImage(imgUrl, function (imgEl) {
                    editor.imageLayer.setElement(imgEl);
                    canvas.requestRenderAll();
                });
            } else {
                // First-time insert
                fabric.Image.fromURL(imgUrl, function (img) {
                    img.set({
                        ...scaledProps,
                        data: {role: 'gemstone'}
                    });
                    canvas.add(img);
                    editor.imageLayer = img;
                    canvas.requestRenderAll();
                }, { crossOrigin: 'Anonymous' });
            }

            personalizeDrawerManager.validateFormAndReturnFormData();
        },
        handleCirclePendantItems: function ( sideName, itemIndex ) {
            const edDivs = document.querySelectorAll(`[contenteditable][data-canvas="${sideName}-${itemIndex}"]`);

            // circle pendant ONLY events
            const circleLowercaseBtn = document.querySelector('.circle-pendant-text-case-align[data-case="lowercase"]');
            const circleUppercaseBtn = document.querySelector('.circle-pendant-text-case-align[data-case="uppercase"]');
            const circleMixedcaseBtn = document.querySelector('.circle-pendant-text-case-align[data-case="mixed"]');

            if ( circleLowercaseBtn != null ) {
                circleLowercaseBtn.removeEventListener('click', personalizeDrawerManager.handleCaseButtonClickCirclePendants.bind(null, 'data-lowercase-max', 'lowercase', circleUppercaseBtn, circleMixedcaseBtn, edDivs));
                circleLowercaseBtn.addEventListener('click', personalizeDrawerManager.handleCaseButtonClickCirclePendants.bind(null, 'data-lowercase-max', 'lowercase', circleUppercaseBtn, circleMixedcaseBtn, edDivs));
            }

            if (circleUppercaseBtn != null ) {
                circleUppercaseBtn.removeEventListener('click', personalizeDrawerManager.handleCaseButtonClickCirclePendants.bind(null, 'data-uppercase-max', 'uppercase', circleLowercaseBtn, circleMixedcaseBtn, edDivs));
                circleUppercaseBtn.addEventListener('click', personalizeDrawerManager.handleCaseButtonClickCirclePendants.bind(null, 'data-uppercase-max', 'uppercase', circleLowercaseBtn, circleMixedcaseBtn, edDivs));
            }

            if ( circleMixedcaseBtn != null ) {
                circleMixedcaseBtn.removeEventListener('click', personalizeDrawerManager.handleCaseButtonClickCirclePendants.bind(null, 'data-mixed-max', 'mixed', circleLowercaseBtn, circleUppercaseBtn, edDivs));
                circleMixedcaseBtn.addEventListener('click', personalizeDrawerManager.handleCaseButtonClickCirclePendants.bind(null, 'data-mixed-max', 'mixed', circleLowercaseBtn, circleUppercaseBtn, edDivs));
            }
        },
        // add event listeners to the divs and all of the buttons that affect individual divs
        handleEditableDivs: function ( sideName, itemIndex ) {
            const edDivs = document.querySelectorAll(`[contenteditable][data-canvas="${sideName}-${itemIndex}"]`);

            for ( let editableDiv of edDivs ) {
                const parentElement = editableDiv.closest('.text-field-and-option-wrapper')
                const lowercaseBtn = parentElement.querySelector('.text-case-align[data-case="lowercase"]');
                const uppercaseBtn = parentElement.querySelector('.text-case-align[data-case="uppercase"]');
                const mixedcaseBtn = parentElement.querySelector('.text-case-align[data-case="mixed"]')
                const charButtons = parentElement.querySelectorAll('.symbol-button');
                const leftAlignBtn = parentElement.querySelector('.alignment-button[data-align-name="left"]');
                const centerAlignBtn = parentElement.querySelector('.alignment-button[data-align-name="center"]');
                const rightAlignBtn = parentElement.querySelector('.alignment-button[data-align-name="right"]');
                const gemButtons = parentElement.querySelectorAll('.gemstone-button');
                const gemDropdowns = parentElement.querySelectorAll('.focusable-dropdown-button-main');
                const gemDropdownListOptions = parentElement.querySelectorAll('.focusable-dropdown-button-list-item');
                const charCounter = parentElement.querySelector('.input-counter');
                const maxSpan = parentElement.querySelector('.input-max-count');

                let maxLength = 0
                if ( editableDiv.classList.contains('lowercase') ) {
                    maxLength = parseInt(editableDiv.getAttribute('data-lowercase-max'), 10);
                } else if ( editableDiv.classList.contains('uppercase') ) {
                    maxLength = parseInt(editableDiv.getAttribute('data-uppercase-max'), 10);
                } else {
                    maxLength = parseInt(editableDiv.getAttribute('data-mixed-max'), 10);
                }
              
                // keep track of caret position for each div
                ['keyup', 'mouseup', 'touchend', 'input', 'click', 'focus'].forEach(evt => {
                    editableDiv.addEventListener(evt, () => {
                        personalizeDrawerManager.saveSelection(editableDiv);
                    });
                });

                editableDiv.removeEventListener("beforeinput", personalizeDrawerManager.handleBeforeInput.bind(null, editableDiv, edDivs, charCounter));
                editableDiv.removeEventListener("paste", personalizeDrawerManager.handlePaste.bind(null, editableDiv, edDivs, charCounter));

                editableDiv.addEventListener("beforeinput", personalizeDrawerManager.handleBeforeInput.bind(null, editableDiv, edDivs, charCounter));
                editableDiv.addEventListener("paste", personalizeDrawerManager.handlePaste.bind(null, editableDiv, edDivs, charCounter));

                // add events for font case buttons
                if ( lowercaseBtn != null ) {
                    lowercaseBtn.removeEventListener('click', personalizeDrawerManager.handleCaseButtonClick.bind(null, editableDiv, 'data-lowercase-max', 'lowercase', uppercaseBtn, mixedcaseBtn, maxSpan, edDivs, charCounter));
                    lowercaseBtn.addEventListener('click', personalizeDrawerManager.handleCaseButtonClick.bind(null, editableDiv, 'data-lowercase-max', 'lowercase', uppercaseBtn, mixedcaseBtn, maxSpan, edDivs, charCounter));
                }

                if (uppercaseBtn != null ) {
                    uppercaseBtn.removeEventListener('click', personalizeDrawerManager.handleCaseButtonClick.bind(null, editableDiv, 'data-uppercase-max', 'uppercase', lowercaseBtn, mixedcaseBtn, maxSpan, edDivs, charCounter));
                    uppercaseBtn.addEventListener('click', personalizeDrawerManager.handleCaseButtonClick.bind(null, editableDiv, 'data-uppercase-max', 'uppercase', lowercaseBtn, mixedcaseBtn, maxSpan, edDivs, charCounter));
                }

                if ( mixedcaseBtn != null ) {
                    mixedcaseBtn.removeEventListener('click', personalizeDrawerManager.handleCaseButtonClick.bind(null, editableDiv, 'data-mixed-max', 'mixed', lowercaseBtn, uppercaseBtn, maxSpan, edDivs, charCounter));
                    mixedcaseBtn.addEventListener('click', personalizeDrawerManager.handleCaseButtonClick.bind(null, editableDiv, 'data-mixed-max', 'mixed', lowercaseBtn, uppercaseBtn, maxSpan, edDivs, charCounter));
                }

                // add event listeners for alignment buttons
                if ( leftAlignBtn != null ) {
                    leftAlignBtn.removeEventListener('click', personalizeDrawerManager.handleAlignButtonClick.bind( null, "left", centerAlignBtn, rightAlignBtn, editableDiv, edDivs, charCounter ));
                    leftAlignBtn.addEventListener('click', personalizeDrawerManager.handleAlignButtonClick.bind( null, "left", centerAlignBtn, rightAlignBtn, editableDiv, edDivs, charCounter ));
                }

                if ( centerAlignBtn != null ) {
                    centerAlignBtn.removeEventListener('click', personalizeDrawerManager.handleAlignButtonClick.bind( null, "center", leftAlignBtn, rightAlignBtn, editableDiv, edDivs, charCounter ));
                    centerAlignBtn.addEventListener('click', personalizeDrawerManager.handleAlignButtonClick.bind( null, "center", leftAlignBtn, rightAlignBtn, editableDiv, edDivs, charCounter ));
                }

                if ( rightAlignBtn != null ) {
                    rightAlignBtn.removeEventListener('click', personalizeDrawerManager.handleAlignButtonClick.bind( null, "right", leftAlignBtn, centerAlignBtn, editableDiv, edDivs, charCounter ));
                    rightAlignBtn.addEventListener('click', personalizeDrawerManager.handleAlignButtonClick.bind( null, "right", leftAlignBtn, centerAlignBtn, editableDiv, edDivs, charCounter ));
                }

                for ( const btn of charButtons ) {
                    // Clean up old handlers if they exist
                    if (btn._charClickHandler) {
                        btn.removeEventListener('click', btn._charClickHandler);
                    }
                    if (btn._charPointerDownHandler) {
                        btn.removeEventListener('pointerdown', btn._charPointerDownHandler);
                    }

                    // Prevent button from stealing focus on mobile
                    btn._charPointerDownHandler = (e) => {
                        e.preventDefault(); // keeps focus/caret in the editable div
                    };
                    btn.addEventListener('pointerdown', btn._charPointerDownHandler);

                    // Bind handler to THIS specific editableDiv
                    btn._charClickHandler = personalizeDrawerManager.handleCharacterButtonClick.bind(
                        personalizeDrawerManager,
                        maxLength,
                        editableDiv, 
                        edDivs,
                        charCounter
                    );

                    btn.addEventListener('click', btn._charClickHandler);
                    // btn.removeEventListener('click', personalizeDrawerManager.handleCharacterButtonClick.bind( null, maxLength, editableDiv, edDivs, charCounter));
                    // btn.addEventListener('click', personalizeDrawerManager.handleCharacterButtonClick.bind( null, maxLength, editableDiv, edDivs, charCounter));
                }

                for ( const btn of gemButtons ) {
                    // Clean up any old handlers on this button
                    if (btn._gemClickHandler) {
                        btn.removeEventListener('click', btn._gemClickHandler);
                    }
                    if (btn._gemPointerDownHandler) {
                        btn.removeEventListener('pointerdown', btn._gemPointerDownHandler);
                    }

                    // Prevent the button from stealing focus on mobile
                    btn._gemPointerDownHandler = (e) => {
                        e.preventDefault(); // keeps caret in the editable div
                    };
                    btn.addEventListener('pointerdown', btn._gemPointerDownHandler);

                    // Bind this gem button to THIS specific editableDiv
                    btn._gemClickHandler = personalizeDrawerManager.handleGemButtonClick.bind(
                        personalizeDrawerManager,
                        editableDiv,  // this div only
                        edDivs,
                        charCounter
                    );

                    btn.addEventListener('click', btn._gemClickHandler);
                    // btn.removeEventListener('click', personalizeDrawerManager.handleGemButtonClick.bind( null, editableDiv, edDivs, charCounter));
                    // btn.addEventListener('click', personalizeDrawerManager.handleGemButtonClick.bind( null, editableDiv, edDivs, charCounter));
                }

                for ( const dropdownBnt of gemDropdowns ) {
                    dropdownBnt.removeEventListener('click', personalizeDrawerManager.handleGemDropdownToggle.bind( null, '.gemstone-container' ));
                    dropdownBnt.addEventListener('click', personalizeDrawerManager.handleGemDropdownToggle.bind( null, '.gemstone-container' ));
                }

                for ( const btn of gemDropdownListOptions ) {
                    btn.removeEventListener('click', personalizeDrawerManager.handleGemLiClick.bind( null, editableDiv, edDivs, charCounter))
                    btn.addEventListener('click', personalizeDrawerManager.handleGemLiClick.bind( null, editableDiv, edDivs, charCounter))
                }
            }
        },
        // click event for alignment buttons
        handleAlignButtonClick: function ( alignment, otherAlignBtn1, otherAlignBtn2, editableDiv, editableDivs, charCounter, e ) {
            const btn = e.currentTarget;
            editableDiv.setAttribute('data-font-align', alignment);

            personalizeDrawerManager.handleCaseToggle(btn, otherAlignBtn1, otherAlignBtn2)
           
            // update counter & fabric canvas text
            personalizeDrawerManager.updateCharCount(editableDiv, editableDivs, charCounter, true , null )
        },
        // click event for icon buttons
        handleCharacterButtonClick: function( maxLength, editableDiv, editableDivs, charCounter, e ) {
            e.preventDefault();
            e.stopPropagation();

            const btn = e.currentTarget;
            const char = btn.getAttribute('data-symbol-character');
            const charCount = parseInt(btn.getAttribute('data-character-space'), 10);
            const type = btn.getAttribute('data-symbol-type');
            
            // don't do anything if the count exceeds the max length
            const currentCase = personalizeDrawerManager.fetchCurrentCase( editableDiv );
            const currentMaxLength = parseInt( personalizeDrawerManager.fetchCurrentMaxLength( editableDiv , currentCase ) );
            const currentCount = personalizeDrawerManager.updateCharCount( editableDiv, editableDivs, charCounter, false , null );
            
            // don't add character if there is not enough space for it.  some characters require more than 1 space
            if ( currentCount + charCount > currentMaxLength ) {
                e.preventDefault();
                return
            }
        
            // add text characters to div
            if ( type == 'text' ) {
                let charcter = personalizeDrawerManager.normalizeHearts(char)
                personalizeDrawerManager.insertElementAtCursor( 'span', null, charcter, null, charCount, currentMaxLength, editableDiv, charCounter, editableDivs );
            // add images to div    
            } else if ( type == 'image' ) {
                const imgUrl = char;
                const alt = btn.getAttribute('data-symbol-name');
                personalizeDrawerManager.insertElementAtCursor( 'img', 'other', imgUrl, alt, charCount, currentMaxLength, editableDiv, charCounter, editableDivs );
            }
        },
        splitSpanIfNeeded: function (range, editableDiv) {
            const container = range.startContainer;

            // caret is inside a TEXT NODE inside a span
            if ( container.nodeType === Node.TEXT_NODE && container.parentNode && container.parentNode.tagName === 'SPAN' && editableDiv.contains(container.parentNode) ) {
                const span = container.parentNode;
                const text = container.textContent || '';
                const offset = range.startOffset;

                // Caret at very start of the span
                if (offset <= 0) {
                    const newRange = document.createRange();
                    newRange.setStartBefore(span);
                    newRange.collapse(true);
                    return newRange;
                }

                // Caret at very end of the span
                if (offset >= text.length) {
                    const newRange = document.createRange();
                    newRange.setStartAfter(span);
                    newRange.collapse(true);
                    return newRange;
                }

                // Caret is in the MIDDLE of the text
                const beforeText = text.slice(0, offset);
                const afterText = text.slice(offset);

                const beforeSpan = document.createElement('span');
                beforeSpan.textContent = beforeText;

                const afterSpan = document.createElement('span');
                afterSpan.textContent = afterText;

                const parent = span.parentNode;

                parent.insertBefore(beforeSpan, span);
                parent.insertBefore(afterSpan, span.nextSibling);
                parent.removeChild(span);

                const newRange = document.createRange();
                newRange.setStartAfter(beforeSpan);
                newRange.collapse(true);
                return newRange;
            }

            // caret is directly inside a <span> element
            if ( container.nodeType === Node.ELEMENT_NODE && container.tagName === 'SPAN' && editableDiv.contains(container) ) {
                const newRange = document.createRange();
                newRange.setStartAfter(container);
                newRange.collapse(true);
                return newRange;
            }

            return range;
        },
        // handles inserting the text or image at cursor in div
        insertElementAtCursor: function ( elementType, imageType, data, alt, charCountForImage, maxLength, editableDiv, charCounter, editableDivs ) {

            const temp = editableDiv.cloneNode(true);
            const currentCount = personalizeDrawerManager.getCharacterCountFromNodes( temp, editableDiv )
            if ( currentCount + charCountForImage > maxLength ) {
                return;
            }

            let elementToAdd = null;
            if ( elementType == 'img' ) {
                const img = document.createElement("img");
                img.src = data;
                img.setAttribute( "data-char-count", charCountForImage );
                if ( imageType != null ) {
                    img.setAttribute('data-symbol-type', imageType)
                }
                img.alt = alt;
                elementToAdd = img;
            } else if ( elementType == 'span' ) {
                const span = document.createElement("span");
                span.setAttribute( 'data-symbol-char' , data );
                span.setAttribute( "data-char-count", charCountForImage );
                span.setAttribute( "contenteditable", "false" );
                span.setAttribute( "data-value", data )
                let innerTxt = this.normalizeHearts(data)
                span.innerHTML = innerTxt;
                elementToAdd = span;
            }

            const sel = window.getSelection();

            // Decide which range to use for THIS div
            let rangeToUse = null;

            // use the saved range for this div
            const savedRange = personalizeDrawerManager.getSelectionForEditable(editableDiv);
            if ( savedRange ) {
                rangeToUse = savedRange.cloneRange();
            } else if ( sel && sel.rangeCount > 0 ) {
                // If we don't have a saved range but the live selection is inside this div, use that
                const liveRange = sel.getRangeAt(0);
                if ( editableDiv.contains(liveRange.startContainer) ) {
                    rangeToUse = liveRange.cloneRange();
                }
            }

            // if we don't have a range still, put the caret at the end of this div
            if (!rangeToUse) {
                rangeToUse = document.createRange();
                rangeToUse.selectNodeContents(editableDiv);
                rangeToUse.collapse(false); 
            }

            if (!sel) return;

            rangeToUse = this.splitSpanIfNeeded(rangeToUse, editableDiv);

            sel.removeAllRanges();
            sel.addRange(rangeToUse);
            
            if ( sel.baseNode != editableDiv ) {
                const range = document.createRange();  
                sel.removeAllRanges();  
                range.selectNodeContents(editableDiv);  
                range.collapse(false);  
                sel.addRange(range);  
            }
            editableDiv.focus();

            let node;
            if (elementType === 'span') {
                node = document.createElement('span');
                node.textContent = data || '';
            } else if (elementType === 'img') {
                node = document.createElement('img');
                node.src = data;      
                node.alt = alt || '';
                node.setAttribute( "data-char-count", charCountForImage );
                if (imageType) {
                    node.setAttribute('data-symbol-type', imageType); 
                }
            }

            // insert at the determined range
            rangeToUse.insertNode(node);

            // Move caret after the inserted node
            rangeToUse.setStartAfter(node);
            rangeToUse.collapse(true);

            sel.removeAllRanges();
            sel.addRange(rangeToUse);

            // save selection for THIS editable div so the next button click works
            this.saveSelection(editableDiv);

            personalizeDrawerManager.updateCharCount(editableDiv, editableDivs, charCounter , true , null );
        },
        // click event for gemstone buttons
        handleGemButtonClick: function ( editableDiv, editableDivs, charCounter, e ) {
            const btn = e.currentTarget;
            const imgUrl = btn.getAttribute('data-gemstone-url');
            const charCount = 1;
            const parentContainer = btn.closest('.gemstone-container');
            let limit = 1;
            if ( parentContainer != null ) {
                let incomingLimit = parentContainer.getAttribute('data-limit');
                if ( incomingLimit != null ) {
                    limit = parseInt(incomingLimit)
                }
            }

            const temp = editableDiv.cloneNode(true);
            const count = personalizeDrawerManager.getGemstoneCountFromNodes(temp);

            if ( count >= limit ) {
                return
            }

        
            const currentCount = personalizeDrawerManager.updateCharCount(editableDiv, editableDivs, charCounter, false , null );
            const currentCase = personalizeDrawerManager.fetchCurrentCase( editableDiv );
            const maxLength = personalizeDrawerManager.fetchCurrentMaxLength( editableDiv, currentCase )

            // don't add character if there is not enough space for it.  some characters require more than 1 space
            if ( currentCount + charCount > maxLength ) {
                return
            }
    
            const alt = btn.getAttribute('data-gemstone-name');
            personalizeDrawerManager.insertElementAtCursor( 'img', 'gemstone', imgUrl, alt, charCount, maxLength, editableDiv, charCounter, editableDivs );
        },
        handleAddGem: function ( editableDiv, editableDivs, charCounter, imgUrl, alt ) {
            const charCount = 1;
            const currentCount = personalizeDrawerManager.updateCharCount(editableDiv, editableDivs, charCounter, false , null );
            const currentCase = personalizeDrawerManager.fetchCurrentCase( editableDiv );
            const maxLength = personalizeDrawerManager.fetchCurrentMaxLength( editableDiv, currentCase )

            // don't add character if there is not enough space for it.  some characters require more than 1 space
            if ( currentCount + charCount > maxLength ) {
                return
            }
    
            personalizeDrawerManager.insertElementAtCursor( 'img', 'gemstone', imgUrl, alt, charCount, maxLength, editableDiv, charCounter, editableDivs );
        },
        resetGemstoneSelect: function ( displayBtn ) {
            if ( displayBtn != null ) {
                const image = displayBtn.querySelector('.gemstone-image');
                if ( image != null ) {
                    image.setAttribute('src', "");
                    image.setAttribute('alt', ``)
                    image.classList.add('hidden')
                }

                const title = displayBtn.querySelector('.title');
                if ( title != null ) {
                    title.innerText = 'Add a Gemstone'
                }
            }
        },
        handleGemLiClick: function ( editableDiv, editableDivs, charCounter, e ) {
            const btn = e.currentTarget;
            const li = btn.closest('.option');
            if ( li != null ) {
                const imgUrl = li.getAttribute('data-gemstone-url');
                const alt = li.getAttribute('data-gemstone-name');

                const parentContainer = li.closest('.gemstone-container');
                let limit = 1;
                if ( parentContainer != null ) {
                    let incomingLimit = parentContainer.getAttribute('data-limit');
                    if ( incomingLimit != null ) {
                        limit = parseInt(incomingLimit)
                    }

                    // update the button
                    let displayBtn = parentContainer.querySelector('.focusable-dropdown-button-main');
                    if ( displayBtn != null ) {
                        const image = displayBtn.querySelector('.gemstone-image');
                        if ( image != null ) {
                            image.setAttribute('src', imgUrl);
                            image.setAttribute('alt', `${alt} gemstone swatch`)
                            image.classList.remove('hidden')
                        }

                        const title = displayBtn.querySelector('.title');
                        if ( title != null ) {
                            title.innerText = alt
                        }
                    }

                    const listContainer = parentContainer.querySelector('.dropdown-options-list');
                    if ( listContainer != null ) {
                        listContainer.classList.remove('active')
                    }
                    const temp = editableDiv.cloneNode(true);
                    const count = personalizeDrawerManager.getGemstoneCountFromNodes(temp);
    
                    
                    if ( count >= limit ) {
                        personalizeDrawerManager.resetGemstoneSelect(displayBtn)
                        return
                    }
                    
                    if ( count < limit && personalizeDrawerManager.gemstoneUiData.inline.type != 'swatches' && personalizeDrawerManager.gemstoneUiData.inline.runType == 'auto' ) {
                        personalizeDrawerManager.handleAddGem(editableDiv, editableDivs, charCounter, imgUrl, alt)
                        
                        setTimeout(() => {
                            personalizeDrawerManager.resetGemstoneSelect(displayBtn)
                        }, 1000)
                    }               
                }
                
            }
        

        },
        handleGemComponenetLiClick: function ( editableDiv, editableDivs, charCounter, e ) {
            const li = e.currentTarget;
            if ( li != null ) {
                const imgUrl = li.getAttribute('data-gemstone-url');
                const alt = li.getAttribute('data-gemstone-name');

                const parentContainer = li.closest('.embeded-gemstone-container');
                if ( parentContainer != null ) {
                    // update the button
                    let displayBtn = parentContainer.querySelector('.focusable-dropdown-button-main-component');
                    if ( displayBtn != null ) {
                        const image = displayBtn.querySelector('.gemstone-image');
                        if ( image != null ) {
                            image.setAttribute('src', imgUrl);
                            image.setAttribute('alt', `${alt} gemstone swatch`)
                            image.classList.remove('hidden')
                        }

                        const title = displayBtn.querySelector('.title');
                        if ( title != null ) {
                            title.innerText = alt
                        }
                    }

                    const listContainer = parentContainer.querySelector('.dropdown-options-list');
                    if ( listContainer != null ) {
                        listContainer.classList.remove('active')
                    }

                    const radius = li.getAttribute('data-radius');
                    const props = parentContainer.getAttribute('data-fabric-props');
                    const canvasId = li.getAttribute('data-canvas');

                    if ( radius == null || radius == '{{radius}}' ) {
                        personalizeDrawerManager.handleChange( imgUrl, canvasId, props )
                    } else {
                        // try to find an editable div / editable divs for the related gemstone dropdown
                        const allInutFieldsWrapper = parentContainer.closest( '.fields-wrapper' );
                        let updatedEditableDivs = [];
                        if ( allInutFieldsWrapper != null ) {
                            updatedEditableDivs = allInutFieldsWrapper.querySelectorAll( '.input-field' );
                        }

                        // trigger reload of canvas
                        personalizeDrawerManager.updateCharCount( null, updatedEditableDivs, null, true , parentContainer );
                    }
                }
            }
        

        },
        handleGemDropdownToggle: function ( parentClass, e ) {
            const btn = e.currentTarget;
            const parentContainer = btn.closest(parentClass);

            if ( parentContainer != null ) {
                let listbox = parentContainer.querySelector('.dropdown-options-list');
                 if ( listbox != null ) {
                    listbox.classList.toggle('active');
                 }
            }
        },
        handleCaseButtonClickCirclePendants: function ( attribute, className, otherCaseBtn, otherCaseBtn2, editableDivs, e ) {
           

            for ( let editableDiv of editableDivs ) {
                const parentElement = editableDiv.closest('.div-and-counter-wrapper');
                const charCounter = parentElement.querySelector('.input-counter');
                const maxSpan = parentElement.querySelector('.input-max-count');

                // reset div to no text
                editableDiv.innerText = '';
                // update counter & fabric canvas text

                // issue here
                // personalizeDrawerManager.updateCharCount(editableDiv, editableDivs, charCounter, true)
                
                // get the new max length
                maxLength = parseInt(editableDiv.getAttribute(attribute), 10);
                // remove all case related class names
                editableDiv.classList.remove('uppercase');
                editableDiv.classList.remove('mixed');
                editableDiv.classList.remove('lowercase');
                // add the correct class name
                editableDiv.classList.add(className);
                // toggle the buttons
                personalizeDrawerManager.handleCaseToggle(e.currentTarget, otherCaseBtn, otherCaseBtn2);
                // update the UI with the new max length
                if ( maxSpan != null ) {
                    maxSpan.textContent = maxLength; 
                    
                    try {
                        const updatedLimitText = `${maxLength} ${personalizeDrawerManager.characterCountStarterLabel}`;
                        const maxSpanWrapper = maxSpan.closest('.input-counter');
                        const limitTextEl = maxSpanWrapper.querySelector('.empty-div-text');
                        limitTextEl.innerHTML = updatedLimitText;
                    } catch ( error ) {
                        console.warn( error );
                    }
                }
            }
        },
        // click event for case buttons
        handleCaseButtonClick: function( editableDiv, attribute, className, otherCaseBtn, otherCaseBtn2, maxSpan, editableDivs, charCounter, e) {
            // reset div to no text
            editableDiv.innerText = '';
            // update counter & fabric canvas text
            personalizeDrawerManager.updateCharCount(editableDiv, editableDivs, charCounter, true , null )
            // get the new max length
            maxLength = parseInt(editableDiv.getAttribute(attribute), 10);
            // remove all case related class names
            editableDiv.classList.remove('uppercase');
            editableDiv.classList.remove('mixed');
            editableDiv.classList.remove('lowercase');
            // add the correct class name
            editableDiv.classList.add(className);
            // toggle the buttons
            personalizeDrawerManager.handleCaseToggle(e.currentTarget, otherCaseBtn, otherCaseBtn2);
            // update the UI with the new max length
            if ( maxSpan != null ) {
                maxSpan.textContent = maxLength; 
                
                try {
                    const updatedLimitText = `${maxLength} ${personalizeDrawerManager.characterCountStarterLabel}`;
                    const maxSpanWrapper = maxSpan.closest('.input-counter');
                    const limitTextEl = maxSpanWrapper.querySelector('.empty-div-text');
                    limitTextEl.innerHTML = updatedLimitText;
                } catch ( error ) {
                    console.warn( error );
                }
            }
        },
        // get the font class name from the div classlist
        fetchCurrentCase: function ( editableDiv ) {
            let response = 'mixed';
            let classes = editableDiv.classList;
            if ( classes.contains('lowercase') ) {
                response = 'lowercase'
            } else if ( classes.contains('uppercase') ) {
                response = 'uppercase'
            }

            return response
        },
        // get the max length from the matching data attribute on the div
        fetchCurrentMaxLength: function ( editableDiv, currentCase ) {
            let response = 0;
            let maxLength = editableDiv.getAttribute(`data-${currentCase}-max`)
            if ( maxLength != null ) {
                response = maxLength
            }

            return response
        }, 
        // paste event handler
        handlePaste: function ( editableDiv, editableDivs, charCounter, e ) {
            e.preventDefault();
            // html handles images
            const html = (e.clipboardData || window.clipboardData).getData("text/html");
            const text = (e.clipboardData || window.clipboardData).getData("text/plain");
            const container = document.createElement("div");
            container.innerHTML = html || text;

            const fragments = document.createDocumentFragment();
            let totalCount = personalizeDrawerManager.updateCharCount(editableDiv, editableDivs, charCounter, false, null);

            // recheck the maxlength, it could have changed
            let currentcase = personalizeDrawerManager.fetchCurrentCase( editableDiv );
            let currentMaxLength = personalizeDrawerManager.fetchCurrentMaxLength( editableDiv, currentcase);

            const currentFontFamily = editableDiv.getAttribute("data-font-family") || null;


            // split the data into nodes so we can run validation on the characters and images
            const walker = document.createTreeWalker(container, NodeFilter.SHOW_ALL, null, false);
            while (walker.nextNode()) {
                const node = walker.currentNode;
                let count = 0;

                if (node.nodeType === Node.TEXT_NODE) {
                    const text = node.textContent;
                    let filtered = [];
                    for (const ch of text) {
                        if (personalizeDrawerManager.isValidCharacter(ch) || personalizeDrawerManager.isValidSpecialCharacter(currentFontFamily, ch) ) {
                            const chCount = personalizeDrawerManager.characterCounts[ch] || 1;
                            if (totalCount + count + chCount > currentMaxLength) {
                                break
                            }

                            const span = document.createElement("span");
                            span.setAttribute( 'data-symbol-char' , ch );
                            span.setAttribute( "data-char-count", chCount );
                            span.setAttribute( "contenteditable", "false" );
                            span.innerHTML = ch;                       

                            filtered.push( span );
                            count += chCount;
                        }
                    }

                    if ( filtered.length > 0 ) {
                        for ( let f = 0; f < filtered.length; f++ ) {
                            fragments.appendChild( filtered[f] );
                        }
                        totalCount += count;
                    }
                } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'IMG') {
                    const src = node.getAttribute("src") || "";
                    if (personalizeDrawerManager.characterCounts.hasOwnProperty(src)) {
                        const imgCount = personalizeDrawerManager.characterCounts[src] || parseInt(node.getAttribute("data-char-count") || "1", 10);
                        if (totalCount + imgCount <= currentMaxLength) {
                            node.setAttribute("data-char-count", imgCount);
                            fragments.appendChild(node.cloneNode(true));
                            totalCount += imgCount;
                        }
                    }
                }
            }

            const sel = window.getSelection();
            if (!sel.rangeCount) return;
            const range = sel.getRangeAt(0);
            range.deleteContents();
            range.insertNode(fragments);
            sel.collapseToEnd();

            personalizeDrawerManager.updateCharCount(editableDiv, editableDivs, charCounter, true, null);
        },
        normalizeHearts: function ( str ) {
            if ( typeof str !== 'string' || str.length <= 0 ) {
                return str;
            }
            
            const TEXT_HEART = '\u2764\uFE0E';
            const SUIT_HEART = '\u2665\uFE0E';
            return str
                .replace(/\u2764(?:\uFE0F|\uFE0E)?\u200D[\u{1F300}-\u{1FAFF}]/gu, TEXT_HEART)
                .replace(/\u2665(?:\uFE0F|\uFE0E)?\u200D[\u{1F300}-\u{1FAFF}]/gu, SUIT_HEART)
                .replace(/\u2764(?:\uFE0F|\uFE0E)?/g, TEXT_HEART)
                .replace(/\u2665(?:\uFE0F|\uFE0E)?/g, SUIT_HEART);
        },
        // sets the max limit on the div
        handleBeforeInput: function ( editableDiv, editableDivs, charCounter, e ) {
            const currentCount = personalizeDrawerManager.updateCharCount(editableDiv, editableDivs, charCounter, false, null);
            const inputType = e.inputType;
            const data = e.data || "";

            // block enter 
            if ( e.inputType === 'insertParagraph' || e.inputType === 'insertLineBreak' ) {
                e.preventDefault();
                e.stopPropagation(); 
            }

            // Allow deletions
            if (inputType.startsWith("delete")) {
                setTimeout(() => {
                    // refresh canvas when we delete a char
                    personalizeDrawerManager.updateCharCount( editableDiv, editableDivs, charCounter, true, null );
                }, 0)
                return
            }

            const currentFontFamily = editableDiv.getAttribute("data-font-family") || null;


            // calculate character addition (only count valid characters)
            let toAdd = 0;
            for (const ch of data) {
                if (personalizeDrawerManager.isValidCharacter(ch) || personalizeDrawerManager.isValidSpecialCharacter(currentFontFamily, ch) ) {
                    toAdd += personalizeDrawerManager.characterCounts[ch] || 1;
                } else {
                    e.preventDefault();
                    return;
                }
            }

            // don't do anything if the count exceeds the max length
            const currentCase = personalizeDrawerManager.fetchCurrentCase( editableDiv );
            const currentMaxLength = personalizeDrawerManager.fetchCurrentMaxLength( editableDiv , currentCase );

            if ( currentCount + toAdd > currentMaxLength ) {
                e.preventDefault();
            }

             if (e.inputType === 'insertText' && e.data) {
                e.preventDefault(); 

                let typedChar = personalizeDrawerManager.normalizeHearts(e.data);

                const currentCase = personalizeDrawerManager.fetchCurrentCase( editableDiv );
                const maxLength = personalizeDrawerManager.fetchCurrentMaxLength( editableDiv, currentCase );
                personalizeDrawerManager.insertElementAtCursor( 'span', null, typedChar, null, 1, maxLength, editableDiv, charCounter, editableDivs );
            }
        },
        getGemstoneCountFromNodes: function ( container ) {
            // split the data into nodes so we can get an accurate count
            let count = 0;
            const walker = document.createTreeWalker(container, NodeFilter.SHOW_ALL, null, false);

            while (walker.nextNode()) {
                const node = walker.currentNode;
                if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'IMG') {
                    const imageType = node.getAttribute("data-symbol-type");
                    if ( imageType != null && imageType == 'gemstone' ) {
                        count++
                    }
                }
            }

            return count;
        },
        // count the existing characters and images in the div
        getCharacterCountFromNodes: function ( container, div ) {
            // split the data into nodes so we can get an accurate count
            let count = 0;
            const walker = document.createTreeWalker(container, NodeFilter.SHOW_ALL, null, false);

            const currentFontFamily = div.getAttribute('data-font-family') || null; 

            while (walker.nextNode()) {
                const node = walker.currentNode;
                if (node.nodeType === Node.TEXT_NODE) {
                    const text = node.textContent;
                    for (const char of text) {
                        // validate character
                        if ( personalizeDrawerManager.isValidCharacter(char) || personalizeDrawerManager.isValidSpecialCharacter(currentFontFamily, char) ) {
                            count += personalizeDrawerManager.characterCounts[char] || 1;
                        }
                    }
                } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'IMG') {
                    const src = node.getAttribute("src") || "";
                    
                    // validate image
                    if (personalizeDrawerManager.characterCounts.hasOwnProperty(src)) {
                        const charCount = personalizeDrawerManager.characterCounts[src] || parseInt(node.getAttribute("data-char-count") || "1", 10);
                        count += charCount;
                    } else {
                        const charCount = parseInt(node.getAttribute('data-char-count'));
                        count += charCount
                    }
                }
            }

            return count;
        },
        // update the UI count and fabric canvas
        updateCharCount: function ( editableDiv, editableDivs, charCounter, reload = true, gemstoneContainer = null ) {
            
            let countResults = 0;
            if ( editableDiv != null && charCounter != null ) {
                const temp = editableDiv.cloneNode(true);
                const count = personalizeDrawerManager.getCharacterCountFromNodes(temp, editableDiv);
                countResults = count;
                const charCountDisplay = charCounter.querySelector('.input-count');
                const emptyDivText = charCounter.querySelector('.empty-div-text');
                const hasContentText = charCounter.querySelector('.has-content-text');

                if ( charCountDisplay != null ){
                    charCountDisplay.textContent = count;
                }

                if ( emptyDivText != null && hasContentText != null ) {
                    if ( count == 0 ) {
                        if ( emptyDivText.classList.contains('hidden') ) {
                            emptyDivText.classList.remove('hidden')
                        }
                        if ( !hasContentText.classList.contains('hidden') ) {
                            hasContentText.classList.add('hidden')
                        }
                    } else {
                        if ( !emptyDivText.classList.contains('hidden') ) {
                            emptyDivText.classList.add('hidden')
                        }
                        if ( hasContentText.classList.contains('hidden') ) {
                            hasContentText.classList.remove('hidden')
                        }
                    }
                }

                let divId = editableDiv.getAttribute('id');
                let canvasKey = editableDiv.getAttribute('data-canvas')
                let fields = divId.split('-')
                let side = fields[1];
                let index = fields[fields.length - 1]
                let fieldMapKey = `${side}-${index}`;

                if ( reload ) {
                    setTimeout(() => {
                        personalizeDrawerManager.updateFabricCanvas(editableDivs, canvasKey);
                    } , 0 );
                }
            } else if ( gemstoneContainer != null ) {
                const inputOption = gemstoneContainer.querySelector( '[data-canvas]' );
                if ( inputOption != null ) {
                    const canvasKey = inputOption.getAttribute('data-canvas')
                    if ( reload ) {
                        setTimeout(() => {
                            personalizeDrawerManager.updateFabricCanvas(editableDivs, canvasKey);
                        } , 0 );
                    }
                }
            }

            personalizeDrawerManager.validateFormAndReturnFormData();

            return countResults;
        },   
        // updates the class name of the case buttons for style changes on the UI
        handleCaseToggle: function ( caseBtnToSetActive, caseBtnToRemoveActive, otherCaseBtnToRemoveActive ) {
            // handle button toggles
            if ( caseBtnToSetActive != null && !caseBtnToSetActive.classList.contains('enabled-box') ) {
                caseBtnToSetActive.classList.add('enabled-box')
            }

            if ( caseBtnToRemoveActive != null && caseBtnToRemoveActive.classList.contains('enabled-box') ) {
                caseBtnToRemoveActive.classList.remove('enabled-box')
            }

            if ( otherCaseBtnToRemoveActive != null && otherCaseBtnToRemoveActive.classList.contains('enabled-box') ) {
                otherCaseBtnToRemoveActive.classList.remove('enabled-box')
            }
        },
        isValidSpecialCharacter: function ( fontFamily, ch ) {
            if ( personalizeDrawerManager.debug ) {
                console.log('Checking', fontFamily, 'metaobject data for special', ch )
            }
            if ( fontFamily != null ) {
                const fontStructure = personalizeDrawerManager.fontSizing[fontFamily] || null;
                if ( fontStructure != null ) {
                    let specialCharacters = fontStructure?.whitelist_characters || null;

                    if ( specialCharacters != null ) {
                        return specialCharacters.indexOf(ch) > -1
                    }
                }
            }
            return false
        },
        // checks if character is on the whitelist or in characterCounts
        isValidCharacter: function ( char ) {
            return personalizeDrawerManager.whiteListCharacters.indexOf(char) > -1 || personalizeDrawerManager.whiteListNumbers.indexOf(char) > -1 || personalizeDrawerManager.characterCounts.hasOwnProperty(char);
        },
        preloadAllFonts: async function( currentColor ) {
            // read the JSON file and look for a text field on either the front or back side of the object
            const drawer = document.querySelector( '.personalize-drawer' )
            if ( drawer == null ) {
                console.warn( '[Personalization Drawer Manager] Failed to preload fonts! The drawer was not defined!' );
                return;
            }
            
            let personalizationData = null;

            const urlParams = new URLSearchParams( window.location.search );
            const usingVersion = urlParams.has( 'version' );
            if ( usingVersion ) {
                const version = urlParams.get('version');
                try {
                    const handle = drawer.getAttribute('data-product-handle');
                    const url = `https://tinytags-staging.txtcon.io/server/public/products/${handle}/personalization/${version}`

                    const apiResponse = await fetch( url, { method: 'POST' } );
                    const personalizationJSONFromServer = await apiResponse.json();
                    personalizationData = personalizationJSONFromServer;
                } catch (error) {
                    console.error( error );
                    console.warn( '[Personalization Drawer Manager] Failed to preload fonts! The personalization data from the server was not retireved' );
                }
            } else {
                const productId = drawer.getAttribute( 'data-product-id' );
                const scriptTag = document.querySelector( `#product-${productId}-personalization-data` );

                if ( scriptTag == null ) {
                    console.warn( '[Personalization Drawer Manager] Failed to preload fonts! The personalization data was missing!' );
                    return;
                }

                personalizationData = JSON.parse( scriptTag.innerText );
            }

            if ( personalizationData == null ) {
                console.warn( '[Personalization Drawer Manager] Failed to preload fonts! The personalization data was missing!' );
                return;
            }

            if ( currentColor === null ) {
                const personalizationFormInnerWrapper = document.querySelector('personalization-form .inner-wrapper');
                if ( personalizationFormInnerWrapper != null ) {
                    currentColor = personalizationFormInnerWrapper.getAttribute( 'data-current-color' );
                }
            }

            const frontDataPtr = personalizationData["front"][ currentColor ];
            const backDataPtr = personalizationData["back"][ currentColor ];
            
            for ( let i = 0; i < frontDataPtr.length; i++ ) {
                const fontOptionsPtr = frontDataPtr[i]?.["field_options"]?.["font_settings"]?.["options"]?.["font"]?.["options"];
                if ( fontOptionsPtr ) {
                    for ( let j = 0; j < fontOptionsPtr.length; j++ ) {
                        const fontOptionValue = fontOptionsPtr[j];
                        const fontName = fontOptionValue.linked_font_data.font_name;
                        const fontStyle = fontOptionValue.linked_font_data.font_style;
                        const fontWeight = fontOptionValue.linked_font_data.font_weight;
                        const fontFiles = fontOptionValue.linked_font_data.files;

                        for ( let f = 0; f < fontFiles.length; f++ ) {
                            const fontFileUrl = fontFiles[f].shopify_cdn_url;
                            try {
                                const fontFaceUrl = `url(${fontFileUrl})`;
                                const fontProps = {
                                    style: fontStyle,
                                    weight: fontWeight
                                };
                                const currentFontFace = new FontFace( fontName, fontFaceUrl, fontProps );

                                await currentFontFace.load();
                                document.fonts.add(currentFontFace);
                                if ( personalizeDrawerManager.debug ) {
                                    console.log( `[Personalization Drawer Manager] Loaded font: ${fontName} from ${fontFileUrl}`);
                                }
                            } catch (e) {
                                console.warn( `[Personalization Drawer Manager]Failed to load font: ${fontName}`, e );
                            }
                        }
                    }
                }
            }

            for ( let i = 0; i < backDataPtr.length; i++ ) {
                const backOptionsPtr = backDataPtr[i]?.["field_options"]?.["font_settings"]?.["options"]?.["font"]?.["options"];
                if ( backOptionsPtr ) {
                    for ( let j = 0; j < backOptionsPtr.length; j++ ) {
                        const fontOptionValue = backOptionsPtr[j];
                        const fontName = fontOptionValue.linked_font_data.font_name;
                        const fontStyle = fontOptionValue.linked_font_data.font_style;
                        const fontWeight = fontOptionValue.linked_font_data.font_weight;
                        const fontFiles = fontOptionValue.linked_font_data.files;
                        for ( let f = 0; f < fontFiles.length; f++ ) {
                            const fontFileUrl = fontFiles[f].shopify_cdn_url;
                            try {
                                const fontFaceUrl = `url(${fontFileUrl})`;
                                const fontProps = {
                                    style: fontStyle,
                                    weight: fontWeight
                                };
                                const currentFontFace = new FontFace( fontName, fontFaceUrl, fontProps );

                                await currentFontFace.load();
                                document.fonts.add(currentFontFace);
                                if ( personalizeDrawerManager.debug ) {
                                    console.log( `[Personalization Drawer Manager] Loaded font: ${fontName} from ${fontFileUrl}`);
                                }
                            } catch (e) {
                                console.warn( `[Personalization Drawer Manager]Failed to load font: ${fontName}`, e );
                            }
                        }
                    }
                }
            }

            return;
        },
        // Normalize an existing 600×600 canvas down to theme setting for size
        downscaleCanvasToNewSize: function ( canvas ) {
            const originalSize = 600; 
            const newSize = personalizeDrawerManager.canvasSize;
            const newScale = newSize / originalSize; 

            // Scale background image if present
            const backgroundImage = canvas.backgroundImage;
            if ( backgroundImage ) {
                backgroundImage.set({
                    left: (backgroundImage.left || 0) * newScale,
                    top: (backgroundImage.top || 0) * newScale,
                    scaleX: (backgroundImage.scaleX || 1) * newScale,
                    scaleY: (backgroundImage.scaleY || 1) * newScale,
                });
            }

            // Scale all objects
            canvas.getObjects().forEach(obj => {
                obj.set({
                    left: obj.left * newScale,
                    top: obj.top * newScale,
                    scaleX: obj.scaleX * newScale,
                    scaleY: obj.scaleY * newScale
                });

                // Text-specific tweaks
                if (obj.type === 'textbox' || obj.type === 'i-text' || obj.type === 'text') {
                    if (typeof obj.fontSize === 'number') {
                        obj.set({ fontSize: obj.fontSize * newScale });
                    }
                    if (typeof obj.charSpacing === 'number') {
                        obj.set({ charSpacing: obj.charSpacing * newScale });
                    }
                    if (typeof obj.lineHeight === 'number') {
                        obj.set({ lineHeight: obj.lineHeight * newScale });
                    }
                }

                // Optional: scale stroke widths if you use them
                if (typeof obj.strokeWidth === 'number') {
                    obj.set({ strokeWidth: obj.strokeWidth * newScale });
                }

                obj.setCoords();
            });

            // Finally set canvas size to the new size
            canvas.setWidth(newSize);
            canvas.setHeight(newSize);
            canvas.requestRenderAll();
        },
        // Make canvases responsive (keep logical size the theme setting, zoom for display)
        updateCSSVariables: function () {
            const baseSize = personalizeDrawerManager.canvasSize
            const viewportWidth = Math.min(window.innerWidth, document.documentElement.clientWidth || window.innerWidth);
            const needsSmall = viewportWidth < 450;
            const targetPx = needsSmall ? Math.floor(viewportWidth * 0.95) : baseSize;

            document.documentElement.style.cssText = `--dynamic-image-size: ${targetPx}px; --dynamic-bundle-3-offset: ${targetPx / 3}px; --dynamic-bundle-2-offset: ${targetPx / 6}px`;
        },
        watchForOutsideClick: function( e ) {
            const drawer = document.querySelector( 'personalize-drawer' );
            if ( drawer != null ) {
                drawer.close();
            }

            return;
        },
        canvasDoneLoading: function( ) {
            for ( const [key, value] of Object.entries(personalizeDrawerManager.fabricMap) ) {
                if ( value?.canvas ) {
                    personalizeDrawerManager.downscaleCanvasToNewSize(value.canvas)
                }
            }

            personalizeDrawerManager.updateCSSVariables();
        },
        scaleImageToFitCanvas: function( image, maxWidth, maxHeight ) {
            const { width, height } = image;
            if ( width > maxWidth || height > maxHeight ) {
                const widthRatio = maxWidth / width;
                const heightRatio = maxHeight / height;
                const scale = Math.min( widthRatio, heightRatio );
                image.scale( scale );
            } else {
                image.scale(1);
            }

            return;
        },
        createSkuProperty: function( lineItem , baseSku ) {
            let finalSku = baseSku;

            try {
                const alignmentKey = 'alignment';
                const caseKey = 'case';
                const frontKey = 'front';
                const backKey = 'back';

                const lookupValuesForFrontAlignmentSkus = personalizeDrawerManager.skuCodes[frontKey][alignmentKey];
                const lookupValuesForBackAlignmentSkus = personalizeDrawerManager.skuCodes[backKey][alignmentKey];
                const lookupValuesForFrontCaseSkus = personalizeDrawerManager.skuCodes[frontKey][caseKey];
                const lookupValuesForBackCaseSkus = personalizeDrawerManager.skuCodes[backKey][caseKey];

                const baseSkuValue = personalizeDrawerManager.skuCodes[backKey]["base"];

                const querySelectorForAllFrontCases = `[data-option="${frontKey}"] .case-container .text-case-align.enabled-box`;
                const querySelectorForAllFrontAlignments = `[data-option="${frontKey}"] .alignment-container .alignment-button.enabled-box`;

                const querySelectorForAllBackCases = `[data-option="${backKey}"] .case-container .text-case-align.enabled-box`;
                const querySelectorForAllBackAlignments = `[data-option="${backKey}"] .alignment-container .alignment-button.enabled-box`;

                const frontCasesSelected = document.querySelectorAll( querySelectorForAllFrontCases );
                const frontAlignmentsSelected = document.querySelectorAll( querySelectorForAllFrontAlignments );

                const backCasesSelected = document.querySelectorAll( querySelectorForAllBackCases );
                const backAlignmentsSelected = document.querySelectorAll( querySelectorForAllBackAlignments );

                const drawerEl = document.querySelector('personalize-drawer');
                let allBackInputs = [];
                if ( drawerEl != null ) {
                    allBackInputs = drawerEl.querySelectorAll(`.input-field[data-position="${backKey}"]`);
                }

                // if the wrapper div above has 2 or more nodes, we want to add
                // if the wrapper div above has 1 node or 0 nodes, we dont want to add

                for ( let i = 0; i < frontCasesSelected.length; i++ ) {
                    const parentNode = frontCasesSelected[i].closest( '.case-container' );
                    let numberOfChildElements = 0;
                    if ( parentNode != null ) {
                        numberOfChildElements = parentNode.childElementCount;
                    }

                    if ( numberOfChildElements <= 1 ) {
                        continue;
                    }

                    const caseSelected = frontCasesSelected[i].getAttribute( 'data-case' );
                    const caseSkuToAdd = lookupValuesForFrontCaseSkus[ caseSelected ];

                    if ( caseSkuToAdd ) {
                        finalSku += `${caseSkuToAdd}`;
                    }
                }

                for ( let i = 0; i < frontAlignmentsSelected.length; i++ ) {
                    const parentNode = frontAlignmentsSelected[i].closest( '.alignment-container' );
                    let numberOfChildElements = 0;
                    if ( parentNode != null ) {
                        numberOfChildElements = parentNode.childElementCount;
                    }

                    if ( numberOfChildElements <= 1 ) {
                        continue;
                    }

                    const alignSelected = frontAlignmentsSelected[i].getAttribute( 'data-align-name' );
                    const alignSkuToadd = lookupValuesForFrontAlignmentSkus[ alignSelected ];

                    if ( alignSkuToadd ) {
                        finalSku += `${alignSkuToadd}`;
                    }
                }

                for ( let i = 0; i < allBackInputs.length; i++ ) {
                    if ( allBackInputs[i].childNodes.length > 0 ) {
                        if ( baseSkuValue ) {
                            finalSku += `${baseSkuValue}`;
                        }
                        
                        break;
                    }
                    
                }

                // before we add back alignment / cases, check if a back engraving has at least 1 char for the related input field
                // we also need to do the same node validation
                for ( let i = 0; i < backCasesSelected.length; i++ ) {
                    const wrapperOfFields = backCasesSelected[i].closest( '.text-field-and-option-wrapper' );
                    if ( wrapperOfFields != null ) {
                        const inputField = wrapperOfFields.querySelector( '.input-field' );
                        if ( inputField != null ) {
                            if ( inputField.childNodes.length <= 0 ) {
                                continue;
                            }
                        }
                    }

                    const parentNode = backCasesSelected[i].closest( '.case-container' );
                    let numberOfChildElements = 0;
                    if ( parentNode != null ) {
                        numberOfChildElements = parentNode.childElementCount;
                    }   

                    if ( numberOfChildElements <= 1 ) {
                        continue;
                    }

                    const caseSelected = backCasesSelected[i].getAttribute( 'data-case' );
                    const caseSkuToAdd = lookupValuesForBackCaseSkus[ caseSelected ];

                    if ( caseSkuToAdd ) {
                        finalSku += `${caseSkuToAdd}`;
                    }
                }

                for ( let i = 0; i < backAlignmentsSelected.length; i++ ) {
                    const wrapperOfFields = backAlignmentsSelected[i].closest( '.text-field-and-option-wrapper' );
                    if ( wrapperOfFields != null ) {
                        const inputField = wrapperOfFields.querySelector( '.input-field' );
                        if ( inputField != null ) {
                            if ( inputField.childNodes.length <= 0 ) {
                                continue;
                            }
                        }
                    }

                    const parentNode = backAlignmentsSelected[i].closest( '.alignment-container' );
                    let numberOfChildElements = 0;
                    if ( parentNode != null ) {
                        numberOfChildElements = parentNode.childElementCount;
                    }

                    if ( numberOfChildElements <= 1 ) {
                        continue;
                    }

                    const alignSelected = backAlignmentsSelected[i].getAttribute( 'data-align-name' );
                    const alignSkuToAdd = lookupValuesForBackAlignmentSkus[ alignSelected ];

                    if ( alignSkuToAdd ) {
                        finalSku += `${alignSkuToAdd}`;
                    }
                }
            } catch ( error ) {
                console.warn( 'An error occurred when trying to build the product sku property. Base sku sent back as final property.' , error );
            }

            lineItem.properties['_sku'] = finalSku;
            
            if ( personalizeDrawerManager.debug ) {
                console.log( finalSku );
            }

            return;
        }
    }

    window.personalizationManagers = window.personalizationManagers || {};
    window.personalizationManagers.latest = personalizeDrawerManager;
    window.personalizeDrawerManager = personalizeDrawerManager

    const personalizeDrawer = document.querySelector('personalize-drawer');
    if ( personalizeDrawer != null ) {
        personalizeDrawerManager.init()
    }

    window.addEventListener('resize', personalizeDrawerManager.updateCSSVariables)
    
    const overlay = document.querySelector( '#personalization-overlay' );
    if ( overlay != null ) {
        overlay.addEventListener('click' , personalizeDrawerManager.watchForOutsideClick );
    }
})
})();
